// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AddonAccessUpdateData,
  AddonAccessUpdateErrors,
  AddonAccessUpdateResponses,
  AddonChartSourceData,
  AddonChartSourceErrors,
  AddonChartSourceResponses,
  AddonConfigDeleteData,
  AddonConfigDeleteErrors,
  AddonConfigDeleteResponses,
  AddonConfigEntryDeleteData,
  AddonConfigEntryDeleteErrors,
  AddonConfigEntryDeleteResponses,
  AddonConfigEntryUpdateData,
  AddonConfigEntryUpdateErrors,
  AddonConfigEntryUpdateResponses,
  AddonConfigListData,
  AddonConfigListErrors,
  AddonConfigListResponses,
  AddonConfigUpdateData,
  AddonConfigUpdateErrors,
  AddonConfigUpdateResponses,
  AddonDetailData,
  AddonDetailErrors,
  AddonDetailResponses,
  AddonEnvironmentData,
  AddonEnvironmentErrors,
  AddonEnvironmentResponses,
  AddonInstallData,
  AddonInstallErrors,
  AddonInstallResponses,
  AddonListData,
  AddonListErrors,
  AddonListResponses,
  AddonRepairData,
  AddonRepairErrors,
  AddonRepairResponses,
  AddonStoreConfigEntryDeleteData,
  AddonStoreConfigEntryDeleteErrors,
  AddonStoreConfigEntryDeleteResponses,
  AddonStoreConfigEntryUpdateData,
  AddonStoreConfigEntryUpdateErrors,
  AddonStoreConfigEntryUpdateResponses,
  AddonStoreConfigListData,
  AddonStoreConfigListErrors,
  AddonStoreConfigListResponses,
  AddonStoreConfigUpdateData,
  AddonStoreConfigUpdateErrors,
  AddonStoreConfigUpdateResponses,
  AddonUninstallData,
  AddonUninstallErrors,
  AddonUninstallResponses,
  AgentVersionsData,
  AgentVersionsErrors,
  AgentVersionsResponses,
  AllowListInspectData,
  AllowListInspectErrors,
  AllowListInspectResponses,
  AllowListUpdateData,
  AllowListUpdateErrors,
  AllowListUpdateResponses,
  AuthenticateUserData,
  AuthenticateUserErrors,
  AuthenticateUserResponses,
  AuthLogsCsvData,
  AuthLogsCsvErrors,
  AuthLogsCsvResponses,
  AuthLogsListData,
  AuthLogsListErrors,
  AuthLogsListResponses,
  AutoUpdateListData,
  AutoUpdateListErrors,
  AutoUpdateListResponses,
  AzureBlobBackupSettingsFetchData,
  AzureBlobBackupSettingsFetchErrors,
  AzureBlobBackupSettingsFetchResponses,
  AzureBlobBackupStatusFetchData,
  AzureBlobBackupStatusFetchErrors,
  AzureBlobBackupStatusFetchResponses,
  AzureBlobTestConnectionData,
  AzureBlobTestConnectionErrors,
  AzureBlobTestConnectionResponses,
  BackupData,
  BackupErrors,
  BackupResponses,
  BackupSettingsFetchData,
  BackupSettingsFetchErrors,
  BackupSettingsFetchResponses,
  BackupStatusFetchData,
  BackupStatusFetchErrors,
  BackupStatusFetchResponses,
  BackupToAzureBlobData,
  BackupToAzureBlobErrors,
  BackupToAzureBlobResponses,
  BackupToS3Data,
  BackupToS3Errors,
  BackupToS3Responses,
  CloudCredsDeleteData,
  CloudCredsDeleteErrors,
  CloudCredsDeleteResponses,
  CloudCredsGetByIdData,
  CloudCredsGetByIdErrors,
  CloudCredsGetByIdResponses,
  CloudCredsUpdateData,
  CloudCredsUpdateErrors,
  CloudCredsUpdateResponses,
  ContainerImageStatusData,
  ContainerImageStatusErrors,
  ContainerImageStatusResponses,
  ContainersImageStatusClearData,
  ContainersImageStatusClearErrors,
  ContainersImageStatusClearResponses,
  CreateAlertRuleData,
  CreateAlertRuleErrors,
  CreateAlertRuleResponses,
  CreateData,
  CreateErrors,
  CreateKubernetesConfigMapData,
  CreateKubernetesConfigMapErrors,
  CreateKubernetesConfigMapResponses,
  CreateKubernetesDeploymentData,
  CreateKubernetesDeploymentErrors,
  CreateKubernetesDeploymentResponses,
  CreateKubernetesIngressData,
  CreateKubernetesIngressErrors,
  CreateKubernetesIngressResponses,
  CreateKubernetesNamespaceData,
  CreateKubernetesNamespaceErrors,
  CreateKubernetesNamespaceResponses,
  CreateKubernetesPersistentVolumeClaimData,
  CreateKubernetesPersistentVolumeClaimErrors,
  CreateKubernetesPersistentVolumeClaimResponses,
  CreateKubernetesSecretData,
  CreateKubernetesSecretErrors,
  CreateKubernetesSecretResponses,
  CreateKubernetesServiceData,
  CreateKubernetesServiceErrors,
  CreateKubernetesServiceResponses,
  CreateResponses,
  CreateSilenceData,
  CreateSilenceErrors,
  CreateSilenceResponses,
  CurrentUserEndpointAuthorizationsInspectData,
  CurrentUserEndpointAuthorizationsInspectErrors,
  CurrentUserEndpointAuthorizationsInspectResponses,
  CurrentUserEndpointNamespaceAuthorizationsInspectData,
  CurrentUserEndpointNamespaceAuthorizationsInspectErrors,
  CurrentUserEndpointNamespaceAuthorizationsInspectResponses,
  CurrentUserInspectData,
  CurrentUserInspectErrors,
  CurrentUserInspectResponses,
  CustomTemplateCreateFileData,
  CustomTemplateCreateFileErrors,
  CustomTemplateCreateFileResponses,
  CustomTemplateCreateRepositoryData,
  CustomTemplateCreateRepositoryErrors,
  CustomTemplateCreateRepositoryResponses,
  CustomTemplateCreateStringData,
  CustomTemplateCreateStringErrors,
  CustomTemplateCreateStringResponses,
  CustomTemplateDeleteData,
  CustomTemplateDeleteErrors,
  CustomTemplateDeleteResponses,
  CustomTemplateFileData,
  CustomTemplateFileErrors,
  CustomTemplateFileResponses,
  CustomTemplateGitFetchData,
  CustomTemplateGitFetchErrors,
  CustomTemplateGitFetchResponses,
  CustomTemplateInspectData,
  CustomTemplateInspectErrors,
  CustomTemplateInspectResponses,
  CustomTemplateListData,
  CustomTemplateListErrors,
  CustomTemplateListResponses,
  CustomTemplateUpdateData,
  CustomTemplateUpdateErrors,
  CustomTemplateUpdateResponses,
  DefaultRegistryUpdateData,
  DefaultRegistryUpdateErrors,
  DefaultRegistryUpdateResponses,
  DeleteAlertRuleData,
  DeleteAlertRuleErrors,
  DeleteAlertRuleResponses,
  DeleteClusterRoleBindingsData,
  DeleteClusterRoleBindingsErrors,
  DeleteClusterRoleBindingsResponses,
  DeleteClusterRolesData,
  DeleteClusterRolesErrors,
  DeleteClusterRolesResponses,
  DeleteCronJobsData,
  DeleteCronJobsErrors,
  DeleteCronJobsResponses,
  DeleteJobsData,
  DeleteJobsErrors,
  DeleteJobsResponses,
  DeleteKubernetesClusterScopedCustomResourceData,
  DeleteKubernetesClusterScopedCustomResourceErrors,
  DeleteKubernetesClusterScopedCustomResourceResponses,
  DeleteKubernetesConfigMapData,
  DeleteKubernetesConfigMapErrors,
  DeleteKubernetesConfigMapResponses,
  DeleteKubernetesCustomResourceDefinitionData,
  DeleteKubernetesCustomResourceDefinitionErrors,
  DeleteKubernetesCustomResourceDefinitionResponses,
  DeleteKubernetesDeploymentData,
  DeleteKubernetesDeploymentErrors,
  DeleteKubernetesDeploymentResponses,
  DeleteKubernetesIngressesData,
  DeleteKubernetesIngressesErrors,
  DeleteKubernetesIngressesResponses,
  DeleteKubernetesNamespaceData,
  DeleteKubernetesNamespacedCustomResourceData,
  DeleteKubernetesNamespacedCustomResourceErrors,
  DeleteKubernetesNamespacedCustomResourceResponses,
  DeleteKubernetesNamespaceErrors,
  DeleteKubernetesNamespaceResponses,
  DeleteKubernetesPersistentVolumeClaimsData,
  DeleteKubernetesPersistentVolumeClaimsErrors,
  DeleteKubernetesPersistentVolumeClaimsResponses,
  DeleteKubernetesPersistentVolumesData,
  DeleteKubernetesPersistentVolumesErrors,
  DeleteKubernetesPersistentVolumesResponses,
  DeleteKubernetesPodData,
  DeleteKubernetesPodErrors,
  DeleteKubernetesPodResponses,
  DeleteKubernetesSecretData,
  DeleteKubernetesSecretErrors,
  DeleteKubernetesSecretResponses,
  DeleteKubernetesServicesData,
  DeleteKubernetesServicesErrors,
  DeleteKubernetesServicesResponses,
  DeleteKubernetesStorageClassesData,
  DeleteKubernetesStorageClassesErrors,
  DeleteKubernetesStorageClassesResponses,
  DeleteRoleBindingsData,
  DeleteRoleBindingsErrors,
  DeleteRoleBindingsResponses,
  DeleteRolesData,
  DeleteRolesErrors,
  DeleteRolesResponses,
  DeleteServiceAccountsData,
  DeleteServiceAccountsErrors,
  DeleteServiceAccountsResponses,
  DeleteSilenceData,
  DeleteSilenceErrors,
  DeleteSilenceResponses,
  DescribeResourceData,
  DescribeResourceErrors,
  DescribeResourceResponses,
  DockerContainerGpusInspectData,
  DockerContainerGpusInspectErrors,
  DockerContainerGpusInspectResponses,
  DockerDashboardData2,
  DockerDashboardErrors,
  DockerDashboardResponses,
  DockerImagesListData,
  DockerImagesListErrors,
  DockerImagesListResponses,
  DrainNodeData,
  DrainNodeErrors,
  DrainNodeResponses,
  DryRunKubernetesManifestsData,
  DryRunKubernetesManifestsErrors,
  DryRunKubernetesManifestsResponses,
  EcrDeleteRepositoryData,
  EcrDeleteRepositoryErrors,
  EcrDeleteRepositoryResponses,
  EcrDeleteTagsData,
  EcrDeleteTagsErrors,
  EcrDeleteTagsResponses,
  EdgeConfigCreateData,
  EdgeConfigCreateErrors,
  EdgeConfigCreateResponses,
  EdgeConfigDeleteData,
  EdgeConfigDeleteErrors,
  EdgeConfigDeleteResponses,
  EdgeConfigFilesData,
  EdgeConfigFilesErrors,
  EdgeConfigFilesResponses,
  EdgeConfigInspectData,
  EdgeConfigInspectErrors,
  EdgeConfigInspectResponses,
  EdgeConfigListData,
  EdgeConfigListErrors,
  EdgeConfigListResponses,
  EdgeConfigStateData,
  EdgeConfigStateErrors,
  EdgeConfigStateResponses,
  EdgeConfigUpdateData,
  EdgeConfigUpdateErrors,
  EdgeConfigUpdateResponses,
  EdgeGroupCreateData,
  EdgeGroupCreateErrors,
  EdgeGroupCreateResponses,
  EdgeGroupDeleteData,
  EdgeGroupDeleteErrors,
  EdgeGroupDeleteResponses,
  EdgeGroupInspectData,
  EdgeGroupInspectErrors,
  EdgeGroupInspectResponses,
  EdgeGroupListData,
  EdgeGroupListErrors,
  EdgeGroupListResponses,
  EdgeGroupUpdateData,
  EdgeGroupUpdateErrors,
  EdgeGroupUpdateResponses,
  EdgeJobCreateFileData,
  EdgeJobCreateFileErrors,
  EdgeJobCreateFileResponses,
  EdgeJobCreateStringData,
  EdgeJobCreateStringErrors,
  EdgeJobCreateStringResponses,
  EdgeJobDeleteData,
  EdgeJobDeleteErrors,
  EdgeJobDeleteResponses,
  EdgeJobFileData,
  EdgeJobFileErrors,
  EdgeJobFileResponses,
  EdgeJobInspectData,
  EdgeJobInspectErrors,
  EdgeJobInspectResponses,
  EdgeJobListData,
  EdgeJobListErrors,
  EdgeJobListResponses,
  EdgeJobTaskLogsInspectData,
  EdgeJobTaskLogsInspectErrors,
  EdgeJobTaskLogsInspectResponses,
  EdgeJobTasksClearData,
  EdgeJobTasksClearErrors,
  EdgeJobTasksClearResponses,
  EdgeJobTasksCollectData,
  EdgeJobTasksCollectErrors,
  EdgeJobTasksCollectResponses,
  EdgeJobTasksListData,
  EdgeJobTasksListErrors,
  EdgeJobTasksListResponses,
  EdgeJobUpdateData,
  EdgeJobUpdateErrors,
  EdgeJobUpdateResponses,
  EdgeStackCreateFileData,
  EdgeStackCreateFileErrors,
  EdgeStackCreateFileResponses,
  EdgeStackCreateHelmRepositoryData,
  EdgeStackCreateHelmRepositoryErrors,
  EdgeStackCreateHelmRepositoryResponses,
  EdgeStackCreateRepositoryData,
  EdgeStackCreateRepositoryErrors,
  EdgeStackCreateRepositoryResponses,
  EdgeStackCreateStringData,
  EdgeStackCreateStringErrors,
  EdgeStackCreateStringResponses,
  EdgeStackDeleteData,
  EdgeStackDeleteErrors,
  EdgeStackDeleteResponses,
  EdgeStackFileData,
  EdgeStackFileErrors,
  EdgeStackFileResponses,
  EdgeStackInspectData,
  EdgeStackInspectErrors,
  EdgeStackInspectResponses,
  EdgeStackListData,
  EdgeStackListErrors,
  EdgeStackListResponses,
  EdgeStackLogsCollectData,
  EdgeStackLogsCollectErrors,
  EdgeStackLogsCollectResponses,
  EdgeStackLogsDeleteData,
  EdgeStackLogsDeleteErrors,
  EdgeStackLogsDeleteResponses,
  EdgeStackLogsDownloadData,
  EdgeStackLogsDownloadErrors,
  EdgeStackLogsDownloadResponses,
  EdgeStackLogsStatusGetData,
  EdgeStackLogsStatusGetErrors,
  EdgeStackLogsStatusGetResponses,
  EdgeStackParseRegistriesData,
  EdgeStackParseRegistriesErrors,
  EdgeStackParseRegistriesResponses,
  EdgeStackStaggerStatusInspectData,
  EdgeStackStaggerStatusInspectErrors,
  EdgeStackStaggerStatusInspectResponses,
  EdgeStackStatusUpdateData,
  EdgeStackStatusUpdateErrors,
  EdgeStackStatusUpdateResponses,
  EdgeStackUpdateData,
  EdgeStackUpdateErrors,
  EdgeStackUpdateFromGitData,
  EdgeStackUpdateFromGitErrors,
  EdgeStackUpdateFromGitResponses,
  EdgeStackUpdateHelmRepositoryData,
  EdgeStackUpdateHelmRepositoryErrors,
  EdgeStackUpdateHelmRepositoryResponses,
  EdgeStackUpdateResponses,
  EdgeStackWebhookInvokeData,
  EdgeStackWebhookInvokeErrors,
  EdgeStackWebhookInvokeResponses,
  EdgeUpdatePreviousVersionsData,
  EdgeUpdatePreviousVersionsErrors,
  EdgeUpdatePreviousVersionsResponses,
  EdgeUpdateScheduleActiveSchedulesListData,
  EdgeUpdateScheduleActiveSchedulesListErrors,
  EdgeUpdateScheduleActiveSchedulesListResponses,
  EdgeUpdateScheduleCreateData,
  EdgeUpdateScheduleCreateErrors,
  EdgeUpdateScheduleCreateResponses,
  EdgeUpdateScheduleDeleteData,
  EdgeUpdateScheduleDeleteErrors,
  EdgeUpdateScheduleDeleteResponses,
  EdgeUpdateScheduleInfoData,
  EdgeUpdateScheduleInfoErrors,
  EdgeUpdateScheduleInfoResponses,
  EdgeUpdateScheduleInspectData,
  EdgeUpdateScheduleInspectErrors,
  EdgeUpdateScheduleInspectResponses,
  EdgeUpdateScheduleListData,
  EdgeUpdateScheduleListErrors,
  EdgeUpdateScheduleListResponses,
  EdgeUpdateScheduleUpdateData,
  EdgeUpdateScheduleUpdateErrors,
  EdgeUpdateScheduleUpdateResponses,
  EndpointAssociationDeleteData,
  EndpointAssociationDeleteErrors,
  EndpointAssociationDeleteResponses,
  EndpointCreateData,
  EndpointCreateErrors,
  EndpointCreateGlobalKeyData,
  EndpointCreateGlobalKeyErrors,
  EndpointCreateGlobalKeyResponses,
  EndpointCreateResponses,
  EndpointDeleteBatchData,
  EndpointDeleteBatchErrors,
  EndpointDeleteBatchResponses,
  EndpointDeleteData,
  EndpointDeleteErrors,
  EndpointDeleteResponses,
  EndpointDockerBrowsePutData,
  EndpointDockerBrowsePutErrors,
  EndpointDockerBrowsePutResponses,
  EndpointDockerhubStatusData,
  EndpointDockerhubStatusErrors,
  EndpointDockerhubStatusResponses,
  EndpointEdgeGenerateKeyData,
  EndpointEdgeGenerateKeyErrors,
  EndpointEdgeGenerateKeyResponses,
  EndpointForceUpdateServiceData,
  EndpointForceUpdateServiceErrors,
  EndpointForceUpdateServiceResponses,
  EndpointGroupAddEndpointData,
  EndpointGroupAddEndpointErrors,
  EndpointGroupAddEndpointResponses,
  EndpointGroupCreateData,
  EndpointGroupCreateErrors,
  EndpointGroupCreateResponses,
  EndpointGroupDeleteData,
  EndpointGroupDeleteEndpointData,
  EndpointGroupDeleteEndpointErrors,
  EndpointGroupDeleteEndpointResponses,
  EndpointGroupDeleteErrors,
  EndpointGroupDeleteResponses,
  EndpointGroupListData,
  EndpointGroupListErrors,
  EndpointGroupListResponses,
  EndpointGroupUpdateData,
  EndpointGroupUpdateErrors,
  EndpointGroupUpdateResponses,
  EndpointInspectData,
  EndpointInspectErrors,
  EndpointInspectResponses,
  EndpointListData,
  EndpointListErrors,
  EndpointListResponses,
  EndpointMtlsAgentCertificateErrorData,
  EndpointMtlsAgentCertificateErrorErrors,
  EndpointMtlsAgentCertificateErrorResponses,
  EndpointMtlsCertificateData,
  EndpointMtlsCertificateErrors,
  EndpointMtlsCertificateResponses,
  EndpointRegistriesListData,
  EndpointRegistriesListErrors,
  EndpointRegistriesListResponses,
  EndpointRegistryAccessData,
  EndpointRegistryAccessErrors,
  EndpointRegistryAccessResponses,
  EndpointSetPolicyStatusesData,
  EndpointSetPolicyStatusesErrors,
  EndpointSetPolicyStatusesResponses,
  EndpointSettingsUpdateData,
  EndpointSettingsUpdateErrors,
  EndpointSettingsUpdateResponses,
  EndpointSnapshotData,
  EndpointSnapshotErrors,
  EndpointSnapshotResponses,
  EndpointSnapshotsData,
  EndpointSnapshotsErrors,
  EndpointSnapshotsResponses,
  EndpointSummaryCountsData,
  EndpointSummaryCountsErrors,
  EndpointSummaryCountsResponses,
  EndpointUpdateData,
  EndpointUpdateErrors,
  EndpointUpdateRelationsData,
  EndpointUpdateRelationsErrors,
  EndpointUpdateRelationsResponses,
  EndpointUpdateResponses,
  EnvironmentObservabilityDiscoveryData,
  EnvironmentObservabilityDiscoveryErrors,
  EnvironmentObservabilityDiscoveryResponses,
  GenerateData,
  GenerateErrors,
  GenerateResponses,
  GetAlertingSettingsData,
  GetAlertingSettingsErrors,
  GetAlertingSettingsResponses,
  GetAlertRuleData,
  GetAlertRuleEnvironmentsData,
  GetAlertRuleEnvironmentsErrors,
  GetAlertRuleEnvironmentsResponses,
  GetAlertRuleErrors,
  GetAlertRuleResponses,
  GetAlertsData,
  GetAlertsErrors,
  GetAlertsResponses,
  GetAllAlertingSettingsData,
  GetAllAlertingSettingsErrors,
  GetAllAlertingSettingsResponses,
  GetAllAlertRulesData,
  GetAllAlertRulesErrors,
  GetAllAlertRulesResponses,
  GetAllData,
  GetAllErrors,
  GetAllKubernetesApplicationData,
  GetAllKubernetesApplicationErrors,
  GetAllKubernetesApplicationResponses,
  GetAllKubernetesApplicationsCountData,
  GetAllKubernetesApplicationsCountErrors,
  GetAllKubernetesApplicationsCountResponses,
  GetAllKubernetesApplicationsData,
  GetAllKubernetesApplicationsErrors,
  GetAllKubernetesApplicationsResponses,
  GetAllKubernetesClusterIngressesCountData,
  GetAllKubernetesClusterIngressesCountErrors,
  GetAllKubernetesClusterIngressesCountResponses,
  GetAllKubernetesClusterIngressesData,
  GetAllKubernetesClusterIngressesErrors,
  GetAllKubernetesClusterIngressesResponses,
  GetAllKubernetesClusterRoleBindingsData,
  GetAllKubernetesClusterRoleBindingsErrors,
  GetAllKubernetesClusterRoleBindingsResponses,
  GetAllKubernetesClusterRolesData,
  GetAllKubernetesClusterRolesErrors,
  GetAllKubernetesClusterRolesResponses,
  GetAllKubernetesConfigMapsCountData,
  GetAllKubernetesConfigMapsCountErrors,
  GetAllKubernetesConfigMapsCountResponses,
  GetAllKubernetesConfigMapsData,
  GetAllKubernetesConfigMapsErrors,
  GetAllKubernetesConfigMapsResponses,
  GetAllKubernetesDeploymentsData,
  GetAllKubernetesDeploymentsErrors,
  GetAllKubernetesDeploymentsResponses,
  GetAllKubernetesEventsData,
  GetAllKubernetesEventsErrors,
  GetAllKubernetesEventsResponses,
  GetAllKubernetesIngressControllersData,
  GetAllKubernetesIngressControllersErrors,
  GetAllKubernetesIngressControllersResponses,
  GetAllKubernetesIngressesData,
  GetAllKubernetesIngressesErrors,
  GetAllKubernetesIngressesResponses,
  GetAllKubernetesPersistentVolumeClaimsData,
  GetAllKubernetesPersistentVolumeClaimsErrors,
  GetAllKubernetesPersistentVolumeClaimsResponses,
  GetAllKubernetesPersistentVolumesData,
  GetAllKubernetesPersistentVolumesErrors,
  GetAllKubernetesPersistentVolumesResponses,
  GetAllKubernetesPodsData,
  GetAllKubernetesPodsErrors,
  GetAllKubernetesPodsResponses,
  GetAllKubernetesServicesCountData,
  GetAllKubernetesServicesCountErrors,
  GetAllKubernetesServicesCountResponses,
  GetAllKubernetesStorageClassesData,
  GetAllKubernetesStorageClassesErrors,
  GetAllKubernetesStorageClassesResponses,
  GetAllKubernetesVolumesCountData,
  GetAllKubernetesVolumesCountErrors,
  GetAllKubernetesVolumesCountResponses,
  GetAllKubernetesVolumesData,
  GetAllKubernetesVolumesErrors,
  GetAllKubernetesVolumesResponses,
  GetAllResponses,
  GetApplicationsResourcesData,
  GetApplicationsResourcesErrors,
  GetApplicationsResourcesResponses,
  GetDebugLogStatusData,
  GetDebugLogStatusErrors,
  GetDebugLogStatusResponses,
  GetEndpointGroupsByIdData,
  GetEndpointGroupsByIdErrors,
  GetEndpointGroupsByIdResponses,
  GetKubernetesAllCustomResourcesData,
  GetKubernetesAllCustomResourcesErrors,
  GetKubernetesAllCustomResourcesResponses,
  GetKubernetesClusterScopedCustomResourceData,
  GetKubernetesClusterScopedCustomResourceErrors,
  GetKubernetesClusterScopedCustomResourceResponses,
  GetKubernetesConfigMapData,
  GetKubernetesConfigMapErrors,
  GetKubernetesConfigMapResponses,
  GetKubernetesCronJobsData,
  GetKubernetesCronJobsErrors,
  GetKubernetesCronJobsResponses,
  GetKubernetesCustomResourceDefinitionData,
  GetKubernetesCustomResourceDefinitionErrors,
  GetKubernetesCustomResourceDefinitionResponses,
  GetKubernetesCustomResourceDefinitionsData,
  GetKubernetesCustomResourceDefinitionsErrors,
  GetKubernetesCustomResourceDefinitionsResponses,
  GetKubernetesDashboardData,
  GetKubernetesDashboardErrors,
  GetKubernetesDashboardResponses,
  GetKubernetesDeploymentData,
  GetKubernetesDeploymentErrors,
  GetKubernetesDeploymentResponses,
  GetKubernetesDeploymentsForNamespaceData,
  GetKubernetesDeploymentsForNamespaceErrors,
  GetKubernetesDeploymentsForNamespaceResponses,
  GetKubernetesEndpointsData,
  GetKubernetesEndpointsErrors,
  GetKubernetesEndpointsResponses,
  GetKubernetesEventsForNamespaceData,
  GetKubernetesEventsForNamespaceErrors,
  GetKubernetesEventsForNamespaceResponses,
  GetKubernetesGpuInfoData,
  GetKubernetesGpuInfoErrors,
  GetKubernetesGpuInfoResponses,
  GetKubernetesIngressClassesData,
  GetKubernetesIngressClassesErrors,
  GetKubernetesIngressClassesResponses,
  GetKubernetesIngressControllersByNamespaceData,
  GetKubernetesIngressControllersByNamespaceErrors,
  GetKubernetesIngressControllersByNamespaceResponses,
  GetKubernetesIngressData,
  GetKubernetesIngressErrors,
  GetKubernetesIngressResponses,
  GetKubernetesJobsData,
  GetKubernetesJobsErrors,
  GetKubernetesJobsResponses,
  GetKubernetesMaxResourceLimitsData,
  GetKubernetesMaxResourceLimitsErrors,
  GetKubernetesMaxResourceLimitsResponses,
  GetKubernetesMetricsForAllNodesData,
  GetKubernetesMetricsForAllNodesErrors,
  GetKubernetesMetricsForAllNodesResponses,
  GetKubernetesMetricsForAllPodsData,
  GetKubernetesMetricsForAllPodsErrors,
  GetKubernetesMetricsForAllPodsResponses,
  GetKubernetesMetricsForNodeData,
  GetKubernetesMetricsForNodeErrors,
  GetKubernetesMetricsForNodeResponses,
  GetKubernetesMetricsForPodData,
  GetKubernetesMetricsForPodErrors,
  GetKubernetesMetricsForPodResponses,
  GetKubernetesNamespaceData,
  GetKubernetesNamespacedCustomResourceData,
  GetKubernetesNamespacedCustomResourceErrors,
  GetKubernetesNamespacedCustomResourceResponses,
  GetKubernetesNamespaceErrors,
  GetKubernetesNamespaceResponses,
  GetKubernetesNamespacesCountData,
  GetKubernetesNamespacesCountErrors,
  GetKubernetesNamespacesCountResponses,
  GetKubernetesNamespacesData,
  GetKubernetesNamespacesErrors,
  GetKubernetesNamespacesResponses,
  GetKubernetesNodesData,
  GetKubernetesNodesErrors,
  GetKubernetesNodesLimitsData,
  GetKubernetesNodesLimitsErrors,
  GetKubernetesNodesLimitsResponses,
  GetKubernetesNodesResponses,
  GetKubernetesPersistentVolumeClaimData,
  GetKubernetesPersistentVolumeClaimErrors,
  GetKubernetesPersistentVolumeClaimResponses,
  GetKubernetesPersistentVolumeClaimsInNamespaceData,
  GetKubernetesPersistentVolumeClaimsInNamespaceErrors,
  GetKubernetesPersistentVolumeClaimsInNamespaceResponses,
  GetKubernetesPersistentVolumeData,
  GetKubernetesPersistentVolumeErrors,
  GetKubernetesPersistentVolumeResponses,
  GetKubernetesPodLogsData,
  GetKubernetesPodLogsErrors,
  GetKubernetesPodLogsResponses,
  GetKubernetesPodSecurityRuleData,
  GetKubernetesPodSecurityRuleErrors,
  GetKubernetesPodSecurityRuleResponses,
  GetKubernetesPodsForNamespaceData,
  GetKubernetesPodsForNamespaceErrors,
  GetKubernetesPodsForNamespaceResponses,
  GetKubernetesRbacStatusData,
  GetKubernetesRbacStatusErrors,
  GetKubernetesRbacStatusResponses,
  GetKubernetesReplicaSetsData,
  GetKubernetesReplicaSetsErrors,
  GetKubernetesReplicaSetsResponses,
  GetKubernetesResourceQuotasData,
  GetKubernetesResourceQuotasErrors,
  GetKubernetesResourceQuotasResponses,
  GetKubernetesRoleBindingsData,
  GetKubernetesRoleBindingsErrors,
  GetKubernetesRoleBindingsResponses,
  GetKubernetesRolesData,
  GetKubernetesRolesErrors,
  GetKubernetesRolesResponses,
  GetKubernetesSecretData,
  GetKubernetesSecretErrors,
  GetKubernetesSecretResponses,
  GetKubernetesSecretsCountData,
  GetKubernetesSecretsCountErrors,
  GetKubernetesSecretsCountResponses,
  GetKubernetesSecretsData,
  GetKubernetesSecretsErrors,
  GetKubernetesSecretsResponses,
  GetKubernetesServiceAccountData,
  GetKubernetesServiceAccountErrors,
  GetKubernetesServiceAccountResponses,
  GetKubernetesServiceAccountsData,
  GetKubernetesServiceAccountsErrors,
  GetKubernetesServiceAccountsResponses,
  GetKubernetesServicesByNamespaceData,
  GetKubernetesServicesByNamespaceErrors,
  GetKubernetesServicesByNamespaceResponses,
  GetKubernetesServicesData,
  GetKubernetesServicesErrors,
  GetKubernetesServicesResponses,
  GetKubernetesStorageClassData,
  GetKubernetesStorageClassErrors,
  GetKubernetesStorageClassResponses,
  GetKubernetesVersionData,
  GetKubernetesVersionErrors,
  GetKubernetesVersionResponses,
  GetKubernetesVolumeData,
  GetKubernetesVolumeErrors,
  GetKubernetesVolumeResponses,
  GetKubernetesVolumesInNamespaceData,
  GetKubernetesVolumesInNamespaceErrors,
  GetKubernetesVolumesInNamespaceResponses,
  GitOperationRepoFilePreviewData,
  GitOperationRepoFilePreviewErrors,
  GitOperationRepoFilePreviewResponses,
  GitOperationRepoFilesSearchData,
  GitOperationRepoFilesSearchErrors,
  GitOperationRepoFilesSearchResponses,
  GitOperationRepoHelmValuesData,
  GitOperationRepoHelmValuesErrors,
  GitOperationRepoHelmValuesResponses,
  GitOperationRepoRefsData,
  GitOperationRepoRefsErrors,
  GitOperationRepoRefsResponses,
  GitOpsSourceGetData,
  GitOpsSourceGetErrors,
  GitOpsSourceGetResponses,
  GitOpsSourcesCreateGitData,
  GitOpsSourcesCreateGitErrors,
  GitOpsSourcesCreateGitResponses,
  GitOpsSourcesDeleteData,
  GitOpsSourcesDeleteErrors,
  GitOpsSourcesDeleteResponses,
  GitOpsSourcesListData,
  GitOpsSourcesListErrors,
  GitOpsSourcesListResponses,
  GitOpsSourcesSummaryData,
  GitOpsSourcesSummaryErrors,
  GitOpsSourcesSummaryResponses,
  GitOpsSourcesTestByIdData,
  GitOpsSourcesTestByIdErrors,
  GitOpsSourcesTestByIdResponses,
  GitOpsSourcesTestData,
  GitOpsSourcesTestErrors,
  GitOpsSourcesTestResponses,
  GitOpsSourcesUpdateAccessData,
  GitOpsSourcesUpdateAccessErrors,
  GitOpsSourcesUpdateAccessResponses,
  GitOpsSourcesUpdateGitData,
  GitOpsSourcesUpdateGitErrors,
  GitOpsSourcesUpdateGitResponses,
  GitOpsSourceWorkflowsListData,
  GitOpsSourceWorkflowsListErrors,
  GitOpsSourceWorkflowsListResponses,
  GitOpsWorkflowDestroyData,
  GitOpsWorkflowDestroyErrors,
  GitOpsWorkflowDestroyResponses,
  GitOpsWorkflowDetachData,
  GitOpsWorkflowDetachErrors,
  GitOpsWorkflowDetachResponses,
  GitOpsWorkflowGetData,
  GitOpsWorkflowGetErrors,
  GitOpsWorkflowGetResponses,
  GitOpsWorkflowsListData,
  GitOpsWorkflowsListErrors,
  GitOpsWorkflowsListResponses,
  GitOpsWorkflowsSummaryData,
  GitOpsWorkflowsSummaryErrors,
  GitOpsWorkflowsSummaryResponses,
  HelmDeleteData,
  HelmDeleteErrors,
  HelmDeleteResponses,
  HelmGetData,
  HelmGetErrors,
  HelmGetHistoryData,
  HelmGetHistoryErrors,
  HelmGetHistoryResponses,
  HelmGetResponses,
  HelmGitDryRunData,
  HelmGitDryRunErrors,
  HelmGitDryRunResponses,
  HelmInstallData,
  HelmInstallErrors,
  HelmInstallResponses,
  HelmListData,
  HelmListErrors,
  HelmListResponses,
  HelmRepoSearchData,
  HelmRepoSearchErrors,
  HelmRepoSearchResponses,
  HelmRollbackData,
  HelmRollbackErrors,
  HelmRollbackResponses,
  HelmShowData,
  HelmShowErrors,
  HelmShowResponses,
  HelmUserRepositoriesListData,
  HelmUserRepositoriesListErrors,
  HelmUserRepositoriesListResponses,
  HelmUserRepositoryCreateData,
  HelmUserRepositoryCreateErrors,
  HelmUserRepositoryCreateResponses,
  HelmUserRepositoryDeleteData,
  HelmUserRepositoryDeleteErrors,
  HelmUserRepositoryDeleteResponses,
  KubernetesNamespacesToggleSystemData,
  KubernetesNamespacesToggleSystemErrors,
  KubernetesNamespacesToggleSystemResponses,
  LdapAdminGroupsData,
  LdapAdminGroupsErrors,
  LdapAdminGroupsResponses,
  LdapCheckData,
  LdapCheckErrors,
  LdapCheckResponses,
  LdapGroupsData,
  LdapGroupsErrors,
  LdapGroupsResponses,
  LdapTestLoginData,
  LdapTestLoginErrors,
  LdapTestLoginResponses,
  LdapUsersData,
  LdapUsersErrors,
  LdapUsersResponses,
  LicensesAttachData2,
  LicensesAttachResponses,
  LicensesDeleteData,
  LicensesDeleteResponses,
  LicensesInfoData,
  LicensesInfoResponses,
  LicensesListData,
  LicensesListResponses,
  LocalBackupSettingsFetchData,
  LocalBackupSettingsFetchErrors,
  LocalBackupSettingsFetchResponses,
  LocalBackupStatusFetchData,
  LocalBackupStatusFetchErrors,
  LocalBackupStatusFetchResponses,
  LogoutData,
  LogoutErrors,
  LogoutResponses,
  LogsCsvData,
  LogsCsvErrors,
  LogsCsvResponses,
  LogsListData,
  LogsListErrors,
  LogsListResponses,
  MotdData,
  MotdResponses,
  NamespacesAccessUpdateData,
  NamespacesAccessUpdateErrors,
  NamespacesAccessUpdateResponses,
  ObservabilityEnvironmentLogsData,
  ObservabilityEnvironmentLogsErrors,
  ObservabilityEnvironmentLogsResponses,
  ObservabilityEnvironmentMetricsData,
  ObservabilityEnvironmentMetricsErrors,
  ObservabilityEnvironmentMetricsResponses,
  OmniCancelProvisioningData,
  OmniCancelProvisioningErrors,
  OmniCancelProvisioningResponses,
  OmniCreateClusterData,
  OmniCreateClusterErrors,
  OmniCreateClusterResponses,
  OmniDeleteClusterData,
  OmniDeleteClusterErrors,
  OmniDeleteClusterResponses,
  OmniGetClusterData,
  OmniGetClusterErrors,
  OmniGetClusterResponses,
  OmniGetK8sVersionUpgradeStatusData,
  OmniGetK8sVersionUpgradeStatusErrors,
  OmniGetK8sVersionUpgradeStatusResponses,
  OmniGetMachineData,
  OmniGetMachineErrors,
  OmniGetMachineLogsData,
  OmniGetMachineLogsErrors,
  OmniGetMachineLogsResponses,
  OmniGetMachineResponses,
  OmniGetSupportedTalosVersionsData,
  OmniGetSupportedTalosVersionsErrors,
  OmniGetSupportedTalosVersionsResponses,
  OmniGetTalosVersionUpgradeStatusData,
  OmniGetTalosVersionUpgradeStatusErrors,
  OmniGetTalosVersionUpgradeStatusResponses,
  OmniListMachinesData,
  OmniListMachinesErrors,
  OmniListMachinesResponses,
  OmniRebootNodeData,
  OmniRebootNodeErrors,
  OmniRebootNodeResponses,
  OmniUpdateClusterData,
  OmniUpdateClusterErrors,
  OmniUpdateClusterResponses,
  OmniValidateClusterData,
  OmniValidateClusterErrors,
  OmniValidateClusterResponses,
  OmniValidateServiceAccountData,
  OmniValidateServiceAccountErrors,
  OmniValidateServiceAccountResponses,
  PatchKubernetesDeploymentData,
  PatchKubernetesDeploymentErrors,
  PatchKubernetesDeploymentResponses,
  PolicyConflictsData,
  PolicyConflictsErrors,
  PolicyConflictsResponses,
  PolicyCreateData,
  PolicyCreateErrors,
  PolicyCreateResponses,
  PolicyDeleteData,
  PolicyDeleteErrors,
  PolicyDeleteResponses,
  PolicyInspectData,
  PolicyInspectErrors,
  PolicyInspectResponses,
  PolicyListData,
  PolicyListErrors,
  PolicyListResponses,
  PolicyMetadataData,
  PolicyMetadataErrors,
  PolicyMetadataResponses,
  PolicyTemplateInspectData,
  PolicyTemplateInspectErrors,
  PolicyTemplateInspectResponses,
  PolicyTemplateListData,
  PolicyTemplateListResponses,
  PolicyTestObservabilityConnectionData,
  PolicyTestObservabilityConnectionErrors,
  PolicyTestObservabilityConnectionResponses,
  PolicyUpdateData,
  PolicyUpdateErrors,
  PolicyUpdateResponses,
  RecommendationListData,
  RecommendationListErrors,
  RecommendationListResponses,
  RecommendationSummaryData,
  RecommendationSummaryResponses,
  RegistryConfigureData,
  RegistryConfigureErrors,
  RegistryConfigureResponses,
  RegistryCreateData,
  RegistryCreateErrors,
  RegistryCreateResponses,
  RegistryDeleteData,
  RegistryDeleteErrors,
  RegistryDeleteResponses,
  RegistryInspectData,
  RegistryInspectErrors,
  RegistryInspectResponses,
  RegistryListData,
  RegistryListErrors,
  RegistryListResponses,
  RegistryPingData,
  RegistryPingErrors,
  RegistryPingResponses,
  RegistryUpdateData,
  RegistryUpdateErrors,
  RegistryUpdateResponses,
  RemoteUpdatesAgentVersionsData,
  RemoteUpdatesAgentVersionsErrors,
  RemoteUpdatesAgentVersionsResponses,
  RepositoryTagsDeleteData,
  RepositoryTagsDeleteErrors,
  RepositoryTagsDeleteResponses,
  RepositoryTagsDetailsData,
  RepositoryTagsDetailsErrors,
  RepositoryTagsDetailsResponses,
  ResizeKubernetesPersistentVolumeClaimData,
  ResizeKubernetesPersistentVolumeClaimErrors,
  ResizeKubernetesPersistentVolumeClaimResponses,
  ResourceControlCreateData,
  ResourceControlCreateErrors,
  ResourceControlCreateResponses,
  ResourceControlDeleteData,
  ResourceControlDeleteErrors,
  ResourceControlDeleteResponses,
  ResourceControlUpdateData,
  ResourceControlUpdateErrors,
  ResourceControlUpdateResponses,
  RestartKubernetesApplicationData,
  RestartKubernetesApplicationErrors,
  RestartKubernetesApplicationResponses,
  RestartKubernetesPodData,
  RestartKubernetesPodErrors,
  RestartKubernetesPodResponses,
  RestoreData,
  RestoreErrors,
  RestoreFromAzureBlobData,
  RestoreFromAzureBlobErrors,
  RestoreFromAzureBlobResponses,
  RestoreFromS3Data,
  RestoreFromS3Errors,
  RestoreFromS3Responses,
  RestoreResponses,
  RoleListData,
  RoleListErrors,
  RoleListResponses,
  RollbackKubernetesDeploymentData,
  RollbackKubernetesDeploymentErrors,
  RollbackKubernetesDeploymentResponses,
  RunLocalBackupNowData,
  RunLocalBackupNowErrors,
  RunLocalBackupNowResponses,
  ScaleKubernetesDeploymentData,
  ScaleKubernetesDeploymentErrors,
  ScaleKubernetesDeploymentResponses,
  ServiceImageStatusClearData,
  ServiceImageStatusClearErrors,
  ServiceImageStatusClearResponses,
  ServiceImageStatusData,
  ServiceImageStatusErrors,
  ServiceImageStatusResponses,
  SetDebugLogStatusData,
  SetDebugLogStatusErrors,
  SetDebugLogStatusResponses,
  SetDefaultKubernetesStorageClassData,
  SetDefaultKubernetesStorageClassErrors,
  SetDefaultKubernetesStorageClassResponses,
  SettingsAdditionalFunctionalityInspectData,
  SettingsAdditionalFunctionalityInspectErrors,
  SettingsAdditionalFunctionalityInspectResponses,
  SettingsAdditionalFunctionalityUpdateData,
  SettingsAdditionalFunctionalityUpdateErrors,
  SettingsAdditionalFunctionalityUpdateResponses,
  SettingsEdgeMtlscaCertificatesData,
  SettingsEdgeMtlscaCertificatesErrors,
  SettingsEdgeMtlscaCertificatesResponses,
  SettingsEdgeMtlsCertificatesData,
  SettingsEdgeMtlsCertificatesErrors,
  SettingsEdgeMtlsCertificatesResponses,
  SettingsExperimentalInspectData,
  SettingsExperimentalInspectErrors,
  SettingsExperimentalInspectResponses,
  SettingsExperimentalUpdateData,
  SettingsExperimentalUpdateErrors,
  SettingsExperimentalUpdateResponses,
  SettingsInspectData,
  SettingsInspectErrors,
  SettingsInspectResponses,
  SettingsPublicData,
  SettingsPublicErrors,
  SettingsPublicResponses,
  SettingsUpdateData,
  SettingsUpdateErrors,
  SettingsUpdateResponses,
  SharedGitCreateData,
  SharedGitCreateErrors,
  SharedGitCreateResponses,
  SharedGitDeleteData,
  SharedGitDeleteErrors,
  SharedGitDeleteResponses,
  SharedGitGetAllData,
  SharedGitGetAllErrors,
  SharedGitGetAllResponses,
  SharedGitGetData,
  SharedGitGetErrors,
  SharedGitGetResponses,
  SharedGitUpdateData,
  SharedGitUpdateErrors,
  SharedGitUpdateResponses,
  SnapshotContainerInspectData,
  SnapshotContainerInspectErrors,
  SnapshotContainerInspectResponses,
  SnapshotContainersListData,
  SnapshotContainersListErrors,
  SnapshotContainersListResponses,
  SnapshotInspectData,
  SnapshotInspectErrors,
  SnapshotInspectResponses,
  SslInspectData,
  SslInspectErrors,
  SslInspectResponses,
  SslUpdateData,
  SslUpdateErrors,
  SslUpdateResponses,
  StackAssociateData,
  StackAssociateErrors,
  StackAssociateResponses,
  StackConvertData,
  StackConvertErrors,
  StackConvertResponses,
  StackCreateDockerStandaloneFileData,
  StackCreateDockerStandaloneFileErrors,
  StackCreateDockerStandaloneFileResponses,
  StackCreateDockerStandaloneRepositoryData,
  StackCreateDockerStandaloneRepositoryErrors,
  StackCreateDockerStandaloneRepositoryResponses,
  StackCreateDockerStandaloneStringData,
  StackCreateDockerStandaloneStringErrors,
  StackCreateDockerStandaloneStringResponses,
  StackCreateDockerSwarmFileData,
  StackCreateDockerSwarmFileErrors,
  StackCreateDockerSwarmFileResponses,
  StackCreateDockerSwarmRepositoryData,
  StackCreateDockerSwarmRepositoryErrors,
  StackCreateDockerSwarmRepositoryResponses,
  StackCreateDockerSwarmStringData,
  StackCreateDockerSwarmStringErrors,
  StackCreateDockerSwarmStringResponses,
  StackCreateKubernetesFileData,
  StackCreateKubernetesFileErrors,
  StackCreateKubernetesFileResponses,
  StackCreateKubernetesGitData,
  StackCreateKubernetesGitErrors,
  StackCreateKubernetesGitResponses,
  StackCreateKubernetesUrlData,
  StackCreateKubernetesUrlErrors,
  StackCreateKubernetesUrlResponses,
  StackDeleteData,
  StackDeleteErrors,
  StackDeleteKubernetesByNameData,
  StackDeleteKubernetesByNameErrors,
  StackDeleteKubernetesByNameResponses,
  StackDeleteResponses,
  StackFileInspectData,
  StackFileInspectErrors,
  StackFileInspectResponses,
  StackGitRedeployData,
  StackGitRedeployErrors,
  StackGitRedeployResponses,
  StackImagesStatusData,
  StackImagesStatusErrors,
  StackImagesStatusResponses,
  StackInspectData,
  StackInspectErrors,
  StackInspectResponses,
  StackListData,
  StackListErrors,
  StackListResponses,
  StackMigrateData,
  StackMigrateErrors,
  StackMigrateResponses,
  StacksImageStatusClearData,
  StacksImageStatusClearErrors,
  StacksImageStatusClearResponses,
  StackStartData,
  StackStartErrors,
  StackStartResponses,
  StackStopData,
  StackStopErrors,
  StackStopResponses,
  StacksWebhookInvokeData,
  StacksWebhookInvokeErrors,
  StacksWebhookInvokeResponses,
  StackUpdateData,
  StackUpdateErrors,
  StackUpdateGitData,
  StackUpdateGitErrors,
  StackUpdateGitResponses,
  StackUpdateResponses,
  SupportBundleDownloadData,
  SupportBundleDownloadErrors,
  SupportBundleDownloadResponses,
  SystemInfoData,
  SystemInfoErrors,
  SystemInfoResponses,
  SystemNodesCountData,
  SystemNodesCountErrors,
  SystemNodesCountResponses,
  SystemStatusData,
  SystemStatusResponses,
  SystemUpdateData,
  SystemUpdateErrors,
  SystemUpdateResponses,
  SystemVersionData,
  SystemVersionResponses,
  TagCreateData,
  TagCreateErrors,
  TagCreateResponses,
  TagDeleteData,
  TagDeleteErrors,
  TagDeleteResponses,
  TagListData,
  TagListErrors,
  TagListResponses,
  TeamCreateData,
  TeamCreateErrors,
  TeamCreateResponses,
  TeamDeleteData,
  TeamDeleteErrors,
  TeamDeleteResponses,
  TeamInspectData,
  TeamInspectErrors,
  TeamInspectResponses,
  TeamListData,
  TeamListErrors,
  TeamListResponses,
  TeamMembershipCreateData,
  TeamMembershipCreateErrors,
  TeamMembershipCreateResponses,
  TeamMembershipDeleteData,
  TeamMembershipDeleteErrors,
  TeamMembershipDeleteResponses,
  TeamMembershipListData,
  TeamMembershipListErrors,
  TeamMembershipListResponses,
  TeamMembershipsData,
  TeamMembershipsErrors,
  TeamMembershipsResponses,
  TeamMembershipUpdateData,
  TeamMembershipUpdateErrors,
  TeamMembershipUpdateResponses,
  TeamUpdateData,
  TeamUpdateErrors,
  TeamUpdateResponses,
  TemplateFileData,
  TemplateFileErrors,
  TemplateFileResponses,
  TemplateListData,
  TemplateListErrors,
  TemplateListResponses,
  TestAlertManagerConnectivityData,
  TestAlertManagerConnectivityErrors,
  TestAlertManagerConnectivityResponses,
  TrustEdgeEndpointsData,
  TrustEdgeEndpointsErrors,
  TrustEdgeEndpointsResponses,
  UpdateAlertingSettingsData,
  UpdateAlertingSettingsErrors,
  UpdateAlertingSettingsResponses,
  UpdateAlertRuleData,
  UpdateAlertRuleErrors,
  UpdateAlertRuleGroupsData,
  UpdateAlertRuleGroupsErrors,
  UpdateAlertRuleGroupsResponses,
  UpdateAlertRuleResponses,
  UpdateAlertRuleTiersData,
  UpdateAlertRuleTiersErrors,
  UpdateAlertRuleTiersResponses,
  UpdateAzureBlobSettingsData,
  UpdateAzureBlobSettingsErrors,
  UpdateAzureBlobSettingsResponses,
  UpdateK8sPodSecurityRuleData,
  UpdateK8sPodSecurityRuleErrors,
  UpdateK8sPodSecurityRuleResponses,
  UpdateKubernetesConfigMapData,
  UpdateKubernetesConfigMapErrors,
  UpdateKubernetesConfigMapResponses,
  UpdateKubernetesDeploymentData,
  UpdateKubernetesDeploymentErrors,
  UpdateKubernetesDeploymentResponses,
  UpdateKubernetesIngressControllersByNamespaceData,
  UpdateKubernetesIngressControllersByNamespaceErrors,
  UpdateKubernetesIngressControllersByNamespaceResponses,
  UpdateKubernetesIngressControllersData,
  UpdateKubernetesIngressControllersErrors,
  UpdateKubernetesIngressControllersResponses,
  UpdateKubernetesIngressData,
  UpdateKubernetesIngressErrors,
  UpdateKubernetesIngressResponses,
  UpdateKubernetesNamespaceData,
  UpdateKubernetesNamespaceDeprecatedData,
  UpdateKubernetesNamespaceDeprecatedErrors,
  UpdateKubernetesNamespaceDeprecatedResponses,
  UpdateKubernetesNamespaceErrors,
  UpdateKubernetesNamespaceResponses,
  UpdateKubernetesPersistentVolumeReclaimPolicyData,
  UpdateKubernetesPersistentVolumeReclaimPolicyErrors,
  UpdateKubernetesPersistentVolumeReclaimPolicyResponses,
  UpdateKubernetesSecretData,
  UpdateKubernetesSecretErrors,
  UpdateKubernetesSecretResponses,
  UpdateKubernetesServiceAccountImagePullSecretsData,
  UpdateKubernetesServiceAccountImagePullSecretsErrors,
  UpdateKubernetesServiceAccountImagePullSecretsResponses,
  UpdateKubernetesServiceData,
  UpdateKubernetesServiceErrors,
  UpdateKubernetesServiceResponses,
  UpdateLocalBackupSettingsData,
  UpdateLocalBackupSettingsErrors,
  UpdateLocalBackupSettingsResponses,
  UpdateS3SettingsData,
  UpdateS3SettingsErrors,
  UpdateS3SettingsResponses,
  UpgradeData,
  UpgradeErrors,
  UpgradeResponses,
  UploadTlsData,
  UploadTlsErrors,
  UploadTlsResponses,
  UserAdminCheckData,
  UserAdminCheckErrors,
  UserAdminCheckResponses,
  UserAdminInitData,
  UserAdminInitErrors,
  UserAdminInitResponses,
  UserCreateData,
  UserCreateErrors,
  UserCreateResponses,
  UserDeleteData,
  UserDeleteErrors,
  UserDeleteResponses,
  UserEffectiveAccessInspectData,
  UserEffectiveAccessInspectErrors,
  UserEffectiveAccessInspectResponses,
  UserGenerateApiKeyData,
  UserGenerateApiKeyErrors,
  UserGenerateApiKeyResponses,
  UserGetApiKeysData,
  UserGetApiKeysErrors,
  UserGetApiKeysResponses,
  UserInspectData,
  UserInspectErrors,
  UserInspectResponses,
  UserListData,
  UserListErrors,
  UserListResponses,
  UserMembershipsInspectData,
  UserMembershipsInspectErrors,
  UserMembershipsInspectResponses,
  UserMembershipsSyncData,
  UserMembershipsSyncErrors,
  UserMembershipsSyncResponses,
  UserNamespacesData,
  UserNamespacesErrors,
  UserNamespacesResponses,
  UserRemoveApiKeyData,
  UserRemoveApiKeyErrors,
  UserRemoveApiKeyResponses,
  UserUpdateData,
  UserUpdateErrors,
  UserUpdatePasswordData,
  UserUpdatePasswordErrors,
  UserUpdatePasswordResponses,
  UserUpdateResponses,
  ValidateOAuthData,
  ValidateOAuthErrors,
  ValidateOAuthResponses,
  WebhookCreateData,
  WebhookCreateErrors,
  WebhookCreateResponses,
  WebhookDeleteData,
  WebhookDeleteErrors,
  WebhookDeleteResponses,
  WebhookExecuteData,
  WebhookExecuteErrors,
  WebhookExecuteResponses,
  WebhookListData,
  WebhookListErrors,
  WebhookListResponses,
  WebhookReassignData,
  WebhookReassignErrors,
  WebhookReassignResponses,
  WebhookUpdateData,
  WebhookUpdateErrors,
  WebhookUpdateResponses,
  WebsocketAttachData,
  WebsocketAttachErrors,
  WebsocketAttachResponses,
  WebsocketExecData,
  WebsocketExecErrors,
  WebsocketExecResponses,
  WebsocketKubernetesShellData,
  WebsocketKubernetesShellErrors,
  WebsocketKubernetesShellResponses,
  WebsocketNodeShellExecData,
  WebsocketNodeShellExecErrors,
  WebsocketNodeShellExecResponses,
  WebsocketPodExecData,
  WebsocketPodExecErrors,
  WebsocketPodExecResponses,
  WorkflowCreateData,
  WorkflowCreateErrors,
  WorkflowCreateResponses,
  WorkflowUpdateData,
  WorkflowUpdateErrors,
  WorkflowUpdateResponses,
} from './types.gen';
import {
  zAddonAccessUpdateBody,
  zAddonAccessUpdatePath,
  zAddonAccessUpdateResponse,
  zAddonChartSourcePath,
  zAddonChartSourceQuery,
  zAddonChartSourceResponse,
  zAddonConfigDeletePath,
  zAddonConfigDeleteResponse,
  zAddonConfigEntryDeletePath,
  zAddonConfigEntryDeleteResponse,
  zAddonConfigEntryUpdateBody,
  zAddonConfigEntryUpdatePath,
  zAddonConfigEntryUpdateResponse,
  zAddonConfigListPath,
  zAddonConfigListResponse,
  zAddonConfigUpdateBody,
  zAddonConfigUpdatePath,
  zAddonConfigUpdateResponse,
  zAddonDetailPath,
  zAddonDetailResponse,
  zAddonEnvironmentResponse,
  zAddonInstallBody,
  zAddonInstallPath,
  zAddonInstallResponse,
  zAddonListQuery,
  zAddonListResponse,
  zAddonRepairPath,
  zAddonRepairResponse,
  zAddonStoreConfigEntryDeletePath,
  zAddonStoreConfigEntryDeleteResponse,
  zAddonStoreConfigEntryUpdateBody,
  zAddonStoreConfigEntryUpdatePath,
  zAddonStoreConfigEntryUpdateResponse,
  zAddonStoreConfigListResponse,
  zAddonStoreConfigUpdateBody,
  zAddonStoreConfigUpdateResponse,
  zAddonUninstallPath,
  zAddonUninstallQuery,
  zAddonUninstallResponse,
  zAgentVersionsResponse,
  zAllowListInspectPath,
  zAllowListInspectResponse,
  zAllowListUpdateBody,
  zAllowListUpdatePath,
  zAllowListUpdateResponse,
  zAuthenticateUserBody,
  zAuthenticateUserResponse,
  zAuthLogsCsvQuery,
  zAuthLogsListQuery,
  zAuthLogsListResponse,
  zAutoUpdateListResponse,
  zAzureBlobBackupSettingsFetchResponse,
  zAzureBlobBackupStatusFetchResponse,
  zAzureBlobTestConnectionBody,
  zAzureBlobTestConnectionResponse,
  zBackupBody,
  zBackupSettingsFetchResponse,
  zBackupStatusFetchResponse,
  zBackupToAzureBlobBody,
  zBackupToAzureBlobResponse,
  zBackupToS3Body,
  zBackupToS3Response,
  zCloudCredsDeletePath,
  zCloudCredsDeleteResponse,
  zCloudCredsGetByIdPath,
  zCloudCredsGetByIdResponse,
  zCloudCredsUpdateBody,
  zCloudCredsUpdatePath,
  zCloudCredsUpdateResponse,
  zContainerImageStatusPath,
  zContainerImageStatusQuery,
  zContainerImageStatusResponse,
  zContainersImageStatusClearPath,
  zContainersImageStatusClearResponse,
  zCreateAlertRuleBody,
  zCreateAlertRuleResponse,
  zCreateBody,
  zCreateKubernetesConfigMapBody,
  zCreateKubernetesConfigMapPath,
  zCreateKubernetesConfigMapResponse,
  zCreateKubernetesDeploymentBody,
  zCreateKubernetesDeploymentPath,
  zCreateKubernetesDeploymentResponse,
  zCreateKubernetesIngressBody,
  zCreateKubernetesIngressPath,
  zCreateKubernetesIngressResponse,
  zCreateKubernetesNamespaceBody,
  zCreateKubernetesNamespacePath,
  zCreateKubernetesNamespaceResponse,
  zCreateKubernetesPersistentVolumeClaimBody,
  zCreateKubernetesPersistentVolumeClaimPath,
  zCreateKubernetesPersistentVolumeClaimResponse,
  zCreateKubernetesSecretBody,
  zCreateKubernetesSecretPath,
  zCreateKubernetesSecretResponse,
  zCreateKubernetesServiceBody,
  zCreateKubernetesServicePath,
  zCreateKubernetesServiceResponse,
  zCreateResponse,
  zCreateSilenceBody,
  zCreateSilenceResponse,
  zCurrentUserEndpointAuthorizationsInspectPath,
  zCurrentUserEndpointAuthorizationsInspectResponse,
  zCurrentUserEndpointNamespaceAuthorizationsInspectPath,
  zCurrentUserEndpointNamespaceAuthorizationsInspectResponse,
  zCurrentUserInspectQuery,
  zCurrentUserInspectResponse,
  zCustomTemplateCreateFileBody,
  zCustomTemplateCreateFileResponse,
  zCustomTemplateCreateRepositoryBody,
  zCustomTemplateCreateRepositoryResponse,
  zCustomTemplateCreateStringBody,
  zCustomTemplateCreateStringResponse,
  zCustomTemplateDeletePath,
  zCustomTemplateDeleteResponse,
  zCustomTemplateFilePath,
  zCustomTemplateFileResponse,
  zCustomTemplateGitFetchPath,
  zCustomTemplateGitFetchResponse,
  zCustomTemplateInspectPath,
  zCustomTemplateInspectResponse,
  zCustomTemplateListQuery,
  zCustomTemplateListResponse,
  zCustomTemplateUpdateBody,
  zCustomTemplateUpdatePath,
  zCustomTemplateUpdateResponse,
  zDefaultRegistryUpdateBody,
  zDefaultRegistryUpdateResponse,
  zDeleteAlertRulePath,
  zDeleteAlertRuleResponse,
  zDeleteClusterRoleBindingsBody,
  zDeleteClusterRoleBindingsPath,
  zDeleteClusterRoleBindingsResponse,
  zDeleteClusterRolesBody,
  zDeleteClusterRolesPath,
  zDeleteClusterRolesResponse,
  zDeleteCronJobsBody,
  zDeleteCronJobsPath,
  zDeleteCronJobsResponse,
  zDeleteJobsBody,
  zDeleteJobsPath,
  zDeleteJobsResponse,
  zDeleteKubernetesClusterScopedCustomResourcePath,
  zDeleteKubernetesClusterScopedCustomResourceQuery,
  zDeleteKubernetesClusterScopedCustomResourceResponse,
  zDeleteKubernetesConfigMapPath,
  zDeleteKubernetesConfigMapResponse,
  zDeleteKubernetesCustomResourceDefinitionPath,
  zDeleteKubernetesCustomResourceDefinitionResponse,
  zDeleteKubernetesDeploymentPath,
  zDeleteKubernetesDeploymentResponse,
  zDeleteKubernetesIngressesBody,
  zDeleteKubernetesIngressesPath,
  zDeleteKubernetesIngressesResponse,
  zDeleteKubernetesNamespaceBody,
  zDeleteKubernetesNamespacedCustomResourcePath,
  zDeleteKubernetesNamespacedCustomResourceQuery,
  zDeleteKubernetesNamespacedCustomResourceResponse,
  zDeleteKubernetesNamespacePath,
  zDeleteKubernetesNamespaceResponse,
  zDeleteKubernetesPersistentVolumeClaimsBody,
  zDeleteKubernetesPersistentVolumeClaimsPath,
  zDeleteKubernetesPersistentVolumeClaimsResponse,
  zDeleteKubernetesPersistentVolumesBody,
  zDeleteKubernetesPersistentVolumesPath,
  zDeleteKubernetesPersistentVolumesResponse,
  zDeleteKubernetesPodPath,
  zDeleteKubernetesPodResponse,
  zDeleteKubernetesSecretPath,
  zDeleteKubernetesSecretResponse,
  zDeleteKubernetesServicesBody,
  zDeleteKubernetesServicesPath,
  zDeleteKubernetesServicesResponse,
  zDeleteKubernetesStorageClassesBody,
  zDeleteKubernetesStorageClassesPath,
  zDeleteKubernetesStorageClassesResponse,
  zDeleteRoleBindingsBody,
  zDeleteRoleBindingsPath,
  zDeleteRoleBindingsResponse,
  zDeleteRolesBody,
  zDeleteRolesPath,
  zDeleteRolesResponse,
  zDeleteServiceAccountsBody,
  zDeleteServiceAccountsPath,
  zDeleteServiceAccountsResponse,
  zDeleteSilencePath,
  zDeleteSilenceQuery,
  zDeleteSilenceResponse,
  zDescribeResourcePath,
  zDescribeResourceQuery,
  zDescribeResourceResponse,
  zDockerContainerGpusInspectPath,
  zDockerContainerGpusInspectResponse,
  zDockerDashboardPath,
  zDockerDashboardResponse,
  zDockerImagesListPath,
  zDockerImagesListQuery,
  zDockerImagesListResponse,
  zDrainNodeBody,
  zDrainNodePath,
  zDrainNodeResponse,
  zDryRunKubernetesManifestsBody,
  zDryRunKubernetesManifestsPath,
  zDryRunKubernetesManifestsResponse,
  zEcrDeleteRepositoryPath,
  zEcrDeleteTagsBody,
  zEcrDeleteTagsPath,
  zEcrDeleteTagsResponse,
  zEdgeConfigCreateBody,
  zEdgeConfigCreateResponse,
  zEdgeConfigDeletePath,
  zEdgeConfigDeleteResponse,
  zEdgeConfigFilesPath,
  zEdgeConfigFilesResponse,
  zEdgeConfigInspectPath,
  zEdgeConfigInspectResponse,
  zEdgeConfigListBody,
  zEdgeConfigListResponse,
  zEdgeConfigStatePath,
  zEdgeConfigStateResponse,
  zEdgeConfigUpdateBody,
  zEdgeConfigUpdatePath,
  zEdgeConfigUpdateResponse,
  zEdgeGroupCreateBody,
  zEdgeGroupCreateResponse,
  zEdgeGroupDeletePath,
  zEdgeGroupDeleteResponse,
  zEdgeGroupInspectPath,
  zEdgeGroupInspectResponse,
  zEdgeGroupListQuery,
  zEdgeGroupListResponse,
  zEdgeGroupUpdateBody,
  zEdgeGroupUpdatePath,
  zEdgeGroupUpdateResponse,
  zEdgeJobCreateFileBody,
  zEdgeJobCreateFileResponse,
  zEdgeJobCreateStringBody,
  zEdgeJobCreateStringResponse,
  zEdgeJobDeletePath,
  zEdgeJobDeleteResponse,
  zEdgeJobFilePath,
  zEdgeJobFileResponse,
  zEdgeJobInspectPath,
  zEdgeJobInspectResponse,
  zEdgeJobListResponse,
  zEdgeJobTaskLogsInspectPath,
  zEdgeJobTaskLogsInspectResponse,
  zEdgeJobTasksClearPath,
  zEdgeJobTasksClearResponse,
  zEdgeJobTasksCollectPath,
  zEdgeJobTasksCollectResponse,
  zEdgeJobTasksListPath,
  zEdgeJobTasksListResponse,
  zEdgeJobUpdateBody,
  zEdgeJobUpdatePath,
  zEdgeJobUpdateResponse,
  zEdgeStackCreateFileBody,
  zEdgeStackCreateFileQuery,
  zEdgeStackCreateFileResponse,
  zEdgeStackCreateHelmRepositoryBody,
  zEdgeStackCreateHelmRepositoryQuery,
  zEdgeStackCreateHelmRepositoryResponse,
  zEdgeStackCreateRepositoryBody,
  zEdgeStackCreateRepositoryQuery,
  zEdgeStackCreateRepositoryResponse,
  zEdgeStackCreateStringBody,
  zEdgeStackCreateStringQuery,
  zEdgeStackCreateStringResponse,
  zEdgeStackDeletePath,
  zEdgeStackDeleteResponse,
  zEdgeStackFilePath,
  zEdgeStackFileQuery,
  zEdgeStackFileResponse,
  zEdgeStackInspectPath,
  zEdgeStackInspectResponse,
  zEdgeStackListQuery,
  zEdgeStackListResponse,
  zEdgeStackLogsCollectPath,
  zEdgeStackLogsCollectQuery,
  zEdgeStackLogsCollectResponse,
  zEdgeStackLogsDeletePath,
  zEdgeStackLogsDeleteResponse,
  zEdgeStackLogsDownloadPath,
  zEdgeStackLogsStatusGetPath,
  zEdgeStackParseRegistriesBody,
  zEdgeStackParseRegistriesResponse,
  zEdgeStackStaggerStatusInspectPath,
  zEdgeStackStaggerStatusInspectResponse,
  zEdgeStackStatusUpdateBody,
  zEdgeStackStatusUpdatePath,
  zEdgeStackStatusUpdateResponse,
  zEdgeStackUpdateBody,
  zEdgeStackUpdateFromGitBody,
  zEdgeStackUpdateFromGitPath,
  zEdgeStackUpdateFromGitResponse,
  zEdgeStackUpdateHelmRepositoryBody,
  zEdgeStackUpdateHelmRepositoryPath,
  zEdgeStackUpdateHelmRepositoryResponse,
  zEdgeStackUpdatePath,
  zEdgeStackUpdateResponse,
  zEdgeStackWebhookInvokePath,
  zEdgeUpdatePreviousVersionsQuery,
  zEdgeUpdatePreviousVersionsResponse,
  zEdgeUpdateScheduleActiveSchedulesListBody,
  zEdgeUpdateScheduleActiveSchedulesListResponse,
  zEdgeUpdateScheduleCreateBody,
  zEdgeUpdateScheduleCreateResponse,
  zEdgeUpdateScheduleDeletePath,
  zEdgeUpdateScheduleDeleteResponse,
  zEdgeUpdateScheduleInfoResponse,
  zEdgeUpdateScheduleInspectPath,
  zEdgeUpdateScheduleInspectResponse,
  zEdgeUpdateScheduleListQuery,
  zEdgeUpdateScheduleListResponse,
  zEdgeUpdateScheduleUpdateBody,
  zEdgeUpdateScheduleUpdatePath,
  zEdgeUpdateScheduleUpdateResponse,
  zEndpointAssociationDeletePath,
  zEndpointAssociationDeleteResponse,
  zEndpointCreateBody,
  zEndpointCreateGlobalKeyResponse,
  zEndpointCreateResponse,
  zEndpointDeleteBatchBody,
  zEndpointDeleteBatchResponse,
  zEndpointDeletePath,
  zEndpointDeleteResponse,
  zEndpointDockerBrowsePutBody,
  zEndpointDockerBrowsePutPath,
  zEndpointDockerBrowsePutQuery,
  zEndpointDockerBrowsePutResponse,
  zEndpointDockerhubStatusPath,
  zEndpointDockerhubStatusResponse,
  zEndpointEdgeGenerateKeyBody,
  zEndpointForceUpdateServiceBody,
  zEndpointForceUpdateServicePath,
  zEndpointForceUpdateServiceResponse,
  zEndpointGroupAddEndpointPath,
  zEndpointGroupAddEndpointResponse,
  zEndpointGroupCreateBody,
  zEndpointGroupCreateResponse,
  zEndpointGroupDeleteEndpointPath,
  zEndpointGroupDeleteEndpointResponse,
  zEndpointGroupDeletePath,
  zEndpointGroupDeleteResponse,
  zEndpointGroupListQuery,
  zEndpointGroupListResponse,
  zEndpointGroupUpdateBody,
  zEndpointGroupUpdatePath,
  zEndpointGroupUpdateResponse,
  zEndpointInspectPath,
  zEndpointInspectQuery,
  zEndpointInspectResponse,
  zEndpointListQuery,
  zEndpointListResponse,
  zEndpointMtlsAgentCertificateErrorPath,
  zEndpointMtlsAgentCertificateErrorResponse,
  zEndpointMtlsCertificatePath,
  zEndpointMtlsCertificateResponse,
  zEndpointRegistriesListPath,
  zEndpointRegistriesListQuery,
  zEndpointRegistriesListResponse,
  zEndpointRegistryAccessBody,
  zEndpointRegistryAccessPath,
  zEndpointRegistryAccessResponse,
  zEndpointSetPolicyStatusesBody,
  zEndpointSetPolicyStatusesPath,
  zEndpointSetPolicyStatusesResponse,
  zEndpointSettingsUpdateBody,
  zEndpointSettingsUpdatePath,
  zEndpointSettingsUpdateResponse,
  zEndpointSnapshotPath,
  zEndpointSnapshotResponse,
  zEndpointSnapshotsResponse,
  zEndpointSummaryCountsResponse,
  zEndpointUpdateBody,
  zEndpointUpdatePath,
  zEndpointUpdateRelationsBody,
  zEndpointUpdateRelationsResponse,
  zEndpointUpdateResponse,
  zEnvironmentObservabilityDiscoveryPath,
  zEnvironmentObservabilityDiscoveryResponse,
  zGenerateResponse,
  zGetAlertingSettingsPath,
  zGetAlertingSettingsResponse,
  zGetAlertRuleEnvironmentsPath,
  zGetAlertRuleEnvironmentsResponse,
  zGetAlertRulePath,
  zGetAlertRuleResponse,
  zGetAlertsQuery,
  zGetAlertsResponse,
  zGetAllAlertingSettingsResponse,
  zGetAllAlertRulesResponse,
  zGetAllKubernetesApplicationPath,
  zGetAllKubernetesApplicationQuery,
  zGetAllKubernetesApplicationResponse,
  zGetAllKubernetesApplicationsCountPath,
  zGetAllKubernetesApplicationsCountResponse,
  zGetAllKubernetesApplicationsPath,
  zGetAllKubernetesApplicationsQuery,
  zGetAllKubernetesApplicationsResponse,
  zGetAllKubernetesClusterIngressesCountPath,
  zGetAllKubernetesClusterIngressesCountResponse,
  zGetAllKubernetesClusterIngressesPath,
  zGetAllKubernetesClusterIngressesQuery,
  zGetAllKubernetesClusterIngressesResponse,
  zGetAllKubernetesClusterRoleBindingsPath,
  zGetAllKubernetesClusterRoleBindingsResponse,
  zGetAllKubernetesClusterRolesPath,
  zGetAllKubernetesClusterRolesResponse,
  zGetAllKubernetesConfigMapsCountPath,
  zGetAllKubernetesConfigMapsCountResponse,
  zGetAllKubernetesConfigMapsPath,
  zGetAllKubernetesConfigMapsQuery,
  zGetAllKubernetesConfigMapsResponse,
  zGetAllKubernetesDeploymentsPath,
  zGetAllKubernetesDeploymentsQuery,
  zGetAllKubernetesDeploymentsResponse,
  zGetAllKubernetesEventsPath,
  zGetAllKubernetesEventsQuery,
  zGetAllKubernetesEventsResponse,
  zGetAllKubernetesIngressControllersPath,
  zGetAllKubernetesIngressControllersQuery,
  zGetAllKubernetesIngressControllersResponse,
  zGetAllKubernetesIngressesPath,
  zGetAllKubernetesIngressesResponse,
  zGetAllKubernetesPersistentVolumeClaimsPath,
  zGetAllKubernetesPersistentVolumeClaimsResponse,
  zGetAllKubernetesPersistentVolumesPath,
  zGetAllKubernetesPersistentVolumesResponse,
  zGetAllKubernetesPodsPath,
  zGetAllKubernetesPodsQuery,
  zGetAllKubernetesPodsResponse,
  zGetAllKubernetesServicesCountPath,
  zGetAllKubernetesServicesCountResponse,
  zGetAllKubernetesStorageClassesPath,
  zGetAllKubernetesStorageClassesResponse,
  zGetAllKubernetesVolumesCountPath,
  zGetAllKubernetesVolumesCountResponse,
  zGetAllKubernetesVolumesPath,
  zGetAllKubernetesVolumesQuery,
  zGetAllKubernetesVolumesResponse,
  zGetAllResponse,
  zGetApplicationsResourcesPath,
  zGetApplicationsResourcesQuery,
  zGetApplicationsResourcesResponse,
  zGetDebugLogStatusResponse,
  zGetEndpointGroupsByIdPath,
  zGetEndpointGroupsByIdQuery,
  zGetEndpointGroupsByIdResponse,
  zGetKubernetesAllCustomResourcesPath,
  zGetKubernetesAllCustomResourcesQuery,
  zGetKubernetesAllCustomResourcesResponse,
  zGetKubernetesClusterScopedCustomResourcePath,
  zGetKubernetesClusterScopedCustomResourceQuery,
  zGetKubernetesClusterScopedCustomResourceResponse,
  zGetKubernetesConfigMapPath,
  zGetKubernetesConfigMapResponse,
  zGetKubernetesCronJobsPath,
  zGetKubernetesCronJobsResponse,
  zGetKubernetesCustomResourceDefinitionPath,
  zGetKubernetesCustomResourceDefinitionResponse,
  zGetKubernetesCustomResourceDefinitionsPath,
  zGetKubernetesCustomResourceDefinitionsResponse,
  zGetKubernetesDashboardPath,
  zGetKubernetesDashboardResponse,
  zGetKubernetesDeploymentPath,
  zGetKubernetesDeploymentResponse,
  zGetKubernetesDeploymentsForNamespacePath,
  zGetKubernetesDeploymentsForNamespaceQuery,
  zGetKubernetesDeploymentsForNamespaceResponse,
  zGetKubernetesEndpointsPath,
  zGetKubernetesEndpointsResponse,
  zGetKubernetesEventsForNamespacePath,
  zGetKubernetesEventsForNamespaceQuery,
  zGetKubernetesEventsForNamespaceResponse,
  zGetKubernetesGpuInfoPath,
  zGetKubernetesGpuInfoResponse,
  zGetKubernetesIngressClassesPath,
  zGetKubernetesIngressClassesResponse,
  zGetKubernetesIngressControllersByNamespacePath,
  zGetKubernetesIngressControllersByNamespaceResponse,
  zGetKubernetesIngressPath,
  zGetKubernetesIngressResponse,
  zGetKubernetesJobsPath,
  zGetKubernetesJobsQuery,
  zGetKubernetesJobsResponse,
  zGetKubernetesMaxResourceLimitsPath,
  zGetKubernetesMaxResourceLimitsResponse,
  zGetKubernetesMetricsForAllNodesPath,
  zGetKubernetesMetricsForAllNodesResponse,
  zGetKubernetesMetricsForAllPodsPath,
  zGetKubernetesMetricsForAllPodsResponse,
  zGetKubernetesMetricsForNodePath,
  zGetKubernetesMetricsForNodeResponse,
  zGetKubernetesMetricsForPodPath,
  zGetKubernetesMetricsForPodResponse,
  zGetKubernetesNamespacedCustomResourcePath,
  zGetKubernetesNamespacedCustomResourceQuery,
  zGetKubernetesNamespacedCustomResourceResponse,
  zGetKubernetesNamespacePath,
  zGetKubernetesNamespaceQuery,
  zGetKubernetesNamespaceResponse,
  zGetKubernetesNamespacesCountPath,
  zGetKubernetesNamespacesCountResponse,
  zGetKubernetesNamespacesPath,
  zGetKubernetesNamespacesQuery,
  zGetKubernetesNamespacesResponse,
  zGetKubernetesNodesLimitsPath,
  zGetKubernetesNodesLimitsResponse,
  zGetKubernetesNodesPath,
  zGetKubernetesNodesResponse,
  zGetKubernetesPersistentVolumeClaimPath,
  zGetKubernetesPersistentVolumeClaimResponse,
  zGetKubernetesPersistentVolumeClaimsInNamespacePath,
  zGetKubernetesPersistentVolumeClaimsInNamespaceResponse,
  zGetKubernetesPersistentVolumePath,
  zGetKubernetesPersistentVolumeResponse,
  zGetKubernetesPodLogsPath,
  zGetKubernetesPodLogsQuery,
  zGetKubernetesPodLogsResponse,
  zGetKubernetesPodSecurityRulePath,
  zGetKubernetesPodSecurityRuleResponse,
  zGetKubernetesPodsForNamespacePath,
  zGetKubernetesPodsForNamespaceQuery,
  zGetKubernetesPodsForNamespaceResponse,
  zGetKubernetesRbacStatusPath,
  zGetKubernetesRbacStatusResponse,
  zGetKubernetesReplicaSetsPath,
  zGetKubernetesReplicaSetsQuery,
  zGetKubernetesReplicaSetsResponse,
  zGetKubernetesResourceQuotasPath,
  zGetKubernetesResourceQuotasResponse,
  zGetKubernetesRoleBindingsPath,
  zGetKubernetesRoleBindingsResponse,
  zGetKubernetesRolesPath,
  zGetKubernetesRolesResponse,
  zGetKubernetesSecretPath,
  zGetKubernetesSecretResponse,
  zGetKubernetesSecretsCountPath,
  zGetKubernetesSecretsCountResponse,
  zGetKubernetesSecretsPath,
  zGetKubernetesSecretsQuery,
  zGetKubernetesSecretsResponse,
  zGetKubernetesServiceAccountPath,
  zGetKubernetesServiceAccountResponse,
  zGetKubernetesServiceAccountsPath,
  zGetKubernetesServiceAccountsResponse,
  zGetKubernetesServicesByNamespacePath,
  zGetKubernetesServicesByNamespaceResponse,
  zGetKubernetesServicesPath,
  zGetKubernetesServicesQuery,
  zGetKubernetesServicesResponse,
  zGetKubernetesStorageClassPath,
  zGetKubernetesStorageClassResponse,
  zGetKubernetesVersionPath,
  zGetKubernetesVersionResponse,
  zGetKubernetesVolumePath,
  zGetKubernetesVolumeResponse,
  zGetKubernetesVolumesInNamespacePath,
  zGetKubernetesVolumesInNamespaceQuery,
  zGetKubernetesVolumesInNamespaceResponse,
  zGitOperationRepoFilePreviewBody,
  zGitOperationRepoFilePreviewResponse,
  zGitOperationRepoFilesSearchBody,
  zGitOperationRepoFilesSearchQuery,
  zGitOperationRepoFilesSearchResponse,
  zGitOperationRepoHelmValuesBody,
  zGitOperationRepoHelmValuesResponse,
  zGitOperationRepoRefsBody,
  zGitOperationRepoRefsQuery,
  zGitOperationRepoRefsResponse,
  zGitOpsSourceGetPath,
  zGitOpsSourceGetResponse,
  zGitOpsSourcesCreateGitBody,
  zGitOpsSourcesCreateGitResponse,
  zGitOpsSourcesDeletePath,
  zGitOpsSourcesDeleteResponse,
  zGitOpsSourcesListQuery,
  zGitOpsSourcesListResponse,
  zGitOpsSourcesSummaryResponse,
  zGitOpsSourcesTestBody,
  zGitOpsSourcesTestByIdBody,
  zGitOpsSourcesTestByIdPath,
  zGitOpsSourcesTestByIdResponse,
  zGitOpsSourcesTestResponse,
  zGitOpsSourcesUpdateAccessBody,
  zGitOpsSourcesUpdateAccessPath,
  zGitOpsSourcesUpdateAccessResponse,
  zGitOpsSourcesUpdateGitBody,
  zGitOpsSourcesUpdateGitPath,
  zGitOpsSourcesUpdateGitResponse,
  zGitOpsSourceWorkflowsListPath,
  zGitOpsSourceWorkflowsListResponse,
  zGitOpsWorkflowDestroyPath,
  zGitOpsWorkflowDestroyResponse,
  zGitOpsWorkflowDetachPath,
  zGitOpsWorkflowDetachResponse,
  zGitOpsWorkflowGetPath,
  zGitOpsWorkflowGetResponse,
  zGitOpsWorkflowsListQuery,
  zGitOpsWorkflowsListResponse,
  zGitOpsWorkflowsSummaryResponse,
  zHelmDeletePath,
  zHelmDeleteQuery,
  zHelmDeleteResponse,
  zHelmGetHistoryPath,
  zHelmGetHistoryQuery,
  zHelmGetHistoryResponse,
  zHelmGetPath,
  zHelmGetQuery,
  zHelmGetResponse,
  zHelmGitDryRunBody,
  zHelmGitDryRunPath,
  zHelmGitDryRunResponse,
  zHelmInstallBody,
  zHelmInstallPath,
  zHelmInstallQuery,
  zHelmInstallResponse,
  zHelmListPath,
  zHelmListQuery,
  zHelmListResponse,
  zHelmRepoSearchQuery,
  zHelmRepoSearchResponse,
  zHelmRollbackPath,
  zHelmRollbackQuery,
  zHelmRollbackResponse,
  zHelmShowPath,
  zHelmShowQuery,
  zHelmShowResponse,
  zHelmUserRepositoriesListPath,
  zHelmUserRepositoriesListResponse,
  zHelmUserRepositoryCreateBody,
  zHelmUserRepositoryCreatePath,
  zHelmUserRepositoryCreateResponse,
  zHelmUserRepositoryDeletePath,
  zHelmUserRepositoryDeleteResponse,
  zKubernetesNamespacesToggleSystemBody,
  zKubernetesNamespacesToggleSystemPath,
  zKubernetesNamespacesToggleSystemResponse,
  zLdapAdminGroupsBody,
  zLdapAdminGroupsResponse,
  zLdapCheckBody,
  zLdapCheckResponse,
  zLdapGroupsBody,
  zLdapGroupsResponse,
  zLdapTestLoginBody,
  zLdapTestLoginResponse2,
  zLdapUsersBody,
  zLdapUsersResponse,
  zLicensesAttachBody,
  zLicensesAttachQuery,
  zLicensesAttachResponse,
  zLicensesDeleteBody,
  zLicensesInfoResponse,
  zLicensesListResponse,
  zLocalBackupSettingsFetchResponse,
  zLocalBackupStatusFetchResponse,
  zLogoutResponse,
  zLogsCsvQuery,
  zLogsListQuery,
  zLogsListResponse,
  zMotdResponse,
  zNamespacesAccessUpdateBody,
  zNamespacesAccessUpdatePath,
  zNamespacesAccessUpdateResponse,
  zObservabilityEnvironmentLogsPath,
  zObservabilityEnvironmentLogsQuery,
  zObservabilityEnvironmentLogsResponse,
  zObservabilityEnvironmentMetricsPath,
  zObservabilityEnvironmentMetricsQuery,
  zObservabilityEnvironmentMetricsResponse,
  zOmniCancelProvisioningBody,
  zOmniCancelProvisioningPath,
  zOmniCancelProvisioningResponse,
  zOmniCreateClusterBody,
  zOmniCreateClusterPath,
  zOmniCreateClusterResponse,
  zOmniDeleteClusterPath,
  zOmniDeleteClusterQuery,
  zOmniDeleteClusterResponse,
  zOmniGetClusterPath,
  zOmniGetClusterResponse,
  zOmniGetK8sVersionUpgradeStatusPath,
  zOmniGetK8sVersionUpgradeStatusResponse,
  zOmniGetMachineLogsPath,
  zOmniGetMachineLogsResponse,
  zOmniGetMachinePath,
  zOmniGetMachineResponse,
  zOmniGetSupportedTalosVersionsPath,
  zOmniGetSupportedTalosVersionsResponse,
  zOmniGetTalosVersionUpgradeStatusPath,
  zOmniGetTalosVersionUpgradeStatusResponse,
  zOmniListMachinesPath,
  zOmniListMachinesQuery,
  zOmniListMachinesResponse,
  zOmniRebootNodePath,
  zOmniRebootNodeQuery,
  zOmniRebootNodeResponse,
  zOmniUpdateClusterBody,
  zOmniUpdateClusterPath,
  zOmniUpdateClusterResponse,
  zOmniValidateClusterBody,
  zOmniValidateClusterPath,
  zOmniValidateClusterResponse,
  zOmniValidateServiceAccountQuery,
  zPatchKubernetesDeploymentBody,
  zPatchKubernetesDeploymentPath,
  zPatchKubernetesDeploymentResponse,
  zPolicyConflictsBody,
  zPolicyConflictsResponse,
  zPolicyCreateBody,
  zPolicyCreateResponse,
  zPolicyDeletePath,
  zPolicyDeleteResponse,
  zPolicyInspectPath,
  zPolicyInspectResponse,
  zPolicyListResponse,
  zPolicyMetadataResponse,
  zPolicyTemplateInspectPath,
  zPolicyTemplateInspectResponse,
  zPolicyTemplateListQuery,
  zPolicyTemplateListResponse,
  zPolicyTestObservabilityConnectionBody,
  zPolicyTestObservabilityConnectionResponse,
  zPolicyUpdateBody,
  zPolicyUpdatePath,
  zPolicyUpdateResponse,
  zRecommendationListQuery,
  zRecommendationListResponse,
  zRecommendationSummaryResponse,
  zRegistryConfigureBody,
  zRegistryConfigurePath,
  zRegistryConfigureResponse,
  zRegistryCreateBody,
  zRegistryCreateResponse,
  zRegistryDeletePath,
  zRegistryDeleteResponse,
  zRegistryInspectPath,
  zRegistryInspectQuery,
  zRegistryInspectResponse,
  zRegistryListResponse,
  zRegistryPingBody,
  zRegistryPingResponse,
  zRegistryUpdateBody,
  zRegistryUpdatePath,
  zRegistryUpdateResponse,
  zRemoteUpdatesAgentVersionsResponse,
  zRepositoryTagsDeleteBody,
  zRepositoryTagsDeletePath,
  zRepositoryTagsDeleteResponse,
  zRepositoryTagsDetailsPath,
  zRepositoryTagsDetailsQuery,
  zRepositoryTagsDetailsResponse,
  zResizeKubernetesPersistentVolumeClaimBody,
  zResizeKubernetesPersistentVolumeClaimPath,
  zResizeKubernetesPersistentVolumeClaimResponse,
  zResourceControlCreateBody,
  zResourceControlCreateResponse,
  zResourceControlDeletePath,
  zResourceControlDeleteResponse,
  zResourceControlUpdateBody,
  zResourceControlUpdatePath,
  zResourceControlUpdateResponse,
  zRestartKubernetesApplicationPath,
  zRestartKubernetesApplicationResponse,
  zRestartKubernetesPodPath,
  zRestartKubernetesPodResponse,
  zRestoreBody,
  zRestoreFromAzureBlobBody,
  zRestoreFromAzureBlobHeaders,
  zRestoreFromS3Body,
  zRestoreFromS3Headers,
  zRestoreHeaders,
  zRoleListResponse,
  zRollbackKubernetesDeploymentBody,
  zRollbackKubernetesDeploymentPath,
  zRollbackKubernetesDeploymentResponse,
  zRunLocalBackupNowResponse,
  zScaleKubernetesDeploymentBody,
  zScaleKubernetesDeploymentPath,
  zScaleKubernetesDeploymentResponse,
  zServiceImageStatusClearPath,
  zServiceImageStatusClearResponse,
  zServiceImageStatusPath,
  zServiceImageStatusQuery,
  zServiceImageStatusResponse,
  zSetDebugLogStatusBody,
  zSetDebugLogStatusResponse,
  zSetDefaultKubernetesStorageClassPath,
  zSetDefaultKubernetesStorageClassResponse,
  zSettingsAdditionalFunctionalityInspectResponse,
  zSettingsAdditionalFunctionalityUpdateBody,
  zSettingsAdditionalFunctionalityUpdateResponse,
  zSettingsEdgeMtlscaCertificatesResponse,
  zSettingsEdgeMtlsCertificatesResponse,
  zSettingsExperimentalInspectResponse,
  zSettingsExperimentalUpdateBody,
  zSettingsExperimentalUpdateResponse,
  zSettingsInspectResponse,
  zSettingsPublicResponse,
  zSettingsUpdateBody,
  zSettingsUpdateResponse,
  zSharedGitDeletePath,
  zSharedGitDeleteResponse,
  zSharedGitGetAllResponse,
  zSharedGitGetPath,
  zSharedGitUpdatePath,
  zSnapshotContainerInspectPath,
  zSnapshotContainerInspectResponse,
  zSnapshotContainersListPath,
  zSnapshotContainersListQuery,
  zSnapshotContainersListResponse,
  zSnapshotInspectPath,
  zSnapshotInspectResponse,
  zSslInspectResponse,
  zSslUpdateBody,
  zSslUpdateResponse,
  zStackAssociatePath,
  zStackAssociateQuery,
  zStackAssociateResponse,
  zStackConvertBody,
  zStackConvertPath,
  zStackConvertResponse,
  zStackCreateDockerStandaloneFileBody,
  zStackCreateDockerStandaloneFileQuery,
  zStackCreateDockerStandaloneFileResponse,
  zStackCreateDockerStandaloneRepositoryBody,
  zStackCreateDockerStandaloneRepositoryQuery,
  zStackCreateDockerStandaloneRepositoryResponse,
  zStackCreateDockerStandaloneStringBody,
  zStackCreateDockerStandaloneStringQuery,
  zStackCreateDockerStandaloneStringResponse,
  zStackCreateDockerSwarmFileBody,
  zStackCreateDockerSwarmFileQuery,
  zStackCreateDockerSwarmFileResponse,
  zStackCreateDockerSwarmRepositoryBody,
  zStackCreateDockerSwarmRepositoryQuery,
  zStackCreateDockerSwarmRepositoryResponse,
  zStackCreateDockerSwarmStringBody,
  zStackCreateDockerSwarmStringQuery,
  zStackCreateDockerSwarmStringResponse,
  zStackCreateKubernetesFileBody,
  zStackCreateKubernetesFileQuery,
  zStackCreateKubernetesFileResponse,
  zStackCreateKubernetesGitBody,
  zStackCreateKubernetesGitQuery,
  zStackCreateKubernetesGitResponse,
  zStackCreateKubernetesUrlBody,
  zStackCreateKubernetesUrlQuery,
  zStackCreateKubernetesUrlResponse,
  zStackDeleteKubernetesByNamePath,
  zStackDeleteKubernetesByNameQuery,
  zStackDeleteKubernetesByNameResponse,
  zStackDeletePath,
  zStackDeleteQuery,
  zStackDeleteResponse,
  zStackFileInspectPath,
  zStackFileInspectQuery,
  zStackFileInspectResponse,
  zStackGitRedeployBody,
  zStackGitRedeployPath,
  zStackGitRedeployQuery,
  zStackGitRedeployResponse,
  zStackImagesStatusPath,
  zStackImagesStatusQuery,
  zStackImagesStatusResponse,
  zStackInspectPath,
  zStackInspectResponse,
  zStackListQuery,
  zStackListResponse,
  zStackMigrateBody,
  zStackMigratePath,
  zStackMigrateQuery,
  zStackMigrateResponse,
  zStacksImageStatusClearQuery,
  zStacksImageStatusClearResponse,
  zStackStartPath,
  zStackStartQuery,
  zStackStartResponse,
  zStackStopPath,
  zStackStopQuery,
  zStackStopResponse,
  zStacksWebhookInvokePath,
  zStacksWebhookInvokeResponse2,
  zStackUpdateBody,
  zStackUpdateGitBody,
  zStackUpdateGitPath,
  zStackUpdateGitQuery,
  zStackUpdateGitResponse,
  zStackUpdatePath,
  zStackUpdateQuery,
  zStackUpdateResponse,
  zSystemInfoResponse,
  zSystemNodesCountResponse,
  zSystemStatusResponse,
  zSystemUpdateResponse,
  zSystemVersionResponse,
  zTagCreateBody,
  zTagCreateResponse,
  zTagDeletePath,
  zTagDeleteResponse,
  zTagListResponse,
  zTeamCreateBody,
  zTeamCreateResponse,
  zTeamDeletePath,
  zTeamDeleteResponse,
  zTeamInspectPath,
  zTeamInspectResponse,
  zTeamListQuery,
  zTeamListResponse,
  zTeamMembershipCreateBody,
  zTeamMembershipCreateResponse,
  zTeamMembershipDeletePath,
  zTeamMembershipDeleteResponse,
  zTeamMembershipListResponse,
  zTeamMembershipsPath,
  zTeamMembershipsResponse,
  zTeamMembershipUpdateBody,
  zTeamMembershipUpdatePath,
  zTeamMembershipUpdateResponse,
  zTeamUpdateBody,
  zTeamUpdatePath,
  zTeamUpdateResponse,
  zTemplateFilePath,
  zTemplateFileResponse,
  zTemplateListResponse,
  zTestAlertManagerConnectivityQuery,
  zTestAlertManagerConnectivityResponse,
  zTrustEdgeEndpointsBody,
  zTrustEdgeEndpointsResponse,
  zUpdateAlertingSettingsBody,
  zUpdateAlertingSettingsResponse,
  zUpdateAlertRuleBody,
  zUpdateAlertRuleGroupsBody,
  zUpdateAlertRuleGroupsPath,
  zUpdateAlertRuleGroupsResponse,
  zUpdateAlertRulePath,
  zUpdateAlertRuleResponse,
  zUpdateAlertRuleTiersBody,
  zUpdateAlertRuleTiersPath,
  zUpdateAlertRuleTiersResponse,
  zUpdateAzureBlobSettingsBody,
  zUpdateK8sPodSecurityRulePath,
  zUpdateKubernetesConfigMapBody,
  zUpdateKubernetesConfigMapPath,
  zUpdateKubernetesConfigMapResponse,
  zUpdateKubernetesDeploymentBody,
  zUpdateKubernetesDeploymentPath,
  zUpdateKubernetesDeploymentResponse,
  zUpdateKubernetesIngressBody,
  zUpdateKubernetesIngressControllersBody,
  zUpdateKubernetesIngressControllersByNamespaceBody,
  zUpdateKubernetesIngressControllersByNamespacePath,
  zUpdateKubernetesIngressControllersByNamespaceResponse,
  zUpdateKubernetesIngressControllersPath,
  zUpdateKubernetesIngressControllersResponse,
  zUpdateKubernetesIngressPath,
  zUpdateKubernetesIngressResponse,
  zUpdateKubernetesNamespaceBody,
  zUpdateKubernetesNamespaceDeprecatedBody,
  zUpdateKubernetesNamespaceDeprecatedPath,
  zUpdateKubernetesNamespaceDeprecatedResponse,
  zUpdateKubernetesNamespacePath,
  zUpdateKubernetesNamespaceResponse,
  zUpdateKubernetesPersistentVolumeReclaimPolicyBody,
  zUpdateKubernetesPersistentVolumeReclaimPolicyPath,
  zUpdateKubernetesPersistentVolumeReclaimPolicyResponse,
  zUpdateKubernetesSecretBody,
  zUpdateKubernetesSecretPath,
  zUpdateKubernetesSecretResponse,
  zUpdateKubernetesServiceAccountImagePullSecretsBody,
  zUpdateKubernetesServiceAccountImagePullSecretsPath,
  zUpdateKubernetesServiceAccountImagePullSecretsResponse,
  zUpdateKubernetesServiceBody,
  zUpdateKubernetesServicePath,
  zUpdateKubernetesServiceResponse,
  zUpdateLocalBackupSettingsBody,
  zUpdateS3SettingsBody,
  zUpgradePath,
  zUploadTlsBody,
  zUploadTlsPath,
  zUploadTlsResponse,
  zUserAdminCheckResponse,
  zUserAdminInitBody,
  zUserAdminInitHeaders,
  zUserAdminInitResponse,
  zUserCreateBody,
  zUserCreateResponse,
  zUserDeletePath,
  zUserDeleteResponse,
  zUserEffectiveAccessInspectPath,
  zUserEffectiveAccessInspectResponse,
  zUserGenerateApiKeyBody,
  zUserGenerateApiKeyPath,
  zUserGenerateApiKeyResponse,
  zUserGetApiKeysPath,
  zUserGetApiKeysResponse,
  zUserInspectPath,
  zUserInspectResponse,
  zUserListQuery,
  zUserListResponse,
  zUserMembershipsInspectPath,
  zUserMembershipsInspectResponse,
  zUserMembershipsSyncPath,
  zUserMembershipsSyncResponse,
  zUserNamespacesPath,
  zUserNamespacesResponse,
  zUserRemoveApiKeyPath,
  zUserRemoveApiKeyResponse,
  zUserUpdateBody,
  zUserUpdatePasswordBody,
  zUserUpdatePasswordPath,
  zUserUpdatePasswordResponse,
  zUserUpdatePath,
  zUserUpdateResponse,
  zValidateOAuthBody,
  zValidateOAuthResponse,
  zWebhookCreateBody,
  zWebhookCreateResponse,
  zWebhookDeletePath,
  zWebhookExecutePath,
  zWebhookListQuery,
  zWebhookListResponse,
  zWebhookReassignBody,
  zWebhookReassignPath,
  zWebhookReassignResponse,
  zWebhookUpdateBody,
  zWebhookUpdatePath,
  zWebhookUpdateResponse,
  zWebsocketAttachQuery,
  zWebsocketExecQuery,
  zWebsocketKubernetesShellQuery,
  zWebsocketNodeShellExecQuery,
  zWebsocketPodExecQuery,
  zWorkflowCreateBody,
  zWorkflowCreateResponse,
  zWorkflowUpdateBody,
  zWorkflowUpdatePath,
  zWorkflowUpdateResponse,
} from './zod.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Read the calling addon's stored configuration
 *
 * Read the configuration the calling addon has stored. The addon is identified
 * by its instance token, so no identifier appears in the path. Values are
 * returned in full: this is how an addon loads the secrets it runs on.
 * **Access policy**: addon instance token
 */
export const addonStoreConfigList = <ThrowOnError extends boolean = true>(
  options?: Options<AddonStoreConfigListData, ThrowOnError>
): RequestResult<
  AddonStoreConfigListResponses,
  AddonStoreConfigListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AddonStoreConfigListResponses,
    AddonStoreConfigListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonStoreConfigListResponse.parseAsync(data),
    url: '/addon-store/v1/config',
    ...options,
  });

/**
 * Replace the calling addon's stored configuration
 *
 * Replace the full set of configuration entries: entries absent from the
 * request are removed. A sensitive entry may omit its value to keep the
 * stored one.
 * **Access policy**: addon instance token
 */
export const addonStoreConfigUpdate = <ThrowOnError extends boolean = true>(
  options: Options<AddonStoreConfigUpdateData, ThrowOnError>
): RequestResult<
  AddonStoreConfigUpdateResponses,
  AddonStoreConfigUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AddonStoreConfigUpdateResponses,
    AddonStoreConfigUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAddonStoreConfigUpdateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonStoreConfigUpdateResponse.parseAsync(data),
    url: '/addon-store/v1/config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove one of the calling addon's configuration entries
 *
 * Remove one configuration entry.
 * **Access policy**: addon instance token
 */
export const addonStoreConfigEntryDelete = <
  ThrowOnError extends boolean = true,
>(
  options: Options<AddonStoreConfigEntryDeleteData, ThrowOnError>
): RequestResult<
  AddonStoreConfigEntryDeleteResponses,
  AddonStoreConfigEntryDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AddonStoreConfigEntryDeleteResponses,
    AddonStoreConfigEntryDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonStoreConfigEntryDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonStoreConfigEntryDeleteResponse.parseAsync(data),
    url: '/addon-store/v1/config/{key}',
    ...options,
  });

/**
 * Set one of the calling addon's configuration entries
 *
 * Set or update one configuration entry, leaving the others untouched.
 * A sensitive entry may omit its value to keep the stored one.
 * **Access policy**: addon instance token
 */
export const addonStoreConfigEntryUpdate = <
  ThrowOnError extends boolean = true,
>(
  options: Options<AddonStoreConfigEntryUpdateData, ThrowOnError>
): RequestResult<
  AddonStoreConfigEntryUpdateResponses,
  AddonStoreConfigEntryUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AddonStoreConfigEntryUpdateResponses,
    AddonStoreConfigEntryUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAddonStoreConfigEntryUpdateBody,
          path: zAddonStoreConfigEntryUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonStoreConfigEntryUpdateResponse.parseAsync(data),
    url: '/addon-store/v1/config/{key}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List addons
 *
 * List the addons the calling user may open. Administrators receive
 * every catalog addon together with its persisted record (enabled
 * state, chart version and access policies); other users receive
 * only the addons the gateway would let them access, without the
 * record.
 * Pass view=switcher for the lightweight app-switcher listing: only
 * the installed, enabled addons the caller may launch, without the
 * record, available versions or health probe.
 * **Access policy**: authenticated
 */
export const addonList = <ThrowOnError extends boolean = true>(
  options?: Options<AddonListData, ThrowOnError>
): RequestResult<AddonListResponses, AddonListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AddonListResponses,
    AddonListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zAddonListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons',
    ...options,
  });

/**
 * Uninstall an addon
 *
 * Uninstall an addon's Helm release from the cluster Portainer is
 * running in. The addon record is returned in the uninstalling
 * state; the uninstall runs in the background and the record is
 * removed once it completes. Uninstalling an addon that is not
 * installed is a no-op. An in-flight install or upgrade can be
 * uninstalled; only an uninstall already in progress is rejected
 * with 409 unless force=true is set, which is the recovery path for
 * an addon stuck by a restart.
 *
 * The addon's stored configuration is retained by default, so
 * reinstalling restores its settings — including any value the addon's
 * own data depends on, such as an encryption key. Set pruneConfig=true
 * to discard it as well; that is not reversible.
 * **Access policy**: administrator
 */
export const addonUninstall = <ThrowOnError extends boolean = true>(
  options: Options<AddonUninstallData, ThrowOnError>
): RequestResult<AddonUninstallResponses, AddonUninstallErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AddonUninstallResponses,
    AddonUninstallErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonUninstallPath,
          query: zAddonUninstallQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonUninstallResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}',
    ...options,
  });

/**
 * Inspect an addon
 *
 * Retrieve a single addon the calling user may open. Administrators
 * receive the catalog metadata together with the persisted record
 * (enabled state, chart version and access policies); other users
 * receive only the catalog metadata, and a 404 if the gateway
 * would not let them access the addon.
 * **Access policy**: authenticated
 */
export const addonDetail = <ThrowOnError extends boolean = true>(
  options: Options<AddonDetailData, ThrowOnError>
): RequestResult<AddonDetailResponses, AddonDetailErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AddonDetailResponses,
    AddonDetailErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonDetailPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonDetailResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}',
    ...options,
  });

/**
 * Install or upgrade an addon
 *
 * Install a catalog addon as a Helm release into the cluster Portainer
 * is running in, or upgrade it when already installed. The addon record
 * is returned immediately in the installing state for a fresh install
 * or the upgrading state for an already-installed addon; the operation
 * runs in the background and its progress is reflected in the record's status.
 * **Access policy**: administrator
 */
export const addonInstall = <ThrowOnError extends boolean = true>(
  options: Options<AddonInstallData, ThrowOnError>
): RequestResult<AddonInstallResponses, AddonInstallErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddonInstallResponses,
    AddonInstallErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAddonInstallBody.optional(),
          path: zAddonInstallPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonInstallResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update an addon's access configuration
 *
 * Enable or disable an addon and configure which users and teams may access it.
 * **Access policy**: administrator
 */
export const addonAccessUpdate = <ThrowOnError extends boolean = true>(
  options: Options<AddonAccessUpdateData, ThrowOnError>
): RequestResult<
  AddonAccessUpdateResponses,
  AddonAccessUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AddonAccessUpdateResponses,
    AddonAccessUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAddonAccessUpdateBody,
          path: zAddonAccessUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonAccessUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/access',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check where an addon's chart is pulled from
 *
 * Check whether Portainer can read an addon's Helm chart, and list the
 * versions published there. With no query parameters the addon's catalog
 * chart is checked; registryId and chart together check a chart held in a
 * Portainer registry, which is how an install in an air-gapped environment
 * is pointed at a mirror.
 * An unreachable source is reported as a reason rather than an error, so the
 * install form can show it against the chart location field.
 * **Access policy**: administrator
 */
export const addonChartSource = <ThrowOnError extends boolean = true>(
  options: Options<AddonChartSourceData, ThrowOnError>
): RequestResult<
  AddonChartSourceResponses,
  AddonChartSourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AddonChartSourceResponses,
    AddonChartSourceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonChartSourcePath,
          query: zAddonChartSourceQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonChartSourceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/chart-source',
    ...options,
  });

/**
 * Remove all of an addon's stored configuration
 *
 * Remove every configuration entry stored for an addon. This triggers no
 * redeploy.
 * **Access policy**: administrator
 */
export const addonConfigDelete = <ThrowOnError extends boolean = true>(
  options: Options<AddonConfigDeleteData, ThrowOnError>
): RequestResult<
  AddonConfigDeleteResponses,
  AddonConfigDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AddonConfigDeleteResponses,
    AddonConfigDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonConfigDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonConfigDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/config',
    ...options,
  });

/**
 * List an addon's stored configuration
 *
 * List the configuration entries stored for an addon. Values are returned
 * in full, including secrets, since this is how the addon reads its own
 * configuration back; sensitive entries are flagged so a client can display
 * them carefully. Portainer does not interpret these entries.
 * **Access policy**: administrator
 */
export const addonConfigList = <ThrowOnError extends boolean = true>(
  options: Options<AddonConfigListData, ThrowOnError>
): RequestResult<
  AddonConfigListResponses,
  AddonConfigListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AddonConfigListResponses,
    AddonConfigListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonConfigListPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonConfigListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/config',
    ...options,
  });

/**
 * Replace an addon's stored configuration
 *
 * Replace the full set of configuration entries: entries absent from the
 * request are removed. A sensitive entry may omit its value to keep the
 * stored one. Saving only stores; it triggers no redeploy.
 * **Access policy**: administrator
 */
export const addonConfigUpdate = <ThrowOnError extends boolean = true>(
  options: Options<AddonConfigUpdateData, ThrowOnError>
): RequestResult<
  AddonConfigUpdateResponses,
  AddonConfigUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AddonConfigUpdateResponses,
    AddonConfigUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAddonConfigUpdateBody,
          path: zAddonConfigUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonConfigUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a single addon configuration entry
 *
 * Remove one configuration entry. This triggers no redeploy.
 * **Access policy**: administrator
 */
export const addonConfigEntryDelete = <ThrowOnError extends boolean = true>(
  options: Options<AddonConfigEntryDeleteData, ThrowOnError>
): RequestResult<
  AddonConfigEntryDeleteResponses,
  AddonConfigEntryDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AddonConfigEntryDeleteResponses,
    AddonConfigEntryDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonConfigEntryDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonConfigEntryDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/config/{key}',
    ...options,
  });

/**
 * Set a single addon configuration entry
 *
 * Set or update one configuration entry, leaving the others untouched.
 * A sensitive entry may omit its value to keep the stored one, as on the
 * full-set update. Saving only stores; it triggers no redeploy.
 * **Access policy**: administrator
 */
export const addonConfigEntryUpdate = <ThrowOnError extends boolean = true>(
  options: Options<AddonConfigEntryUpdateData, ThrowOnError>
): RequestResult<
  AddonConfigEntryUpdateResponses,
  AddonConfigEntryUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AddonConfigEntryUpdateResponses,
    AddonConfigEntryUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAddonConfigEntryUpdateBody,
          path: zAddonConfigEntryUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonConfigEntryUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/config/{key}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Repair an addon's credential
 *
 * Mint a fresh credential for an installed addon and republish it to the
 * cluster, along with the certificate the addon verifies Portainer's TLS
 * with. The addon's stored configuration is untouched.
 *
 * The recovery path for an addon that is running but can no longer
 * authenticate: a database restored from before the credential was issued, a
 * Secret deleted by hand, or a replaced Portainer certificate. The credential
 * is stored hashed, so Portainer cannot tell which side is stale; repairing
 * replaces both, needing no diagnosis and no uninstall.
 *
 * Not a Helm operation: nothing is redeployed. The addon picks the new
 * credential up once Kubernetes propagates the Secret to its pod.
 * **Access policy**: administrator
 */
export const addonRepair = <ThrowOnError extends boolean = true>(
  options: Options<AddonRepairData, ThrowOnError>
): RequestResult<AddonRepairResponses, AddonRepairErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddonRepairResponses,
    AddonRepairErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAddonRepairPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonRepairResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/{id}/repair',
    ...options,
  });

/**
 * Retrieve the environment addon resources can be read through
 *
 * Return the connected environment that points at the cluster
 * Portainer runs in, the cluster addons install into. It is verified
 * against the cluster's own identity rather than inferred from its
 * type, so it is never a different cluster. environmentId is 0 when
 * none could be verified, which does not affect installed addons.
 * **Access policy**: administrator
 */
export const addonEnvironment = <ThrowOnError extends boolean = true>(
  options?: Options<AddonEnvironmentData, ThrowOnError>
): RequestResult<
  AddonEnvironmentResponses,
  AddonEnvironmentErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AddonEnvironmentResponses,
    AddonEnvironmentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAddonEnvironmentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/addons/environment',
    ...options,
  });

/**
 * Retrieve the URL allow list
 *
 * Retrieve the list of allowed URLs for outbound proxy requests.
 * **Access policy**: administrator
 */
export const allowListInspect = <ThrowOnError extends boolean = true>(
  options: Options<AllowListInspectData, ThrowOnError>
): RequestResult<
  AllowListInspectResponses,
  AllowListInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AllowListInspectResponses,
    AllowListInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zAllowListInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAllowListInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/allowlist/{id}',
    ...options,
  });

/**
 * Update the URL allow list
 *
 * Update the list of allowed URLs for outbound proxy requests.
 * **Access policy**: administrator
 */
export const allowListUpdate = <ThrowOnError extends boolean = true>(
  options: Options<AllowListUpdateData, ThrowOnError>
): RequestResult<
  AllowListUpdateResponses,
  AllowListUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AllowListUpdateResponses,
    AllowListUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAllowListUpdateBody,
          path: zAllowListUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAllowListUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/allowlist/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Authenticate
 *
 * **Access policy**: public
 * Use this environment(endpoint) to authenticate against Portainer using a username and password.
 */
export const authenticateUser = <ThrowOnError extends boolean = true>(
  options: Options<AuthenticateUserData, ThrowOnError>
): RequestResult<
  AuthenticateUserResponses,
  AuthenticateUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthenticateUserResponses,
    AuthenticateUserErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAuthenticateUserBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAuthenticateUserResponse.parseAsync(data),
    url: '/auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Logout
 *
 * **Access policy**: public
 */
export const logout = <ThrowOnError extends boolean = true>(
  options?: Options<LogoutData, ThrowOnError>
): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>(
    {
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseValidator: async (data) => await zLogoutResponse.parseAsync(data),
      security: [
        { name: 'X-API-KEY', type: 'apiKey' },
        { name: 'Authorization', type: 'apiKey' },
      ],
      url: '/auth/logout',
      ...options,
    }
  );

/**
 * Authenticate with OAuth
 *
 * **Access policy**: public
 */
export const validateOAuth = <ThrowOnError extends boolean = true>(
  options: Options<ValidateOAuthData, ThrowOnError>
): RequestResult<ValidateOAuthResponses, ValidateOAuthErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ValidateOAuthResponses,
    ValidateOAuthErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zValidateOAuthBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zValidateOAuthResponse.parseAsync(data),
    url: '/auth/oauth/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List auto updates
 *
 * **Access policy**: administrator
 */
export const autoUpdateList = <ThrowOnError extends boolean = true>(
  options?: Options<AutoUpdateListData, ThrowOnError>
): RequestResult<AutoUpdateListResponses, AutoUpdateListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AutoUpdateListResponses,
    AutoUpdateListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAutoUpdateListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/auto_updates',
    ...options,
  });

/**
 * Creates an archive with a system data snapshot that could be used to restore the system.
 *
 * Creates an archive with a system data snapshot that could be used to restore the system.
 * **Access policy**: admin
 */
export const backup = <ThrowOnError extends boolean = true>(
  options?: Options<BackupData, ThrowOnError>
): RequestResult<BackupResponses, BackupErrors, ThrowOnError> =>
  (options?.client ?? client).post<BackupResponses, BackupErrors, ThrowOnError>(
    {
      requestValidator: async (data) =>
        await z
          .object({
            body: zBackupBody.optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      security: [
        { name: 'X-API-KEY', type: 'apiKey' },
        { name: 'Authorization', type: 'apiKey' },
      ],
      url: '/backup',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    }
  );

/**
 * Execute an ad-hoc backup to Azure Blob Storage
 *
 * Creates a system snapshot archive and uploads it to the configured Azure Blob container
 * **Access policy**: administrator
 */
export const backupToAzureBlob = <ThrowOnError extends boolean = true>(
  options: Options<BackupToAzureBlobData, ThrowOnError>
): RequestResult<
  BackupToAzureBlobResponses,
  BackupToAzureBlobErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BackupToAzureBlobResponses,
    BackupToAzureBlobErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zBackupToAzureBlobBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zBackupToAzureBlobResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/azure/execute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Restore system state from an Azure Blob Storage backup
 *
 * **Access policy**: public (requires the X-Setup-Token header on an uninitialized instance unless --no-setup-token is set)
 */
export const restoreFromAzureBlob = <ThrowOnError extends boolean = true>(
  options: Options<RestoreFromAzureBlobData, ThrowOnError>
): RequestResult<
  RestoreFromAzureBlobResponses,
  RestoreFromAzureBlobErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RestoreFromAzureBlobResponses,
    RestoreFromAzureBlobErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRestoreFromAzureBlobBody,
          headers: zRestoreFromAzureBlobHeaders.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    url: '/backup/azure/restore',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetch Azure Blob Storage backup settings
 *
 * **Access policy**: administrator
 */
export const azureBlobBackupSettingsFetch = <
  ThrowOnError extends boolean = true,
>(
  options?: Options<AzureBlobBackupSettingsFetchData, ThrowOnError>
): RequestResult<
  AzureBlobBackupSettingsFetchResponses,
  AzureBlobBackupSettingsFetchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AzureBlobBackupSettingsFetchResponses,
    AzureBlobBackupSettingsFetchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAzureBlobBackupSettingsFetchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/azure/settings',
    ...options,
  });

/**
 * Update Azure Blob Storage backup settings and reschedule cron job
 *
 * **Access policy**: administrator
 */
export const updateAzureBlobSettings = <ThrowOnError extends boolean = true>(
  options?: Options<UpdateAzureBlobSettingsData, ThrowOnError>
): RequestResult<
  UpdateAzureBlobSettingsResponses,
  UpdateAzureBlobSettingsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    UpdateAzureBlobSettingsResponses,
    UpdateAzureBlobSettingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateAzureBlobSettingsBody.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/azure/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Fetch the status of the last scheduled Azure Blob backup run
 *
 * **Access policy**: public
 */
export const azureBlobBackupStatusFetch = <ThrowOnError extends boolean = true>(
  options?: Options<AzureBlobBackupStatusFetchData, ThrowOnError>
): RequestResult<
  AzureBlobBackupStatusFetchResponses,
  AzureBlobBackupStatusFetchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AzureBlobBackupStatusFetchResponses,
    AzureBlobBackupStatusFetchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAzureBlobBackupStatusFetchResponse.parseAsync(data),
    url: '/backup/azure/status',
    ...options,
  });

/**
 * Test connectivity to an Azure Blob Storage container
 *
 * Verifies that the supplied credentials can reach and access the target container
 * **Access policy**: administrator
 */
export const azureBlobTestConnection = <ThrowOnError extends boolean = true>(
  options: Options<AzureBlobTestConnectionData, ThrowOnError>
): RequestResult<
  AzureBlobTestConnectionResponses,
  AzureBlobTestConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AzureBlobTestConnectionResponses,
    AzureBlobTestConnectionErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zAzureBlobTestConnectionBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zAzureBlobTestConnectionResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/azure/test',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Trigger an immediate local backup outside of the cron schedule
 *
 * **Access policy**: administrator
 */
export const runLocalBackupNow = <ThrowOnError extends boolean = true>(
  options?: Options<RunLocalBackupNowData, ThrowOnError>
): RequestResult<
  RunLocalBackupNowResponses,
  RunLocalBackupNowErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RunLocalBackupNowResponses,
    RunLocalBackupNowErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zRunLocalBackupNowResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/local/run',
    ...options,
  });

/**
 * Fetch local scheduled backup settings
 *
 * **Access policy**: administrator
 */
export const localBackupSettingsFetch = <ThrowOnError extends boolean = true>(
  options?: Options<LocalBackupSettingsFetchData, ThrowOnError>
): RequestResult<
  LocalBackupSettingsFetchResponses,
  LocalBackupSettingsFetchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    LocalBackupSettingsFetchResponses,
    LocalBackupSettingsFetchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zLocalBackupSettingsFetchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/local/settings',
    ...options,
  });

/**
 * Updates local scheduled backup settings and restarts the cron job as needed
 *
 * **Access policy**: administrator
 */
export const updateLocalBackupSettings = <ThrowOnError extends boolean = true>(
  options?: Options<UpdateLocalBackupSettingsData, ThrowOnError>
): RequestResult<
  UpdateLocalBackupSettingsResponses,
  UpdateLocalBackupSettingsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    UpdateLocalBackupSettingsResponses,
    UpdateLocalBackupSettingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateLocalBackupSettingsBody.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/local/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Fetch the status of the last scheduled local backup run
 *
 * **Access policy**: administrator
 */
export const localBackupStatusFetch = <ThrowOnError extends boolean = true>(
  options?: Options<LocalBackupStatusFetchData, ThrowOnError>
): RequestResult<
  LocalBackupStatusFetchResponses,
  LocalBackupStatusFetchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    LocalBackupStatusFetchResponses,
    LocalBackupStatusFetchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zLocalBackupStatusFetchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/local/status',
    ...options,
  });

/**
 * Execute backup to AWS S3 Bucket
 *
 * Creates an archive with a system data snapshot and upload it to the target S3 bucket
 * **Access policy**: administrator
 */
export const backupToS3 = <ThrowOnError extends boolean = true>(
  options: Options<BackupToS3Data, ThrowOnError>
): RequestResult<BackupToS3Responses, BackupToS3Errors, ThrowOnError> =>
  (options.client ?? client).post<
    BackupToS3Responses,
    BackupToS3Errors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zBackupToS3Body,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zBackupToS3Response.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/s3/execute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Triggers a system restore using details of s3 backup
 *
 * Triggers a system restore using details of s3 backup
 * **Access policy**: public (requires the X-Setup-Token header on an uninitialized instance unless --no-setup-token is set)
 */
export const restoreFromS3 = <ThrowOnError extends boolean = true>(
  options?: Options<RestoreFromS3Data, ThrowOnError>
): RequestResult<RestoreFromS3Responses, RestoreFromS3Errors, ThrowOnError> =>
  (options?.client ?? client).post<
    RestoreFromS3Responses,
    RestoreFromS3Errors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRestoreFromS3Body.optional(),
          headers: zRestoreFromS3Headers.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    url: '/backup/s3/restore',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Fetch s3 backup settings/configurations
 *
 * **Access policy**: administrator
 */
export const backupSettingsFetch = <ThrowOnError extends boolean = true>(
  options?: Options<BackupSettingsFetchData, ThrowOnError>
): RequestResult<
  BackupSettingsFetchResponses,
  BackupSettingsFetchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    BackupSettingsFetchResponses,
    BackupSettingsFetchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zBackupSettingsFetchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/s3/settings',
    ...options,
  });

/**
 * Updates stored s3 backup settings and updates running cron jobs as needed
 *
 * Updates stored s3 backup settings and updates running cron jobs as needed
 * **Access policy**: administrator
 */
export const updateS3Settings = <ThrowOnError extends boolean = true>(
  options?: Options<UpdateS3SettingsData, ThrowOnError>
): RequestResult<
  UpdateS3SettingsResponses,
  UpdateS3SettingsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    UpdateS3SettingsResponses,
    UpdateS3SettingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateS3SettingsBody.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/backup/s3/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Fetch the status of the last scheduled backup run
 *
 * **Access policy**: public
 */
export const backupStatusFetch = <ThrowOnError extends boolean = true>(
  options?: Options<BackupStatusFetchData, ThrowOnError>
): RequestResult<
  BackupStatusFetchResponses,
  BackupStatusFetchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    BackupStatusFetchResponses,
    BackupStatusFetchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zBackupStatusFetchResponse.parseAsync(data),
    url: '/backup/s3/status',
    ...options,
  });

/**
 * getAll cloud credentials
 *
 * getAll cloud credential
 * **Access policy**: authenticated
 */
export const getAll = <ThrowOnError extends boolean = true>(
  options?: Options<GetAllData, ThrowOnError>
): RequestResult<GetAllResponses, GetAllErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetAllResponses, GetAllErrors, ThrowOnError>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetAllResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/credentials',
    ...options,
  });

/**
 * Create a cloud credential
 *
 * Create a cloud credential
 * **Access policy**: authenticated
 */
export const create = <ThrowOnError extends boolean = true>(
  options: Options<CreateData, ThrowOnError>
): RequestResult<CreateResponses, CreateErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateResponses, CreateErrors, ThrowOnError>({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/credentials',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete a cloud credential
 *
 * Delete a cloud credential
 * **Access policy**: authenticated
 */
export const cloudCredsDelete = <ThrowOnError extends boolean = true>(
  options: Options<CloudCredsDeleteData, ThrowOnError>
): RequestResult<
  CloudCredsDeleteResponses,
  CloudCredsDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    CloudCredsDeleteResponses,
    CloudCredsDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCloudCredsDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCloudCredsDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/credentials/{id}',
    ...options,
  });

/**
 * getByID gets a cloud credential by ID
 *
 * getByID gets a cloud credential by ID
 * **Access policy**: authenticated
 */
export const cloudCredsGetById = <ThrowOnError extends boolean = true>(
  options: Options<CloudCredsGetByIdData, ThrowOnError>
): RequestResult<
  CloudCredsGetByIdResponses,
  CloudCredsGetByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CloudCredsGetByIdResponses,
    CloudCredsGetByIdErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCloudCredsGetByIdPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCloudCredsGetByIdResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/credentials/{id}',
    ...options,
  });

/**
 * Update a cloud credential
 *
 * Update a cloud credential
 * **Access policy**: authenticated
 */
export const cloudCredsUpdate = <ThrowOnError extends boolean = true>(
  options: Options<CloudCredsUpdateData, ThrowOnError>
): RequestResult<
  CloudCredsUpdateResponses,
  CloudCredsUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CloudCredsUpdateResponses,
    CloudCredsUpdateErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zCloudCredsUpdateBody,
          path: zCloudCredsUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCloudCredsUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/credentials/{id}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Upgrade the cluster to the next stable kubernetes version.
 *
 * Upgrade the cluster to the next stable kubernetes version.
 * **Access policy**: authenticated
 */
export const upgrade = <ThrowOnError extends boolean = true>(
  options: Options<UpgradeData, ThrowOnError>
): RequestResult<UpgradeResponses, UpgradeErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UpgradeResponses,
    UpgradeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUpgradePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/endpoints/{environmentId}/upgrade',
    ...options,
  });

/**
 * Get Shared Git Credentials
 *
 * Get shared git credentials
 * **Access policy**: authenticated
 */
export const sharedGitGetAll = <ThrowOnError extends boolean = true>(
  options?: Options<SharedGitGetAllData, ThrowOnError>
): RequestResult<
  SharedGitGetAllResponses,
  SharedGitGetAllErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SharedGitGetAllResponses,
    SharedGitGetAllErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zSharedGitGetAllResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/gitcredentials',
    ...options,
  });

/**
 * Create Shared Git Credential
 *
 * Create a shared git credential
 * **Access policy**: Administrator only.
 */
export const sharedGitCreate = <ThrowOnError extends boolean = true>(
  options?: Options<SharedGitCreateData, ThrowOnError>
): RequestResult<
  SharedGitCreateResponses,
  SharedGitCreateErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SharedGitCreateResponses,
    SharedGitCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/gitcredentials',
    ...options,
  });

/**
 * Delete Shared Git Credential
 *
 * Delete a shared git credential
 * **Access policy**: Administrator only.
 */
export const sharedGitDelete = <ThrowOnError extends boolean = true>(
  options: Options<SharedGitDeleteData, ThrowOnError>
): RequestResult<
  SharedGitDeleteResponses,
  SharedGitDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    SharedGitDeleteResponses,
    SharedGitDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zSharedGitDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zSharedGitDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/gitcredentials/{id}',
    ...options,
  });

/**
 * Get a Shared Git Credential
 *
 * Get a shared git credential
 * **Access policy**: authenticated
 */
export const sharedGitGet = <ThrowOnError extends boolean = true>(
  options: Options<SharedGitGetData, ThrowOnError>
): RequestResult<SharedGitGetResponses, SharedGitGetErrors, ThrowOnError> =>
  (options.client ?? client).get<
    SharedGitGetResponses,
    SharedGitGetErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zSharedGitGetPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/gitcredentials/{id}',
    ...options,
  });

/**
 * Update a Shared Git Credential
 *
 * Update a shared git credential
 * **Access policy**: Administrator only.
 */
export const sharedGitUpdate = <ThrowOnError extends boolean = true>(
  options: Options<SharedGitUpdateData, ThrowOnError>
): RequestResult<
  SharedGitUpdateResponses,
  SharedGitUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SharedGitUpdateResponses,
    SharedGitUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zSharedGitUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/cloud/gitcredentials/{id}',
    ...options,
  });

/**
 * List available custom templates
 *
 * List available custom templates.
 * **Access policy**: authenticated
 */
export const customTemplateList = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateListData, ThrowOnError>
): RequestResult<
  CustomTemplateListResponses,
  CustomTemplateListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomTemplateListResponses,
    CustomTemplateListErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { type: { array: { explode: false } } } },
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zCustomTemplateListQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates',
    ...options,
  });

/**
 * Remove a template
 *
 * Remove a template.
 * **Access policy**: authenticated
 */
export const customTemplateDelete = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateDeleteData, ThrowOnError>
): RequestResult<
  CustomTemplateDeleteResponses,
  CustomTemplateDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    CustomTemplateDeleteResponses,
    CustomTemplateDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCustomTemplateDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zCustomTemplateDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/{id}',
    ...options,
  });

/**
 * Inspect a custom template
 *
 * Retrieve details about a template.
 * **Access policy**: authenticated
 */
export const customTemplateInspect = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateInspectData, ThrowOnError>
): RequestResult<
  CustomTemplateInspectResponses,
  CustomTemplateInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomTemplateInspectResponses,
    CustomTemplateInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCustomTemplateInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/{id}',
    ...options,
  });

/**
 * Update a template
 *
 * Update a template.
 * **Access policy**: authenticated
 */
export const customTemplateUpdate = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateUpdateData, ThrowOnError>
): RequestResult<
  CustomTemplateUpdateResponses,
  CustomTemplateUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CustomTemplateUpdateResponses,
    CustomTemplateUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCustomTemplateUpdateBody,
          path: zCustomTemplateUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Template stack file content.
 *
 * Retrieve the content of the Stack file for the specified custom template
 * **Access policy**: authenticated
 */
export const customTemplateFile = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateFileData, ThrowOnError>
): RequestResult<
  CustomTemplateFileResponses,
  CustomTemplateFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CustomTemplateFileResponses,
    CustomTemplateFileErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCustomTemplateFilePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/{id}/file',
    ...options,
  });

/**
 * Fetch the latest config file content based on custom template's git repository configuration
 *
 * Retrieve details about a template created from git repository method.
 * **Access policy**: authenticated
 */
export const customTemplateGitFetch = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateGitFetchData, ThrowOnError>
): RequestResult<
  CustomTemplateGitFetchResponses,
  CustomTemplateGitFetchErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    CustomTemplateGitFetchResponses,
    CustomTemplateGitFetchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCustomTemplateGitFetchPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateGitFetchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/{id}/git_fetch',
    ...options,
  });

/**
 * Create a custom template
 *
 * Create a custom template.
 * **Access policy**: authenticated
 */
export const customTemplateCreateFile = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateCreateFileData, ThrowOnError>
): RequestResult<
  CustomTemplateCreateFileResponses,
  CustomTemplateCreateFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CustomTemplateCreateFileResponses,
    CustomTemplateCreateFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zCustomTemplateCreateFileBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateCreateFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/create/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Create a custom template
 *
 * Create a custom template.
 * **Access policy**: authenticated
 */
export const customTemplateCreateRepository = <
  ThrowOnError extends boolean = true,
>(
  options: Options<CustomTemplateCreateRepositoryData, ThrowOnError>
): RequestResult<
  CustomTemplateCreateRepositoryResponses,
  CustomTemplateCreateRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CustomTemplateCreateRepositoryResponses,
    CustomTemplateCreateRepositoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCustomTemplateCreateRepositoryBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateCreateRepositoryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/create/repository',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a custom template
 *
 * Create a custom template.
 * **Access policy**: authenticated
 */
export const customTemplateCreateString = <ThrowOnError extends boolean = true>(
  options: Options<CustomTemplateCreateStringData, ThrowOnError>
): RequestResult<
  CustomTemplateCreateStringResponses,
  CustomTemplateCreateStringErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CustomTemplateCreateStringResponses,
    CustomTemplateCreateStringErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCustomTemplateCreateStringBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCustomTemplateCreateStringResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/custom_templates/create/string',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetch container gpus data
 *
 * **Access policy**:
 */
export const dockerContainerGpusInspect = <ThrowOnError extends boolean = true>(
  options: Options<DockerContainerGpusInspectData, ThrowOnError>
): RequestResult<
  DockerContainerGpusInspectResponses,
  DockerContainerGpusInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DockerContainerGpusInspectResponses,
    DockerContainerGpusInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDockerContainerGpusInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zDockerContainerGpusInspectResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/containers/{containerId}/gpus',
    ...options,
  });

/**
 * Fetch image status for container
 *
 * **Access policy**:
 */
export const containerImageStatus = <ThrowOnError extends boolean = true>(
  options: Options<ContainerImageStatusData, ThrowOnError>
): RequestResult<
  ContainerImageStatusResponses,
  ContainerImageStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ContainerImageStatusResponses,
    ContainerImageStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zContainerImageStatusPath,
          query: zContainerImageStatusQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zContainerImageStatusResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/containers/{containerId}/image_status',
    ...options,
  });

/**
 * Clear container image status cache
 *
 * Clear the image status cache for all containers in the environment
 * **Access policy**:
 */
export const containersImageStatusClear = <ThrowOnError extends boolean = true>(
  options: Options<ContainersImageStatusClearData, ThrowOnError>
): RequestResult<
  ContainersImageStatusClearResponses,
  ContainersImageStatusClearErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ContainersImageStatusClearResponses,
    ContainersImageStatusClearErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zContainersImageStatusClearPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zContainersImageStatusClearResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/containers/image_status/clear',
    ...options,
  });

/**
 * Get counters for the dashboard
 *
 * **Access policy**: restricted
 */
export const dockerDashboard = <ThrowOnError extends boolean = true>(
  options: Options<DockerDashboardData2, ThrowOnError>
): RequestResult<
  DockerDashboardResponses,
  DockerDashboardErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DockerDashboardResponses,
    DockerDashboardErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDockerDashboardPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zDockerDashboardResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/dashboard',
    ...options,
  });

/**
 * Fetch images
 *
 * **Access policy**:
 */
export const dockerImagesList = <ThrowOnError extends boolean = true>(
  options: Options<DockerImagesListData, ThrowOnError>
): RequestResult<
  DockerImagesListResponses,
  DockerImagesListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DockerImagesListResponses,
    DockerImagesListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDockerImagesListPath,
          query: zDockerImagesListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zDockerImagesListResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/images',
    ...options,
  });

/**
 * Fetch image status for service
 *
 * **Access policy**:
 */
export const serviceImageStatus = <ThrowOnError extends boolean = true>(
  options: Options<ServiceImageStatusData, ThrowOnError>
): RequestResult<
  ServiceImageStatusResponses,
  ServiceImageStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ServiceImageStatusResponses,
    ServiceImageStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zServiceImageStatusPath,
          query: zServiceImageStatusQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zServiceImageStatusResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/services/{serviceId}/image_status',
    ...options,
  });

/**
 * Clear service image status cache
 *
 * Clear the image status cache for all services in the environment
 * **Access policy**:
 */
export const serviceImageStatusClear = <ThrowOnError extends boolean = true>(
  options: Options<ServiceImageStatusClearData, ThrowOnError>
): RequestResult<
  ServiceImageStatusClearResponses,
  ServiceImageStatusClearErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ServiceImageStatusClearResponses,
    ServiceImageStatusClearErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zServiceImageStatusClearPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zServiceImageStatusClearResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/services/image_status/clear',
    ...options,
  });

/**
 * Fetch latest snapshot of environment
 *
 * **Access policy**:
 */
export const snapshotInspect = <ThrowOnError extends boolean = true>(
  options: Options<SnapshotInspectData, ThrowOnError>
): RequestResult<
  SnapshotInspectResponses,
  SnapshotInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SnapshotInspectResponses,
    SnapshotInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zSnapshotInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSnapshotInspectResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/snapshot',
    ...options,
  });

/**
 * Fetch containers list from a snapshot
 *
 * **Access policy**:
 */
export const snapshotContainersList = <ThrowOnError extends boolean = true>(
  options: Options<SnapshotContainersListData, ThrowOnError>
): RequestResult<
  SnapshotContainersListResponses,
  SnapshotContainersListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SnapshotContainersListResponses,
    SnapshotContainersListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zSnapshotContainersListPath,
          query: zSnapshotContainersListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSnapshotContainersListResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/snapshot/containers',
    ...options,
  });

/**
 * Fetch container from a snapshot
 *
 * **Access policy**:
 */
export const snapshotContainerInspect = <ThrowOnError extends boolean = true>(
  options: Options<SnapshotContainerInspectData, ThrowOnError>
): RequestResult<
  SnapshotContainerInspectResponses,
  SnapshotContainerInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    SnapshotContainerInspectResponses,
    SnapshotContainerInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zSnapshotContainerInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSnapshotContainerInspectResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/docker/{environmentId}/snapshot/containers/{containerId}',
    ...options,
  });

/**
 * List available Edge Configurations
 *
 * **Access policy**: authenticated
 */
export const edgeConfigList = <ThrowOnError extends boolean = true>(
  options: Options<EdgeConfigListData, ThrowOnError>
): RequestResult<EdgeConfigListResponses, EdgeConfigListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    EdgeConfigListResponses,
    EdgeConfigListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeConfigListBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeConfigListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_configurations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create an Edge Configuration
 *
 * Create an Edge Configuration.
 * **Access policy**: authenticated
 */
export const edgeConfigCreate = <ThrowOnError extends boolean = true>(
  options?: Options<EdgeConfigCreateData, ThrowOnError>
): RequestResult<
  EdgeConfigCreateResponses,
  EdgeConfigCreateErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    EdgeConfigCreateResponses,
    EdgeConfigCreateErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeConfigCreateBody.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeConfigCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_configurations',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  });

/**
 * Delete an Edge configuration
 *
 * Delete an Edge configuration.
 * **Access policy**: authenticated
 */
export const edgeConfigDelete = <ThrowOnError extends boolean = true>(
  options: Options<EdgeConfigDeleteData, ThrowOnError>
): RequestResult<
  EdgeConfigDeleteResponses,
  EdgeConfigDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EdgeConfigDeleteResponses,
    EdgeConfigDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeConfigDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeConfigDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_configurations/{id}',
    ...options,
  });

/**
 * Inspect an Edge configuration
 *
 * Retrieve details about an Edge configuration.
 * **Access policy**: authenticated
 */
export const edgeConfigInspect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeConfigInspectData, ThrowOnError>
): RequestResult<
  EdgeConfigInspectResponses,
  EdgeConfigInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeConfigInspectResponses,
    EdgeConfigInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeConfigInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeConfigInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_configurations/{id}',
    ...options,
  });

/**
 * Update an Edge Configuration
 *
 * Update an Edge Configuration.
 * **Access policy**: authenticated
 */
export const edgeConfigUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeConfigUpdateData, ThrowOnError>
): RequestResult<
  EdgeConfigUpdateResponses,
  EdgeConfigUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeConfigUpdateResponses,
    EdgeConfigUpdateErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeConfigUpdateBody.optional(),
          path: zEdgeConfigUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeConfigUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_configurations/{id}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Update the state of an Edge configuration
 *
 * Used by the standard edge agent to update the state of an Edge configuration.
 */
export const edgeConfigState = <ThrowOnError extends boolean = true>(
  options: Options<EdgeConfigStateData, ThrowOnError>
): RequestResult<
  EdgeConfigStateResponses,
  EdgeConfigStateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeConfigStateResponses,
    EdgeConfigStateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeConfigStatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeConfigStateResponse.parseAsync(data),
    url: '/edge_configurations/{id}/{state}',
    ...options,
  });

/**
 * Get the files for an Edge configuration
 *
 * Used by the standard edge agent to retrieve the files for an Edge configuration.
 */
export const edgeConfigFiles = <ThrowOnError extends boolean = true>(
  options: Options<EdgeConfigFilesData, ThrowOnError>
): RequestResult<
  EdgeConfigFilesResponses,
  EdgeConfigFilesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeConfigFilesResponses,
    EdgeConfigFilesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeConfigFilesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeConfigFilesResponse.parseAsync(data),
    url: '/edge_configurations/{id}/files',
    ...options,
  });

/**
 * list EdgeGroups
 *
 * **Access policy**: administrator
 */
export const edgeGroupList = <ThrowOnError extends boolean = true>(
  options?: Options<EdgeGroupListData, ThrowOnError>
): RequestResult<EdgeGroupListResponses, EdgeGroupListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    EdgeGroupListResponses,
    EdgeGroupListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zEdgeGroupListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeGroupListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_groups',
    ...options,
  });

/**
 * Create an EdgeGroup
 *
 * **Access policy**: administrator
 */
export const edgeGroupCreate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeGroupCreateData, ThrowOnError>
): RequestResult<
  EdgeGroupCreateResponses,
  EdgeGroupCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeGroupCreateResponses,
    EdgeGroupCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeGroupCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeGroupCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deletes an EdgeGroup
 *
 * **Access policy**: administrator
 */
export const edgeGroupDelete = <ThrowOnError extends boolean = true>(
  options: Options<EdgeGroupDeleteData, ThrowOnError>
): RequestResult<
  EdgeGroupDeleteResponses,
  EdgeGroupDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EdgeGroupDeleteResponses,
    EdgeGroupDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeGroupDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeGroupDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_groups/{id}',
    ...options,
  });

/**
 * Inspects an EdgeGroup
 *
 * **Access policy**: administrator
 */
export const edgeGroupInspect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeGroupInspectData, ThrowOnError>
): RequestResult<
  EdgeGroupInspectResponses,
  EdgeGroupInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeGroupInspectResponses,
    EdgeGroupInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeGroupInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeGroupInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_groups/{id}',
    ...options,
  });

/**
 * Updates an EdgeGroup
 *
 * **Access policy**: administrator
 */
export const edgeGroupUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeGroupUpdateData, ThrowOnError>
): RequestResult<
  EdgeGroupUpdateResponses,
  EdgeGroupUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeGroupUpdateResponses,
    EdgeGroupUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeGroupUpdateBody,
          path: zEdgeGroupUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeGroupUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_groups/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetch EdgeJobs list
 *
 * **Access policy**: administrator
 */
export const edgeJobList = <ThrowOnError extends boolean = true>(
  options?: Options<EdgeJobListData, ThrowOnError>
): RequestResult<EdgeJobListResponses, EdgeJobListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    EdgeJobListResponses,
    EdgeJobListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs',
    ...options,
  });

/**
 * Delete an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobDelete = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobDeleteData, ThrowOnError>
): RequestResult<EdgeJobDeleteResponses, EdgeJobDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    EdgeJobDeleteResponses,
    EdgeJobDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeJobDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeJobDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}',
    ...options,
  });

/**
 * Inspect an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobInspect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobInspectData, ThrowOnError>
): RequestResult<EdgeJobInspectResponses, EdgeJobInspectErrors, ThrowOnError> =>
  (options.client ?? client).get<
    EdgeJobInspectResponses,
    EdgeJobInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeJobInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}',
    ...options,
  });

/**
 * Update an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobUpdateData, ThrowOnError>
): RequestResult<EdgeJobUpdateResponses, EdgeJobUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    EdgeJobUpdateResponses,
    EdgeJobUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeJobUpdateBody,
          path: zEdgeJobUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetch a file of an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobFile = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobFileData, ThrowOnError>
): RequestResult<EdgeJobFileResponses, EdgeJobFileErrors, ThrowOnError> =>
  (options.client ?? client).get<
    EdgeJobFileResponses,
    EdgeJobFileErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeJobFilePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}/file',
    ...options,
  });

/**
 * Fetch the list of tasks on an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobTasksList = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobTasksListData, ThrowOnError>
): RequestResult<
  EdgeJobTasksListResponses,
  EdgeJobTasksListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeJobTasksListResponses,
    EdgeJobTasksListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeJobTasksListPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobTasksListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}/tasks',
    ...options,
  });

/**
 * Clear the log for a specifc task on an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobTasksClear = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobTasksClearData, ThrowOnError>
): RequestResult<
  EdgeJobTasksClearResponses,
  EdgeJobTasksClearErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EdgeJobTasksClearResponses,
    EdgeJobTasksClearErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeJobTasksClearPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeJobTasksClearResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}/tasks/{taskID}/logs',
    ...options,
  });

/**
 * Fetch the log for a specifc task on an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobTaskLogsInspect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobTaskLogsInspectData, ThrowOnError>
): RequestResult<
  EdgeJobTaskLogsInspectResponses,
  EdgeJobTaskLogsInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeJobTaskLogsInspectResponses,
    EdgeJobTaskLogsInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeJobTaskLogsInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobTaskLogsInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}/tasks/{taskID}/logs',
    ...options,
  });

/**
 * Collect the log for a specifc task on an EdgeJob
 *
 * **Access policy**: administrator
 */
export const edgeJobTasksCollect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobTasksCollectData, ThrowOnError>
): RequestResult<
  EdgeJobTasksCollectResponses,
  EdgeJobTasksCollectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeJobTasksCollectResponses,
    EdgeJobTasksCollectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeJobTasksCollectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeJobTasksCollectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/{id}/tasks/{taskID}/logs',
    ...options,
  });

/**
 * Create an EdgeJob from a file
 *
 * **Access policy**: administrator
 */
export const edgeJobCreateFile = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobCreateFileData, ThrowOnError>
): RequestResult<
  EdgeJobCreateFileResponses,
  EdgeJobCreateFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeJobCreateFileResponses,
    EdgeJobCreateFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeJobCreateFileBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobCreateFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/create/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Create an EdgeJob from a text
 *
 * **Access policy**: administrator
 */
export const edgeJobCreateString = <ThrowOnError extends boolean = true>(
  options: Options<EdgeJobCreateStringData, ThrowOnError>
): RequestResult<
  EdgeJobCreateStringResponses,
  EdgeJobCreateStringErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeJobCreateStringResponses,
    EdgeJobCreateStringErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeJobCreateStringBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeJobCreateStringResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_jobs/create/string',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetches the list of EdgeStacks
 *
 * **Access policy**: administrator
 */
export const edgeStackList = <ThrowOnError extends boolean = true>(
  options?: Options<EdgeStackListData, ThrowOnError>
): RequestResult<EdgeStackListResponses, EdgeStackListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    EdgeStackListResponses,
    EdgeStackListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zEdgeStackListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks',
    ...options,
  });

/**
 * Delete an EdgeStack
 *
 * **Access policy**: administrator
 */
export const edgeStackDelete = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackDeleteData, ThrowOnError>
): RequestResult<
  EdgeStackDeleteResponses,
  EdgeStackDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EdgeStackDeleteResponses,
    EdgeStackDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeStackDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}',
    ...options,
  });

/**
 * Inspect an EdgeStack
 *
 * **Access policy**: administrator
 */
export const edgeStackInspect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackInspectData, ThrowOnError>
): RequestResult<
  EdgeStackInspectResponses,
  EdgeStackInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeStackInspectResponses,
    EdgeStackInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}',
    ...options,
  });

/**
 * Update an EdgeStack
 *
 * **Access policy**: administrator
 */
export const edgeStackUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackUpdateData, ThrowOnError>
): RequestResult<
  EdgeStackUpdateResponses,
  EdgeStackUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeStackUpdateResponses,
    EdgeStackUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackUpdateBody,
          path: zEdgeStackUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetches the stack file for an EdgeStack
 *
 * **Access policy**: administrator
 */
export const edgeStackFile = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackFileData, ThrowOnError>
): RequestResult<EdgeStackFileResponses, EdgeStackFileErrors, ThrowOnError> =>
  (options.client ?? client).get<
    EdgeStackFileResponses,
    EdgeStackFileErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackFilePath,
          query: zEdgeStackFileQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/file',
    ...options,
  });

/**
 * Update git configuration and pulls the repository
 *
 * **Access policy**: authenticated
 */
export const edgeStackUpdateFromGit = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackUpdateFromGitData, ThrowOnError>
): RequestResult<
  EdgeStackUpdateFromGitResponses,
  EdgeStackUpdateFromGitErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeStackUpdateFromGitResponses,
    EdgeStackUpdateFromGitErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackUpdateFromGitBody,
          path: zEdgeStackUpdateFromGitPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeStackUpdateFromGitResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/git',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update an EdgeStack from a Helm repository
 *
 * **Access policy**: administrator
 */
export const edgeStackUpdateHelmRepository = <
  ThrowOnError extends boolean = true,
>(
  options: Options<EdgeStackUpdateHelmRepositoryData, ThrowOnError>
): RequestResult<
  EdgeStackUpdateHelmRepositoryResponses,
  EdgeStackUpdateHelmRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeStackUpdateHelmRepositoryResponses,
    EdgeStackUpdateHelmRepositoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackUpdateHelmRepositoryBody,
          path: zEdgeStackUpdateHelmRepositoryPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackUpdateHelmRepositoryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/helmRepo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deletes the available logs for a given edge stack and endpoint
 *
 * **Access policy**: administrator
 */
export const edgeStackLogsDelete = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackLogsDeleteData, ThrowOnError>
): RequestResult<
  EdgeStackLogsDeleteResponses,
  EdgeStackLogsDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EdgeStackLogsDeleteResponses,
    EdgeStackLogsDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackLogsDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeStackLogsDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/logs/{endpoint_id}',
    ...options,
  });

/**
 * Gets the status of the log collection for a given edgestack and environment
 *
 * **Access policy**: administrator
 */
export const edgeStackLogsStatusGet = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackLogsStatusGetData, ThrowOnError>
): RequestResult<
  EdgeStackLogsStatusGetResponses,
  EdgeStackLogsStatusGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeStackLogsStatusGetResponses,
    EdgeStackLogsStatusGetErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackLogsStatusGetPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/logs/{endpoint_id}',
    ...options,
  });

/**
 * Schedule the collection of logs for a given endpoint and edge stack
 *
 * **Access policy**: administrator
 */
export const edgeStackLogsCollect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackLogsCollectData, ThrowOnError>
): RequestResult<
  EdgeStackLogsCollectResponses,
  EdgeStackLogsCollectErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeStackLogsCollectResponses,
    EdgeStackLogsCollectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackLogsCollectPath,
          query: zEdgeStackLogsCollectQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeStackLogsCollectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/logs/{endpoint_id}',
    ...options,
  });

/**
 * Downloads the available logs for a given edge stack and endpoint
 *
 * **Access policy**: administrator
 */
export const edgeStackLogsDownload = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackLogsDownloadData, ThrowOnError>
): RequestResult<
  EdgeStackLogsDownloadResponses,
  EdgeStackLogsDownloadErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeStackLogsDownloadResponses,
    EdgeStackLogsDownloadErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackLogsDownloadPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/logs/{endpoint_id}/file',
    ...options,
  });

/**
 * Inspect an EdgeStack's parallel update status
 *
 * **Access policy**: administrator
 */
export const edgeStackStaggerStatusInspect = <
  ThrowOnError extends boolean = true,
>(
  options: Options<EdgeStackStaggerStatusInspectData, ThrowOnError>
): RequestResult<
  EdgeStackStaggerStatusInspectResponses,
  EdgeStackStaggerStatusInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeStackStaggerStatusInspectResponses,
    EdgeStackStaggerStatusInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackStaggerStatusInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackStaggerStatusInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/{id}/stagger/status',
    ...options,
  });

/**
 * Update an EdgeStack status
 *
 * Authorized only if the request is done by an Edge Environment(Endpoint)
 */
export const edgeStackStatusUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackStatusUpdateData, ThrowOnError>
): RequestResult<
  EdgeStackStatusUpdateResponses,
  EdgeStackStatusUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EdgeStackStatusUpdateResponses,
    EdgeStackStatusUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackStatusUpdateBody,
          path: zEdgeStackStatusUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackStatusUpdateResponse.parseAsync(data),
    url: '/edge_stacks/{id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create an EdgeStack from file
 *
 * **Access policy**: administrator
 */
export const edgeStackCreateFile = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackCreateFileData, ThrowOnError>
): RequestResult<
  EdgeStackCreateFileResponses,
  EdgeStackCreateFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeStackCreateFileResponses,
    EdgeStackCreateFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackCreateFileBody,
          path: z.never().optional(),
          query: zEdgeStackCreateFileQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackCreateFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/create/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Create an EdgeStack from a Helm repository
 *
 * **Access policy**: administrator
 */
export const edgeStackCreateHelmRepository = <
  ThrowOnError extends boolean = true,
>(
  options: Options<EdgeStackCreateHelmRepositoryData, ThrowOnError>
): RequestResult<
  EdgeStackCreateHelmRepositoryResponses,
  EdgeStackCreateHelmRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeStackCreateHelmRepositoryResponses,
    EdgeStackCreateHelmRepositoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackCreateHelmRepositoryBody,
          path: z.never().optional(),
          query: zEdgeStackCreateHelmRepositoryQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackCreateHelmRepositoryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/create/helmRepo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create an EdgeStack from a git repository
 *
 * **Access policy**: administrator
 */
export const edgeStackCreateRepository = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackCreateRepositoryData, ThrowOnError>
): RequestResult<
  EdgeStackCreateRepositoryResponses,
  EdgeStackCreateRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeStackCreateRepositoryResponses,
    EdgeStackCreateRepositoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackCreateRepositoryBody,
          path: z.never().optional(),
          query: zEdgeStackCreateRepositoryQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackCreateRepositoryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/create/repository',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create an EdgeStack from a text
 *
 * **Access policy**: administrator
 */
export const edgeStackCreateString = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackCreateStringData, ThrowOnError>
): RequestResult<
  EdgeStackCreateStringResponses,
  EdgeStackCreateStringErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeStackCreateStringResponses,
    EdgeStackCreateStringErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackCreateStringBody,
          path: z.never().optional(),
          query: zEdgeStackCreateStringQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackCreateStringResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/create/string',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Parse registries from a stack file
 *
 * **Access policy**: authenticated
 */
export const edgeStackParseRegistries = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackParseRegistriesData, ThrowOnError>
): RequestResult<
  EdgeStackParseRegistriesResponses,
  EdgeStackParseRegistriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeStackParseRegistriesResponses,
    EdgeStackParseRegistriesErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeStackParseRegistriesBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeStackParseRegistriesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_stacks/parse_registries',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Webhook for triggering edge stack updates from git
 *
 * **Access policy**: public
 */
export const edgeStackWebhookInvoke = <ThrowOnError extends boolean = true>(
  options: Options<EdgeStackWebhookInvokeData, ThrowOnError>
): RequestResult<
  EdgeStackWebhookInvokeResponses,
  EdgeStackWebhookInvokeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeStackWebhookInvokeResponses,
    EdgeStackWebhookInvokeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeStackWebhookInvokePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    url: '/edge_stacks/webhooks/{webhookID}',
    ...options,
  });

/**
 * Fetches the list of Edge Update Schedules
 *
 * **Access policy**: administrator
 */
export const edgeUpdateScheduleList = <ThrowOnError extends boolean = true>(
  options?: Options<EdgeUpdateScheduleListData, ThrowOnError>
): RequestResult<
  EdgeUpdateScheduleListResponses,
  EdgeUpdateScheduleListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    EdgeUpdateScheduleListResponses,
    EdgeUpdateScheduleListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zEdgeUpdateScheduleListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeUpdateScheduleListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules',
    ...options,
  });

/**
 * Creates a scheduled remote update procedure for Edge agents
 *
 * Creates a scheduled remote update process that will update or rollback the Edge agents in the specified Edge groups.
 * **Access policy**: Administrator only.
 */
export const edgeUpdateScheduleCreate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeUpdateScheduleCreateData, ThrowOnError>
): RequestResult<
  EdgeUpdateScheduleCreateResponses,
  EdgeUpdateScheduleCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeUpdateScheduleCreateResponses,
    EdgeUpdateScheduleCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeUpdateScheduleCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeUpdateScheduleCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deletes an Edge Update Schedule
 *
 * **Access policy**: administrator
 */
export const edgeUpdateScheduleDelete = <ThrowOnError extends boolean = true>(
  options: Options<EdgeUpdateScheduleDeleteData, ThrowOnError>
): RequestResult<
  EdgeUpdateScheduleDeleteResponses,
  EdgeUpdateScheduleDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EdgeUpdateScheduleDeleteResponses,
    EdgeUpdateScheduleDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeUpdateScheduleDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEdgeUpdateScheduleDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules/{id}',
    ...options,
  });

/**
 * Returns the Edge Update Schedule with the given ID
 *
 * **Access policy**: administrator
 */
export const edgeUpdateScheduleInspect = <ThrowOnError extends boolean = true>(
  options: Options<EdgeUpdateScheduleInspectData, ThrowOnError>
): RequestResult<
  EdgeUpdateScheduleInspectResponses,
  EdgeUpdateScheduleInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdgeUpdateScheduleInspectResponses,
    EdgeUpdateScheduleInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEdgeUpdateScheduleInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeUpdateScheduleInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules/{id}',
    ...options,
  });

/**
 * Update a scheduled remote update procedure for Edge agents
 *
 * Creates a scheduled remote update process that will update or rollback the Edge agents in the specified Edge groups.
 * **Access policy**: Administrator only.
 */
export const edgeUpdateScheduleUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EdgeUpdateScheduleUpdateData, ThrowOnError>
): RequestResult<
  EdgeUpdateScheduleUpdateResponses,
  EdgeUpdateScheduleUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeUpdateScheduleUpdateResponses,
    EdgeUpdateScheduleUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeUpdateScheduleUpdateBody,
          path: zEdgeUpdateScheduleUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeUpdateScheduleUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetches the list of Active Edge Update Schedules
 *
 * **Access policy**: administrator
 */
export const edgeUpdateScheduleActiveSchedulesList = <
  ThrowOnError extends boolean = true,
>(
  options: Options<EdgeUpdateScheduleActiveSchedulesListData, ThrowOnError>
): RequestResult<
  EdgeUpdateScheduleActiveSchedulesListResponses,
  EdgeUpdateScheduleActiveSchedulesListErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EdgeUpdateScheduleActiveSchedulesListResponses,
    EdgeUpdateScheduleActiveSchedulesListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEdgeUpdateScheduleActiveSchedulesListBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeUpdateScheduleActiveSchedulesListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules/active',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetches the supported versions of the agent to update/rollback
 *
 * **Access policy**: authenticated
 */
export const remoteUpdatesAgentVersions = <ThrowOnError extends boolean = true>(
  options?: Options<RemoteUpdatesAgentVersionsData, ThrowOnError>
): RequestResult<
  RemoteUpdatesAgentVersionsResponses,
  RemoteUpdatesAgentVersionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    RemoteUpdatesAgentVersionsResponses,
    RemoteUpdatesAgentVersionsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRemoteUpdatesAgentVersionsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules/agent_versions',
    ...options,
  });

/**
 * Returns informations the help create edge update schedules
 *
 * **Access policy**: administrator
 */
export const edgeUpdateScheduleInfo = <ThrowOnError extends boolean = true>(
  options?: Options<EdgeUpdateScheduleInfoData, ThrowOnError>
): RequestResult<
  EdgeUpdateScheduleInfoResponses,
  EdgeUpdateScheduleInfoErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    EdgeUpdateScheduleInfoResponses,
    EdgeUpdateScheduleInfoErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeUpdateScheduleInfoResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules/info',
    ...options,
  });

/**
 * Fetches the previous versions of updated agents
 *
 * **Access policy**: administrator
 */
export const edgeUpdatePreviousVersions = <ThrowOnError extends boolean = true>(
  options?: Options<EdgeUpdatePreviousVersionsData, ThrowOnError>
): RequestResult<
  EdgeUpdatePreviousVersionsResponses,
  EdgeUpdatePreviousVersionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    EdgeUpdatePreviousVersionsResponses,
    EdgeUpdatePreviousVersionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        environmentIds: { array: { explode: false } },
        edgeGroupIds: { array: { explode: false } },
      },
    },
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zEdgeUpdatePreviousVersionsQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEdgeUpdatePreviousVersionsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/edge_update_schedules/previous_versions',
    ...options,
  });

/**
 * List Environment(Endpoint) groups
 *
 * List all environment(endpoint) groups based on the current user authorizations. Will
 * return all environment(endpoint) groups if using an administrator account otherwise it will
 * only return authorized environment(endpoint) groups.
 * **Access policy**: restricted
 */
export const endpointGroupList = <ThrowOnError extends boolean = true>(
  options?: Options<EndpointGroupListData, ThrowOnError>
): RequestResult<
  EndpointGroupListResponses,
  EndpointGroupListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    EndpointGroupListResponses,
    EndpointGroupListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zEndpointGroupListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointGroupListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoint_groups',
    ...options,
  });

/**
 * Create an Environment(Endpoint) Group
 *
 * Create a new environment(endpoint) group.
 * **Access policy**: administrator
 */
export const endpointGroupCreate = <ThrowOnError extends boolean = true>(
  options: Options<EndpointGroupCreateData, ThrowOnError>
): RequestResult<
  EndpointGroupCreateResponses,
  EndpointGroupCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EndpointGroupCreateResponses,
    EndpointGroupCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointGroupCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointGroupCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoint_groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove an environment(endpoint) group
 *
 * Remove an environment(endpoint) group.
 * **Access policy**: administrator
 */
export const endpointGroupDelete = <ThrowOnError extends boolean = true>(
  options: Options<EndpointGroupDeleteData, ThrowOnError>
): RequestResult<
  EndpointGroupDeleteResponses,
  EndpointGroupDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EndpointGroupDeleteResponses,
    EndpointGroupDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointGroupDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointGroupDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoint_groups/{id}',
    ...options,
  });

/**
 * Inspect an Environment(Endpoint) group
 *
 * Retrieve details about an environment(endpoint) group.
 * **Access policy**: administrator
 */
export const getEndpointGroupsById = <ThrowOnError extends boolean = true>(
  options: Options<GetEndpointGroupsByIdData, ThrowOnError>
): RequestResult<
  GetEndpointGroupsByIdResponses,
  GetEndpointGroupsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEndpointGroupsByIdResponses,
    GetEndpointGroupsByIdErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetEndpointGroupsByIdPath,
          query: zGetEndpointGroupsByIdQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetEndpointGroupsByIdResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoint_groups/{id}',
    ...options,
  });

/**
 * Update an environment(endpoint) group
 *
 * Update an environment(endpoint) group.
 * **Access policy**: administrator
 */
export const endpointGroupUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EndpointGroupUpdateData, ThrowOnError>
): RequestResult<
  EndpointGroupUpdateResponses,
  EndpointGroupUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointGroupUpdateResponses,
    EndpointGroupUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointGroupUpdateBody,
          path: zEndpointGroupUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointGroupUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoint_groups/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Removes environment(endpoint) from an environment(endpoint) group
 *
 * **Access policy**: administrator
 */
export const endpointGroupDeleteEndpoint = <
  ThrowOnError extends boolean = true,
>(
  options: Options<EndpointGroupDeleteEndpointData, ThrowOnError>
): RequestResult<
  EndpointGroupDeleteEndpointResponses,
  EndpointGroupDeleteEndpointErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EndpointGroupDeleteEndpointResponses,
    EndpointGroupDeleteEndpointErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointGroupDeleteEndpointPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointGroupDeleteEndpointResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoint_groups/{id}/endpoints/{endpointId}',
    ...options,
  });

/**
 * Add an environment(endpoint) to an environment(endpoint) group
 *
 * Add an environment(endpoint) to an environment(endpoint) group
 * **Access policy**: administrator
 */
export const endpointGroupAddEndpoint = <ThrowOnError extends boolean = true>(
  options: Options<EndpointGroupAddEndpointData, ThrowOnError>
): RequestResult<
  EndpointGroupAddEndpointResponses,
  EndpointGroupAddEndpointErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointGroupAddEndpointResponses,
    EndpointGroupAddEndpointErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointGroupAddEndpointPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointGroupAddEndpointResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoint_groups/{id}/endpoints/{endpointId}',
    ...options,
  });

/**
 * List environments(endpoints)
 *
 * List all environments(endpoints) based on the current user authorizations. Will
 * return all environments(endpoints) if using an administrator or team leader account otherwise it will
 * only return authorized environments(endpoints).
 * **Access policy**: restricted
 */
export const endpointList = <ThrowOnError extends boolean = true>(
  options?: Options<EndpointListData, ThrowOnError>
): RequestResult<EndpointListResponses, EndpointListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    EndpointListResponses,
    EndpointListErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        groupIds: { array: { explode: false } },
        status: { array: { explode: false } },
        types: { array: { explode: false } },
        platformTypes: { array: { explode: false } },
        excludeGroupIds: { array: { explode: false } },
        tagIds: { array: { explode: false } },
        endpointIds: { array: { explode: false } },
        excludeIds: { array: { explode: false } },
        agentVersions: { array: { explode: false } },
        edgeGroupIds: { array: { explode: false } },
        excludeEdgeGroupIds: { array: { explode: false } },
        policyIds: { array: { explode: false } },
        policyStatus: { array: { explode: false } },
      },
    },
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zEndpointListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints',
    ...options,
  });

/**
 * Create a new environment(endpoint)
 *
 * Create a new environment(endpoint) that will be used to manage an environment(endpoint).
 * **Access policy**: administrator
 */
export const endpointCreate = <ThrowOnError extends boolean = true>(
  options: Options<EndpointCreateData, ThrowOnError>
): RequestResult<EndpointCreateResponses, EndpointCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    EndpointCreateResponses,
    EndpointCreateErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Remove an environment
 *
 * Remove the environment associated to the specified identifier and optionally clean-up associated resources.
 * **Access policy**: Administrator only.
 */
export const endpointDelete = <ThrowOnError extends boolean = true>(
  options: Options<EndpointDeleteData, ThrowOnError>
): RequestResult<EndpointDeleteResponses, EndpointDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    EndpointDeleteResponses,
    EndpointDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}',
    ...options,
  });

/**
 * Inspect an environment(endpoint)
 *
 * Retrieve details about an environment(endpoint).
 * **Access policy**: restricted
 */
export const endpointInspect = <ThrowOnError extends boolean = true>(
  options: Options<EndpointInspectData, ThrowOnError>
): RequestResult<
  EndpointInspectResponses,
  EndpointInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EndpointInspectResponses,
    EndpointInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointInspectPath,
          query: zEndpointInspectQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}',
    ...options,
  });

/**
 * Update an environment(endpoint)
 *
 * Update an environment(endpoint).
 * **Access policy**: authenticated
 */
export const endpointUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EndpointUpdateData, ThrowOnError>
): RequestResult<EndpointUpdateResponses, EndpointUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    EndpointUpdateResponses,
    EndpointUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointUpdateBody,
          path: zEndpointUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * De-association an edge environment(endpoint)
 *
 * De-association an edge environment(endpoint).
 * **Access policy**: administrator
 */
export const endpointAssociationDelete = <ThrowOnError extends boolean = true>(
  options: Options<EndpointAssociationDeleteData, ThrowOnError>
): RequestResult<
  EndpointAssociationDeleteResponses,
  EndpointAssociationDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointAssociationDeleteResponses,
    EndpointAssociationDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointAssociationDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointAssociationDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/association',
    ...options,
  });

/**
 * Upload a file under a specific path on the file system of an environment (endpoint)
 *
 * Use this environment(endpoint) to upload TLS files.
 * **Access policy**: administrator
 */
export const endpointDockerBrowsePut = <ThrowOnError extends boolean = true>(
  options: Options<EndpointDockerBrowsePutData, ThrowOnError>
): RequestResult<
  EndpointDockerBrowsePutResponses,
  EndpointDockerBrowsePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EndpointDockerBrowsePutResponses,
    EndpointDockerBrowsePutErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointDockerBrowsePutBody,
          path: zEndpointDockerBrowsePutPath,
          query: zEndpointDockerBrowsePutQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointDockerBrowsePutResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/docker/v2/browse/put',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * fetch docker pull limits
 *
 * get docker pull limits for a docker hub registry in the environment
 * **Access policy**:
 */
export const endpointDockerhubStatus = <ThrowOnError extends boolean = true>(
  options: Options<EndpointDockerhubStatusData, ThrowOnError>
): RequestResult<
  EndpointDockerhubStatusResponses,
  EndpointDockerhubStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EndpointDockerhubStatusResponses,
    EndpointDockerhubStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointDockerhubStatusPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointDockerhubStatusResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/dockerhub/{registryId}',
    ...options,
  });

/**
 * Report per-policy status from an edge agent
 *
 * environment(endpoint) for edge agent to report back per-policy reconciliation statuses
 * **Access policy**: restricted only to Edge environments(endpoints)
 */
export const endpointSetPolicyStatuses = <ThrowOnError extends boolean = true>(
  options: Options<EndpointSetPolicyStatusesData, ThrowOnError>
): RequestResult<
  EndpointSetPolicyStatusesResponses,
  EndpointSetPolicyStatusesErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointSetPolicyStatusesResponses,
    EndpointSetPolicyStatusesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointSetPolicyStatusesBody,
          path: zEndpointSetPolicyStatusesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointSetPolicyStatusesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/edge/policies/statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * force update a docker service
 *
 * force update a docker service
 * **Access policy**: authenticated
 */
export const endpointForceUpdateService = <ThrowOnError extends boolean = true>(
  options: Options<EndpointForceUpdateServiceData, ThrowOnError>
): RequestResult<
  EndpointForceUpdateServiceResponses,
  EndpointForceUpdateServiceErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointForceUpdateServiceResponses,
    EndpointForceUpdateServiceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointForceUpdateServiceBody,
          path: zEndpointForceUpdateServicePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointForceUpdateServiceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/forceupdateservice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Helm Releases
 *
 * List the Helm releases in the namespaces the user can access.
 * **Access policy**: authenticated
 */
export const helmList = <ThrowOnError extends boolean = true>(
  options: Options<HelmListData, ThrowOnError>
): RequestResult<HelmListResponses, HelmListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    HelmListResponses,
    HelmListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHelmListPath,
          query: zHelmListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zHelmListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/kubernetes/helm',
    ...options,
  });

/**
 * Install Helm Chart
 *
 * **Access policy**: authenticated
 */
export const helmInstall = <ThrowOnError extends boolean = true>(
  options: Options<HelmInstallData, ThrowOnError>
): RequestResult<HelmInstallResponses, HelmInstallErrors, ThrowOnError> =>
  (options.client ?? client).post<
    HelmInstallResponses,
    HelmInstallErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zHelmInstallBody,
          path: zHelmInstallPath,
          query: zHelmInstallQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zHelmInstallResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/kubernetes/helm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Helm Release
 *
 * **Access policy**: authenticated
 */
export const helmDelete = <ThrowOnError extends boolean = true>(
  options: Options<HelmDeleteData, ThrowOnError>
): RequestResult<HelmDeleteResponses, HelmDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    HelmDeleteResponses,
    HelmDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHelmDeletePath,
          query: zHelmDeleteQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zHelmDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/kubernetes/helm/{release}',
    ...options,
  });

/**
 * Get a helm release
 *
 * Get details of a helm release by release name
 * The release is scoped to the namespaces the user can access. Callers
 * without the K8sSecretsDetailsR authorization receive the release with its
 * manifest, values, config, hooks and notes omitted, because those are
 * rendered from the chart and can contain Secret data.
 * **Access policy**: authenticated
 */
export const helmGet = <ThrowOnError extends boolean = true>(
  options: Options<HelmGetData, ThrowOnError>
): RequestResult<HelmGetResponses, HelmGetErrors, ThrowOnError> =>
  (options.client ?? client).get<HelmGetResponses, HelmGetErrors, ThrowOnError>(
    {
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: zHelmGetPath,
            query: zHelmGetQuery.optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await zHelmGetResponse.parseAsync(data),
      security: [
        { name: 'X-API-KEY', type: 'apiKey' },
        { name: 'Authorization', type: 'apiKey' },
      ],
      url: '/endpoints/{id}/kubernetes/helm/{release}',
      ...options,
    }
  );

/**
 * Get a historical list of releases
 *
 * Get a historical list of releases by release name.
 * The history is scoped to the namespaces the user can access. Callers
 * without the K8sSecretsDetailsR authorization receive each revision with
 * its rendered notes omitted.
 * **Access policy**: authenticated
 */
export const helmGetHistory = <ThrowOnError extends boolean = true>(
  options: Options<HelmGetHistoryData, ThrowOnError>
): RequestResult<HelmGetHistoryResponses, HelmGetHistoryErrors, ThrowOnError> =>
  (options.client ?? client).get<
    HelmGetHistoryResponses,
    HelmGetHistoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHelmGetHistoryPath,
          query: zHelmGetHistoryQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zHelmGetHistoryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/kubernetes/helm/{release}/history',
    ...options,
  });

/**
 * Rollback a helm release
 *
 * Rollback a helm release to a previous revision
 * **Access policy**: authenticated
 */
export const helmRollback = <ThrowOnError extends boolean = true>(
  options: Options<HelmRollbackData, ThrowOnError>
): RequestResult<HelmRollbackResponses, HelmRollbackErrors, ThrowOnError> =>
  (options.client ?? client).post<
    HelmRollbackResponses,
    HelmRollbackErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHelmRollbackPath,
          query: zHelmRollbackQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zHelmRollbackResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/kubernetes/helm/{release}/rollback',
    ...options,
  });

/**
 * Helm Git Dry Run
 *
 * **Access policy**: authenticated
 */
export const helmGitDryRun = <ThrowOnError extends boolean = true>(
  options: Options<HelmGitDryRunData, ThrowOnError>
): RequestResult<HelmGitDryRunResponses, HelmGitDryRunErrors, ThrowOnError> =>
  (options.client ?? client).post<
    HelmGitDryRunResponses,
    HelmGitDryRunErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zHelmGitDryRunBody,
          path: zHelmGitDryRunPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zHelmGitDryRunResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/kubernetes/helm/git/dryrun',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get an environment(endpoint) mTLS certificate
 *
 * Retrieve the mTLS certificate of an environment(endpoint).
 * **Access policy**: administrator
 */
export const endpointMtlsCertificate = <ThrowOnError extends boolean = true>(
  options: Options<EndpointMtlsCertificateData, ThrowOnError>
): RequestResult<
  EndpointMtlsCertificateResponses,
  EndpointMtlsCertificateErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EndpointMtlsCertificateResponses,
    EndpointMtlsCertificateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointMtlsCertificatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointMtlsCertificateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/mtls_certificate',
    ...options,
  });

/**
 * Get an agent(endpoint) mTLS certificate
 *
 * Retrieve the mTLS certificate of an environment(endpoint).
 * **Access policy**: administrator
 */
export const endpointMtlsAgentCertificateError = <
  ThrowOnError extends boolean = true,
>(
  options: Options<EndpointMtlsAgentCertificateErrorData, ThrowOnError>
): RequestResult<
  EndpointMtlsAgentCertificateErrorResponses,
  EndpointMtlsAgentCertificateErrorErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EndpointMtlsAgentCertificateErrorResponses,
    EndpointMtlsAgentCertificateErrorErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointMtlsAgentCertificateErrorPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointMtlsAgentCertificateErrorResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/mtls_certificate_error',
    ...options,
  });

/**
 * Update namespace access for a given namespace
 *
 * Update the access permissions on a namespace in the given environment. This endpoint allows adding or removing users and teams that can access the specified namespace. Please note that users or teams must be added to the environment before they can be added to the namespace.
 * **Access policy**: Restricted. User must be an administrator or have appropriate permissions to modify namespace access.
 */
export const namespacesAccessUpdate = <ThrowOnError extends boolean = true>(
  options: Options<NamespacesAccessUpdateData, ThrowOnError>
): RequestResult<
  NamespacesAccessUpdateResponses,
  NamespacesAccessUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    NamespacesAccessUpdateResponses,
    NamespacesAccessUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zNamespacesAccessUpdateBody,
          path: zNamespacesAccessUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zNamespacesAccessUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/pools/{rpn}/access',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Registries on environment
 *
 * List all registries based on the current user authorizations in current environment.
 * **Access policy**: authenticated
 */
export const endpointRegistriesList = <ThrowOnError extends boolean = true>(
  options: Options<EndpointRegistriesListData, ThrowOnError>
): RequestResult<
  EndpointRegistriesListResponses,
  EndpointRegistriesListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EndpointRegistriesListResponses,
    EndpointRegistriesListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointRegistriesListPath,
          query: zEndpointRegistriesListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointRegistriesListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/registries',
    ...options,
  });

/**
 * update registry access for environment
 *
 * **Access policy**: authenticated
 */
export const endpointRegistryAccess = <ThrowOnError extends boolean = true>(
  options: Options<EndpointRegistryAccessData, ThrowOnError>
): RequestResult<
  EndpointRegistryAccessResponses,
  EndpointRegistryAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointRegistryAccessResponses,
    EndpointRegistryAccessErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointRegistryAccessBody,
          path: zEndpointRegistryAccessPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointRegistryAccessResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/registries/{registryId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update settings for an environment(endpoint)
 *
 * Update settings for an environment(endpoint).
 * **Access policy**: authenticated
 */
export const endpointSettingsUpdate = <ThrowOnError extends boolean = true>(
  options: Options<EndpointSettingsUpdateData, ThrowOnError>
): RequestResult<
  EndpointSettingsUpdateResponses,
  EndpointSettingsUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointSettingsUpdateResponses,
    EndpointSettingsUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointSettingsUpdateBody,
          path: zEndpointSettingsUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointSettingsUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Snapshots an environment(endpoint)
 *
 * Snapshots an environment(endpoint)
 * **Access policy**: authenticated
 */
export const endpointSnapshot = <ThrowOnError extends boolean = true>(
  options: Options<EndpointSnapshotData, ThrowOnError>
): RequestResult<
  EndpointSnapshotResponses,
  EndpointSnapshotErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EndpointSnapshotResponses,
    EndpointSnapshotErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEndpointSnapshotPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointSnapshotResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/{id}/snapshot',
    ...options,
  });

/**
 * List agent versions
 *
 * List all agent versions based on the current user authorizations and query parameters.
 * **Access policy**: restricted
 */
export const agentVersions = <ThrowOnError extends boolean = true>(
  options?: Options<AgentVersionsData, ThrowOnError>
): RequestResult<AgentVersionsResponses, AgentVersionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AgentVersionsResponses,
    AgentVersionsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAgentVersionsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/agent_versions',
    ...options,
  });

/**
 * Remove multiple environments
 *
 * Remove multiple environments and optionally clean-up associated resources.
 * **Access policy**: Administrator only.
 */
export const endpointDeleteBatch = <ThrowOnError extends boolean = true>(
  options: Options<EndpointDeleteBatchData, ThrowOnError>
): RequestResult<
  EndpointDeleteBatchResponses,
  EndpointDeleteBatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EndpointDeleteBatchResponses,
    EndpointDeleteBatchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointDeleteBatchBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointDeleteBatchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate an EdgeKey
 *
 * Generates a general edge key
 * **Access policy**: admin
 */
export const endpointEdgeGenerateKey = <ThrowOnError extends boolean = true>(
  options: Options<EndpointEdgeGenerateKeyData, ThrowOnError>
): RequestResult<
  EndpointEdgeGenerateKeyResponses,
  EndpointEdgeGenerateKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EndpointEdgeGenerateKeyResponses,
    EndpointEdgeGenerateKeyErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointEdgeGenerateKeyBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    url: '/endpoints/edge/generate-key',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Associate one or more Edge environments in the waiting room to environments
 *
 * Associate one or more Edge environments, currently in the waiting room, with Portainer environments. This action effectively grants trust to these environments.
 * **Access policy**: Administrator only.
 */
export const trustEdgeEndpoints = <ThrowOnError extends boolean = true>(
  options: Options<TrustEdgeEndpointsData, ThrowOnError>
): RequestResult<
  TrustEdgeEndpointsResponses,
  TrustEdgeEndpointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TrustEdgeEndpointsResponses,
    TrustEdgeEndpointsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zTrustEdgeEndpointsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zTrustEdgeEndpointsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/edge/trust',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create or retrieve the endpoint for an EdgeID
 */
export const endpointCreateGlobalKey = <ThrowOnError extends boolean = true>(
  options?: Options<EndpointCreateGlobalKeyData, ThrowOnError>
): RequestResult<
  EndpointCreateGlobalKeyResponses,
  EndpointCreateGlobalKeyErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    EndpointCreateGlobalKeyResponses,
    EndpointCreateGlobalKeyErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointCreateGlobalKeyResponse.parseAsync(data),
    url: '/endpoints/global-key',
    ...options,
  });

/**
 * Update relations for a list of environments
 *
 * Update relations for a list of environments
 * Edge groups, tags and environment group can be updated.
 *
 * **Access policy**: administrator
 */
export const endpointUpdateRelations = <ThrowOnError extends boolean = true>(
  options: Options<EndpointUpdateRelationsData, ThrowOnError>
): RequestResult<
  EndpointUpdateRelationsResponses,
  EndpointUpdateRelationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EndpointUpdateRelationsResponses,
    EndpointUpdateRelationsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEndpointUpdateRelationsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointUpdateRelationsResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/endpoints/relations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Snapshot all environment(endpoint)
 *
 * Snapshot all environments(endpoints)
 * **Access policy**: administrator
 */
export const endpointSnapshots = <ThrowOnError extends boolean = true>(
  options?: Options<EndpointSnapshotsData, ThrowOnError>
): RequestResult<
  EndpointSnapshotsResponses,
  EndpointSnapshotsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    EndpointSnapshotsResponses,
    EndpointSnapshotsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEndpointSnapshotsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/snapshot',
    ...options,
  });

/**
 * Get environment summary counts
 *
 * Returns counts of environments by status (up, down, outdated) and ungrouped environments (unassigned), plus breakdowns by group, type, and health.
 * **Access policy**: restricted
 */
export const endpointSummaryCounts = <ThrowOnError extends boolean = true>(
  options?: Options<EndpointSummaryCountsData, ThrowOnError>
): RequestResult<
  EndpointSummaryCountsResponses,
  EndpointSummaryCountsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    EndpointSummaryCountsResponses,
    EndpointSummaryCountsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEndpointSummaryCountsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/endpoints/summary',
    ...options,
  });

/**
 * preview the content of target file in the git repository
 *
 * Retrieve the compose file content based on git repository configuration
 * **Access policy**: authenticated
 */
export const gitOperationRepoFilePreview = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GitOperationRepoFilePreviewData, ThrowOnError>
): RequestResult<
  GitOperationRepoFilePreviewResponses,
  GitOperationRepoFilePreviewErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GitOperationRepoFilePreviewResponses,
    GitOperationRepoFilePreviewErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOperationRepoFilePreviewBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOperationRepoFilePreviewResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/repo/file/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search the file path from a git repository files with specified extensions
 *
 * Search the file path from the git repository based on partial or completed filename
 * **Access policy**: authenticated
 */
export const gitOperationRepoFilesSearch = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GitOperationRepoFilesSearchData, ThrowOnError>
): RequestResult<
  GitOperationRepoFilesSearchResponses,
  GitOperationRepoFilesSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GitOperationRepoFilesSearchResponses,
    GitOperationRepoFilesSearchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOperationRepoFilesSearchBody,
          path: z.never().optional(),
          query: zGitOperationRepoFilesSearchQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zGitOperationRepoFilesSearchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/repo/files/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Preview merged Helm values files from git repository
 *
 * Load and merge multiple Helm values files from a Git repository, mimicking Helm CLI behavior
 * **Access policy**: authenticated
 */
export const gitOperationRepoHelmValues = <ThrowOnError extends boolean = true>(
  options: Options<GitOperationRepoHelmValuesData, ThrowOnError>
): RequestResult<
  GitOperationRepoHelmValuesResponses,
  GitOperationRepoHelmValuesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GitOperationRepoHelmValuesResponses,
    GitOperationRepoHelmValuesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOperationRepoHelmValuesBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOperationRepoHelmValuesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/repo/helm/values',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List the refs of a git repository
 *
 * List all the refs of a git repository
 * Will return all refs of a git repository
 * **Access policy**: authenticated
 */
export const gitOperationRepoRefs = <ThrowOnError extends boolean = true>(
  options: Options<GitOperationRepoRefsData, ThrowOnError>
): RequestResult<
  GitOperationRepoRefsResponses,
  GitOperationRepoRefsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GitOperationRepoRefsResponses,
    GitOperationRepoRefsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOperationRepoRefsBody,
          path: z.never().optional(),
          query: zGitOperationRepoRefsQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zGitOperationRepoRefsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/repo/refs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all GitOps sources
 *
 * Returns a deduplicated list of git repositories used across all GitOps workflows.
 * **Access policy**: authenticated
 */
export const gitOpsSourcesList = <ThrowOnError extends boolean = true>(
  options?: Options<GitOpsSourcesListData, ThrowOnError>
): RequestResult<
  GitOpsSourcesListResponses,
  GitOpsSourcesListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GitOpsSourcesListResponses,
    GitOpsSourcesListErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { ids: { array: { explode: false } } } },
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGitOpsSourcesListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourcesListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources',
    ...options,
  });

/**
 * Delete a source
 *
 * Deletes an existing GitOps source. Returns 409 if the source is referenced by any workflow or custom template.
 * **Access policy**: authenticated
 */
export const gitOpsSourcesDelete = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourcesDeleteData, ThrowOnError>
): RequestResult<
  GitOpsSourcesDeleteResponses,
  GitOpsSourcesDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    GitOpsSourcesDeleteResponses,
    GitOpsSourcesDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGitOpsSourcesDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zGitOpsSourcesDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/{id}',
    ...options,
  });

/**
 * Get a GitOps source by ID
 *
 * Returns a single GitOps source with its connection settings and access rules.
 * **Access policy**: authenticated
 */
export const gitOpsSourceGet = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourceGetData, ThrowOnError>
): RequestResult<
  GitOpsSourceGetResponses,
  GitOpsSourceGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GitOpsSourceGetResponses,
    GitOpsSourceGetErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGitOpsSourceGetPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourceGetResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/{id}',
    ...options,
  });

/**
 * Update a Git source
 *
 * Updates an existing GitOps source backed by a Git repository.
 * **Access policy**: authenticated
 */
export const gitOpsSourcesUpdateGit = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourcesUpdateGitData, ThrowOnError>
): RequestResult<
  GitOpsSourcesUpdateGitResponses,
  GitOpsSourcesUpdateGitErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    GitOpsSourcesUpdateGitResponses,
    GitOpsSourcesUpdateGitErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOpsSourcesUpdateGitBody,
          path: zGitOpsSourcesUpdateGitPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourcesUpdateGitResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a GitOps source's access control
 *
 * Updates the access control settings for an existing GitOps source.
 * **Access policy**: administrator
 */
export const gitOpsSourcesUpdateAccess = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourcesUpdateAccessData, ThrowOnError>
): RequestResult<
  GitOpsSourcesUpdateAccessResponses,
  GitOpsSourcesUpdateAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    GitOpsSourcesUpdateAccessResponses,
    GitOpsSourcesUpdateAccessErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOpsSourcesUpdateAccessBody,
          path: zGitOpsSourcesUpdateAccessPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourcesUpdateAccessResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/{id}/access',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Test the connection of a stored source
 *
 * Tests connectivity for a GitOps source, applying optional overrides to the stored configuration.
 * **Access policy**: authenticated
 */
export const gitOpsSourcesTestById = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourcesTestByIdData, ThrowOnError>
): RequestResult<
  GitOpsSourcesTestByIdResponses,
  GitOpsSourcesTestByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GitOpsSourcesTestByIdResponses,
    GitOpsSourcesTestByIdErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOpsSourcesTestByIdBody.optional(),
          path: zGitOpsSourcesTestByIdPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourcesTestByIdResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/{id}/test',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List the workflows using a GitOps source
 *
 * Returns the workflows (stacks or edge stacks) currently deployed from this source.
 * **Access policy**: authenticated
 */
export const gitOpsSourceWorkflowsList = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourceWorkflowsListData, ThrowOnError>
): RequestResult<
  GitOpsSourceWorkflowsListResponses,
  GitOpsSourceWorkflowsListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GitOpsSourceWorkflowsListResponses,
    GitOpsSourceWorkflowsListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGitOpsSourceWorkflowsListPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourceWorkflowsListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/{id}/workflows',
    ...options,
  });

/**
 * Create a Git source
 *
 * Creates a new GitOps source backed by a Git repository.
 * **Access policy**: authenticated
 */
export const gitOpsSourcesCreateGit = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourcesCreateGitData, ThrowOnError>
): RequestResult<
  GitOpsSourcesCreateGitResponses,
  GitOpsSourcesCreateGitErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GitOpsSourcesCreateGitResponses,
    GitOpsSourcesCreateGitErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOpsSourcesCreateGitBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourcesCreateGitResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/git',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Summarize GitOps source status counts
 *
 * Returns a count of sources per status.
 * **Access policy**: authenticated
 */
export const gitOpsSourcesSummary = <ThrowOnError extends boolean = true>(
  options?: Options<GitOpsSourcesSummaryData, ThrowOnError>
): RequestResult<
  GitOpsSourcesSummaryResponses,
  GitOpsSourcesSummaryErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GitOpsSourcesSummaryResponses,
    GitOpsSourcesSummaryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourcesSummaryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/summary',
    ...options,
  });

/**
 * Test a Git source connection
 *
 * Tests connectivity for Git connection details that have not been persisted yet.
 * **Access policy**: authenticated
 */
export const gitOpsSourcesTest = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsSourcesTestData, ThrowOnError>
): RequestResult<
  GitOpsSourcesTestResponses,
  GitOpsSourcesTestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GitOpsSourcesTestResponses,
    GitOpsSourcesTestErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zGitOpsSourcesTestBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsSourcesTestResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/sources/test',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all GitOps workflows
 *
 * Returns a list of GitOps workflows, each with its aggregated status and the artifacts it contains.
 * **Access policy**: authenticated
 */
export const gitOpsWorkflowsList = <ThrowOnError extends boolean = true>(
  options?: Options<GitOpsWorkflowsListData, ThrowOnError>
): RequestResult<
  GitOpsWorkflowsListResponses,
  GitOpsWorkflowsListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GitOpsWorkflowsListResponses,
    GitOpsWorkflowsListErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: { endpointIds: { array: { explode: false } } },
    },
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGitOpsWorkflowsListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsWorkflowsListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/workflows',
    ...options,
  });

/**
 * Create a new workflow
 *
 * Create a new workflow.
 * **Access policy**: administrator
 */
export const workflowCreate = <ThrowOnError extends boolean = true>(
  options: Options<WorkflowCreateData, ThrowOnError>
): RequestResult<WorkflowCreateResponses, WorkflowCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    WorkflowCreateResponses,
    WorkflowCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zWorkflowCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zWorkflowCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/workflows',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a GitOps workflow by ID
 *
 * Returns the detail view of a single GitOps workflow, with one entry per backing
 * stack or edge stack artifact.
 * **Access policy**: authenticated
 */
export const gitOpsWorkflowGet = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsWorkflowGetData, ThrowOnError>
): RequestResult<
  GitOpsWorkflowGetResponses,
  GitOpsWorkflowGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GitOpsWorkflowGetResponses,
    GitOpsWorkflowGetErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGitOpsWorkflowGetPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsWorkflowGetResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/workflows/{id}',
    ...options,
  });

/**
 * Update a workflow
 *
 * Applies a partial, identity-preserving update to a workflow: the underlying
 * Stack/EdgeStack of each matched artifact is updated in place (same ID, no
 * delete+recreate) and immediately redeployed. Only artifact entries present in
 * the request are touched; omitted fields on a touched artifact are left unchanged.
 * **Access policy**: administrator
 */
export const workflowUpdate = <ThrowOnError extends boolean = true>(
  options: Options<WorkflowUpdateData, ThrowOnError>
): RequestResult<WorkflowUpdateResponses, WorkflowUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    WorkflowUpdateResponses,
    WorkflowUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zWorkflowUpdateBody,
          path: zWorkflowUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zWorkflowUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/workflows/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Destroy a GitOps workflow
 *
 * Tears down each of the workflow's artifacts then deletes the workflow record.
 * **Access policy**: authenticated
 */
export const gitOpsWorkflowDestroy = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsWorkflowDestroyData, ThrowOnError>
): RequestResult<
  GitOpsWorkflowDestroyResponses,
  GitOpsWorkflowDestroyErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    GitOpsWorkflowDestroyResponses,
    GitOpsWorkflowDestroyErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGitOpsWorkflowDestroyPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zGitOpsWorkflowDestroyResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/workflows/{id}/destroy',
    ...options,
  });

/**
 * Detach a GitOps workflow
 *
 * Removes the workflow but leaves its deployed stack/edge-stack running,
 * unlinked from GitOps.
 * **Access policy**: authenticated
 */
export const gitOpsWorkflowDetach = <ThrowOnError extends boolean = true>(
  options: Options<GitOpsWorkflowDetachData, ThrowOnError>
): RequestResult<
  GitOpsWorkflowDetachResponses,
  GitOpsWorkflowDetachErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    GitOpsWorkflowDetachResponses,
    GitOpsWorkflowDetachErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGitOpsWorkflowDetachPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zGitOpsWorkflowDetachResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/workflows/{id}/detach',
    ...options,
  });

/**
 * Summarize GitOps workflow status counts
 *
 * Returns a count of workflows per status for workflows accessible to the requesting user.
 * **Access policy**: authenticated
 */
export const gitOpsWorkflowsSummary = <ThrowOnError extends boolean = true>(
  options?: Options<GitOpsWorkflowsSummaryData, ThrowOnError>
): RequestResult<
  GitOpsWorkflowsSummaryResponses,
  GitOpsWorkflowsSummaryErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GitOpsWorkflowsSummaryResponses,
    GitOpsWorkflowsSummaryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGitOpsWorkflowsSummaryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/gitops/workflows/summary',
    ...options,
  });

/**
 * Get Pod Security Rule within k8s cluster, if not found, the frontend will create a default
 *
 * Get Pod Security Rule within k8s cluster
 * **Access policy**: authenticated
 */
export const getKubernetesPodSecurityRule = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesPodSecurityRuleData, ThrowOnError>
): RequestResult<
  GetKubernetesPodSecurityRuleResponses,
  GetKubernetesPodSecurityRuleErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesPodSecurityRuleResponses,
    GetKubernetesPodSecurityRuleErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesPodSecurityRulePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesPodSecurityRuleResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{environmentId}/opa',
    ...options,
  });

/**
 * Update Pod Security Rule within k8s cluster
 *
 * Update Pod Security Rule within k8s cluster
 * **Access policy**: authenticated
 */
export const updateK8sPodSecurityRule = <ThrowOnError extends boolean = true>(
  options: Options<UpdateK8sPodSecurityRuleData, ThrowOnError>
): RequestResult<
  UpdateK8sPodSecurityRuleResponses,
  UpdateK8sPodSecurityRuleErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateK8sPodSecurityRuleResponses,
    UpdateK8sPodSecurityRuleErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUpdateK8sPodSecurityRulePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{environmentId}/opa',
    ...options,
  });

/**
 * Get a list of applications across all namespaces in the cluster. If the nodeName is provided, it will return the applications running on that node.
 *
 * Get a list of applications across all namespaces in the cluster. If the nodeName is provided, it will return the applications running on that node.
 * **Access policy**: authenticated
 */
export const getAllKubernetesApplications = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesApplicationsData, ThrowOnError>
): RequestResult<
  GetAllKubernetesApplicationsResponses,
  GetAllKubernetesApplicationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesApplicationsResponses,
    GetAllKubernetesApplicationsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesApplicationsPath,
          query: zGetAllKubernetesApplicationsQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesApplicationsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/applications',
    ...options,
  });

/**
 * Get Applications count
 *
 * Get the count of Applications across all namespaces in the cluster. If the nodeName is provided, it will return the count of applications running on that node.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesApplicationsCount = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesApplicationsCountData, ThrowOnError>
): RequestResult<
  GetAllKubernetesApplicationsCountResponses,
  GetAllKubernetesApplicationsCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesApplicationsCountResponses,
    GetAllKubernetesApplicationsCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesApplicationsCountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesApplicationsCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/applications/count',
    ...options,
  });

/**
 * Delete cluster role bindings
 *
 * Delete the provided list of cluster role bindings.
 * **Access policy**: Authenticated user.
 */
export const deleteClusterRoleBindings = <ThrowOnError extends boolean = true>(
  options: Options<DeleteClusterRoleBindingsData, ThrowOnError>
): RequestResult<
  DeleteClusterRoleBindingsResponses,
  DeleteClusterRoleBindingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteClusterRoleBindingsResponses,
    DeleteClusterRoleBindingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteClusterRoleBindingsBody,
          path: zDeleteClusterRoleBindingsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteClusterRoleBindingsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/cluster_role_bindings/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete cluster roles
 *
 * Delete the provided list of cluster roles.
 * **Access policy**: Authenticated user.
 */
export const deleteClusterRoles = <ThrowOnError extends boolean = true>(
  options: Options<DeleteClusterRolesData, ThrowOnError>
): RequestResult<
  DeleteClusterRolesResponses,
  DeleteClusterRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteClusterRolesResponses,
    DeleteClusterRolesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteClusterRolesBody,
          path: zDeleteClusterRolesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteClusterRolesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/cluster_roles/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of kubernetes cluster role bindings
 *
 * Get a list of kubernetes cluster role bindings within the given environment at the cluster level.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesClusterRoleBindings = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesClusterRoleBindingsData, ThrowOnError>
): RequestResult<
  GetAllKubernetesClusterRoleBindingsResponses,
  GetAllKubernetesClusterRoleBindingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesClusterRoleBindingsResponses,
    GetAllKubernetesClusterRoleBindingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesClusterRoleBindingsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesClusterRoleBindingsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/clusterrolebindings',
    ...options,
  });

/**
 * Get a list of kubernetes cluster roles
 *
 * Get a list of kubernetes cluster roles within the given environment at the cluster level.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesClusterRoles = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesClusterRolesData, ThrowOnError>
): RequestResult<
  GetAllKubernetesClusterRolesResponses,
  GetAllKubernetesClusterRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesClusterRolesResponses,
    GetAllKubernetesClusterRolesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesClusterRolesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesClusterRolesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/clusterroles',
    ...options,
  });

/**
 * Get a list of ConfigMaps
 *
 * Get a list of ConfigMaps across all namespaces in the cluster. For non-admin users, it will only return ConfigMaps based on the namespaces that they have access to.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesConfigMaps = <ThrowOnError extends boolean = true>(
  options: Options<GetAllKubernetesConfigMapsData, ThrowOnError>
): RequestResult<
  GetAllKubernetesConfigMapsResponses,
  GetAllKubernetesConfigMapsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesConfigMapsResponses,
    GetAllKubernetesConfigMapsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesConfigMapsPath,
          query: zGetAllKubernetesConfigMapsQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesConfigMapsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/configmaps',
    ...options,
  });

/**
 * Get ConfigMaps count
 *
 * Get the count of ConfigMaps across all namespaces in the cluster. For non-admin users, it will only return the count of ConfigMaps based on the namespaces that they have access to.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesConfigMapsCount = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesConfigMapsCountData, ThrowOnError>
): RequestResult<
  GetAllKubernetesConfigMapsCountResponses,
  GetAllKubernetesConfigMapsCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesConfigMapsCountResponses,
    GetAllKubernetesConfigMapsCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesConfigMapsCountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesConfigMapsCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/configmaps/count',
    ...options,
  });

/**
 * Get a list of kubernetes Cron Jobs
 *
 * Get a list of kubernetes Cron Jobs that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesCronJobs = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesCronJobsData, ThrowOnError>
): RequestResult<
  GetKubernetesCronJobsResponses,
  GetKubernetesCronJobsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesCronJobsResponses,
    GetKubernetesCronJobsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesCronJobsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesCronJobsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/cron_jobs',
    ...options,
  });

/**
 * Delete Cron Jobs
 *
 * Delete the provided list of Cron Jobs.
 * **Access policy**: Authenticated user.
 */
export const deleteCronJobs = <ThrowOnError extends boolean = true>(
  options: Options<DeleteCronJobsData, ThrowOnError>
): RequestResult<DeleteCronJobsResponses, DeleteCronJobsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    DeleteCronJobsResponses,
    DeleteCronJobsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteCronJobsBody,
          path: zDeleteCronJobsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteCronJobsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/cron_jobs/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of kubernetes Custom Resource Definitions
 *
 * Get a list of kubernetes Custom Resource Definitions that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesCustomResourceDefinitions = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesCustomResourceDefinitionsData, ThrowOnError>
): RequestResult<
  GetKubernetesCustomResourceDefinitionsResponses,
  GetKubernetesCustomResourceDefinitionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesCustomResourceDefinitionsResponses,
    GetKubernetesCustomResourceDefinitionsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesCustomResourceDefinitionsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesCustomResourceDefinitionsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresourcedefinitions',
    ...options,
  });

/**
 * Delete a kubernetes Custom Resource Definition
 *
 * Delete a kubernetes Custom Resource Definition.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesCustomResourceDefinition = <
  ThrowOnError extends boolean = true,
>(
  options: Options<DeleteKubernetesCustomResourceDefinitionData, ThrowOnError>
): RequestResult<
  DeleteKubernetesCustomResourceDefinitionResponses,
  DeleteKubernetesCustomResourceDefinitionErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesCustomResourceDefinitionResponses,
    DeleteKubernetesCustomResourceDefinitionErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteKubernetesCustomResourceDefinitionPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesCustomResourceDefinitionResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresourcedefinitions/{name}',
    ...options,
  });

/**
 * Get a kubernetes Custom Resource Definition
 *
 * Get a kubernetes Custom Resource Definition.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesCustomResourceDefinition = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesCustomResourceDefinitionData, ThrowOnError>
): RequestResult<
  GetKubernetesCustomResourceDefinitionResponses,
  GetKubernetesCustomResourceDefinitionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesCustomResourceDefinitionResponses,
    GetKubernetesCustomResourceDefinitionErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesCustomResourceDefinitionPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesCustomResourceDefinitionResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresourcedefinitions/{name}',
    ...options,
  });

/**
 * Get a list of kubernetes Custom Resources
 *
 * Get a list of kubernetes Custom Resources that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesAllCustomResources = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesAllCustomResourcesData, ThrowOnError>
): RequestResult<
  GetKubernetesAllCustomResourcesResponses,
  GetKubernetesAllCustomResourcesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesAllCustomResourcesResponses,
    GetKubernetesAllCustomResourcesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesAllCustomResourcesPath,
          query: zGetKubernetesAllCustomResourcesQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesAllCustomResourcesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresources',
    ...options,
  });

/**
 * Delete a cluster-scoped kubernetes Custom Resource
 *
 * Delete a cluster-scoped kubernetes Custom Resource that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesClusterScopedCustomResource = <
  ThrowOnError extends boolean = true,
>(
  options: Options<
    DeleteKubernetesClusterScopedCustomResourceData,
    ThrowOnError
  >
): RequestResult<
  DeleteKubernetesClusterScopedCustomResourceResponses,
  DeleteKubernetesClusterScopedCustomResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesClusterScopedCustomResourceResponses,
    DeleteKubernetesClusterScopedCustomResourceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteKubernetesClusterScopedCustomResourcePath,
          query: zDeleteKubernetesClusterScopedCustomResourceQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesClusterScopedCustomResourceResponse.parseAsync(
        data
      ),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresources/{name}',
    ...options,
  });

/**
 * Get a cluster-scoped kubernetes Custom Resource
 *
 * Get a cluster-scoped kubernetes Custom Resource that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesClusterScopedCustomResource = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesClusterScopedCustomResourceData, ThrowOnError>
): RequestResult<
  GetKubernetesClusterScopedCustomResourceResponses,
  GetKubernetesClusterScopedCustomResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesClusterScopedCustomResourceResponses,
    GetKubernetesClusterScopedCustomResourceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesClusterScopedCustomResourcePath,
          query: zGetKubernetesClusterScopedCustomResourceQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesClusterScopedCustomResourceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresources/{name}',
    ...options,
  });

/**
 * Delete a namespaced kubernetes Custom Resource
 *
 * Delete a namespaced kubernetes Custom Resource that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesNamespacedCustomResource = <
  ThrowOnError extends boolean = true,
>(
  options: Options<DeleteKubernetesNamespacedCustomResourceData, ThrowOnError>
): RequestResult<
  DeleteKubernetesNamespacedCustomResourceResponses,
  DeleteKubernetesNamespacedCustomResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesNamespacedCustomResourceResponses,
    DeleteKubernetesNamespacedCustomResourceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteKubernetesNamespacedCustomResourcePath,
          query: zDeleteKubernetesNamespacedCustomResourceQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesNamespacedCustomResourceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresources/{namespace}/{name}',
    ...options,
  });

/**
 * Get a list of kubernetes Custom Resources
 *
 * Get a list of kubernetes Custom Resources that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesNamespacedCustomResource = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesNamespacedCustomResourceData, ThrowOnError>
): RequestResult<
  GetKubernetesNamespacedCustomResourceResponses,
  GetKubernetesNamespacedCustomResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesNamespacedCustomResourceResponses,
    GetKubernetesNamespacedCustomResourceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesNamespacedCustomResourcePath,
          query: zGetKubernetesNamespacedCustomResourceQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesNamespacedCustomResourceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/customresources/{namespace}/{name}',
    ...options,
  });

/**
 * Get the dashboard summary data
 *
 * Get the dashboard summary data which is simply a count of a range of different commonly used kubernetes resources.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesDashboard = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesDashboardData, ThrowOnError>
): RequestResult<
  GetKubernetesDashboardResponses,
  GetKubernetesDashboardErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesDashboardResponses,
    GetKubernetesDashboardErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesDashboardPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesDashboardResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/dashboard',
    ...options,
  });

/**
 * Get Kubernetes deployments
 *
 * Get the list of Kubernetes deployments across all namespaces the user can access.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesDeployments = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesDeploymentsData, ThrowOnError>
): RequestResult<
  GetAllKubernetesDeploymentsResponses,
  GetAllKubernetesDeploymentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesDeploymentsResponses,
    GetAllKubernetesDeploymentsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesDeploymentsPath,
          query: zGetAllKubernetesDeploymentsQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesDeploymentsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/deployments',
    ...options,
  });

/**
 * Get a description of a kubernetes resource
 *
 * Get a description of a kubernetes resource.
 * **Access policy**: Authenticated user.
 */
export const describeResource = <ThrowOnError extends boolean = true>(
  options: Options<DescribeResourceData, ThrowOnError>
): RequestResult<
  DescribeResourceResponses,
  DescribeResourceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DescribeResourceResponses,
    DescribeResourceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDescribeResourcePath,
          query: zDescribeResourceQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zDescribeResourceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/describe',
    ...options,
  });

/**
 * Get a list of Endpoints
 *
 * Get a list of Kubernetes endpoints within the given environment.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesEndpoints = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesEndpointsData, ThrowOnError>
): RequestResult<
  GetKubernetesEndpointsResponses,
  GetKubernetesEndpointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesEndpointsResponses,
    GetKubernetesEndpointsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesEndpointsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesEndpointsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/endpoints',
    ...options,
  });

/**
 * Gets kubernetes events
 *
 * Get events by query param resourceId
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesEvents = <ThrowOnError extends boolean = true>(
  options: Options<GetAllKubernetesEventsData, ThrowOnError>
): RequestResult<
  GetAllKubernetesEventsResponses,
  GetAllKubernetesEventsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesEventsResponses,
    GetAllKubernetesEventsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesEventsPath,
          query: zGetAllKubernetesEventsQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesEventsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/events',
    ...options,
  });

/**
 * Get GPU visibility information for a Kubernetes cluster.
 *
 * Returns GPU resource summary, per-node GPU details, and GPU-requesting workloads.
 * **Access policy**: authenticated
 */
export const getKubernetesGpuInfo = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesGpuInfoData, ThrowOnError>
): RequestResult<
  GetKubernetesGpuInfoResponses,
  GetKubernetesGpuInfoErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesGpuInfoResponses,
    GetKubernetesGpuInfoErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesGpuInfoPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesGpuInfoResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/gpu',
    ...options,
  });

/**
 * Get Kubernetes ingress classes
 *
 * Get the list of Kubernetes ingress classes (cluster-scoped), as read
 * models, distinct from the ingress controllers returned by /ingresscontrollers.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesIngressClasses = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesIngressClassesData, ThrowOnError>
): RequestResult<
  GetKubernetesIngressClassesResponses,
  GetKubernetesIngressClassesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesIngressClassesResponses,
    GetKubernetesIngressClassesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesIngressClassesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesIngressClassesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/ingressclasses',
    ...options,
  });

/**
 * Get a list of ingress controllers
 *
 * Get a list of ingress controllers for the given environment. If the allowedOnly query parameter is set, only ingress controllers that are allowed by the environment's ingress configuration will be returned.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesIngressControllers = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesIngressControllersData, ThrowOnError>
): RequestResult<
  GetAllKubernetesIngressControllersResponses,
  GetAllKubernetesIngressControllersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesIngressControllersResponses,
    GetAllKubernetesIngressControllersErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesIngressControllersPath,
          query: zGetAllKubernetesIngressControllersQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesIngressControllersResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/ingresscontrollers',
    ...options,
  });

/**
 * Update (block/unblock) ingress controllers
 *
 * Update (block/unblock) ingress controllers for the provided environment.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesIngressControllers = <
  ThrowOnError extends boolean = true,
>(
  options: Options<UpdateKubernetesIngressControllersData, ThrowOnError>
): RequestResult<
  UpdateKubernetesIngressControllersResponses,
  UpdateKubernetesIngressControllersErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesIngressControllersResponses,
    UpdateKubernetesIngressControllersErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesIngressControllersBody,
          path: zUpdateKubernetesIngressControllersPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUpdateKubernetesIngressControllersResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/ingresscontrollers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get kubernetes ingresses at the cluster level
 *
 * Get kubernetes ingresses at the cluster level for the provided environment.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesClusterIngresses = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesClusterIngressesData, ThrowOnError>
): RequestResult<
  GetAllKubernetesClusterIngressesResponses,
  GetAllKubernetesClusterIngressesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesClusterIngressesResponses,
    GetAllKubernetesClusterIngressesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesClusterIngressesPath,
          query: zGetAllKubernetesClusterIngressesQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesClusterIngressesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/ingresses',
    ...options,
  });

/**
 * Get Ingresses count
 *
 * Get the number of kubernetes ingresses within the given environment.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesClusterIngressesCount = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesClusterIngressesCountData, ThrowOnError>
): RequestResult<
  GetAllKubernetesClusterIngressesCountResponses,
  GetAllKubernetesClusterIngressesCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesClusterIngressesCountResponses,
    GetAllKubernetesClusterIngressesCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesClusterIngressesCountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesClusterIngressesCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/ingresses/count',
    ...options,
  });

/**
 * Delete one or more Ingresses
 *
 * Delete one or more Ingresses in the provided environment.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesIngresses = <ThrowOnError extends boolean = true>(
  options: Options<DeleteKubernetesIngressesData, ThrowOnError>
): RequestResult<
  DeleteKubernetesIngressesResponses,
  DeleteKubernetesIngressesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteKubernetesIngressesResponses,
    DeleteKubernetesIngressesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteKubernetesIngressesBody,
          path: zDeleteKubernetesIngressesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesIngressesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/ingresses/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of kubernetes Jobs
 *
 * Get a list of kubernetes Jobs that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesJobs = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesJobsData, ThrowOnError>
): RequestResult<
  GetKubernetesJobsResponses,
  GetKubernetesJobsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesJobsResponses,
    GetKubernetesJobsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesJobsPath,
          query: zGetKubernetesJobsQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesJobsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/jobs',
    ...options,
  });

/**
 * Delete Jobs
 *
 * Delete the provided list of Jobs.
 * **Access policy**: Authenticated user.
 */
export const deleteJobs = <ThrowOnError extends boolean = true>(
  options: Options<DeleteJobsData, ThrowOnError>
): RequestResult<DeleteJobsResponses, DeleteJobsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    DeleteJobsResponses,
    DeleteJobsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteJobsBody,
          path: zDeleteJobsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteJobsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/jobs/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Validate Kubernetes manifests without applying them
 *
 * Validate Kubernetes manifests against the cluster with a server-side dry-run apply, without persisting anything.
 * Each resource is reported on its own, so a rejected resource does not hide the outcome of the others.
 * The dry-run runs with the permissions of the requesting user, so it also surfaces missing permissions.
 * A resource living in a namespace created by another manifest of the same request is reported as failed, because the dry-run never persists that namespace.
 * **Access policy**: authenticated
 */
export const dryRunKubernetesManifests = <ThrowOnError extends boolean = true>(
  options: Options<DryRunKubernetesManifestsData, ThrowOnError>
): RequestResult<
  DryRunKubernetesManifestsResponses,
  DryRunKubernetesManifestsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DryRunKubernetesManifestsResponses,
    DryRunKubernetesManifestsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDryRunKubernetesManifestsBody,
          path: zDryRunKubernetesManifestsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zDryRunKubernetesManifestsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/manifests/dry_run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get max CPU and memory limits of all nodes within k8s cluster
 *
 * Get max CPU and memory limits (unused resources) of all nodes within k8s cluster.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesMaxResourceLimits = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesMaxResourceLimitsData, ThrowOnError>
): RequestResult<
  GetKubernetesMaxResourceLimitsResponses,
  GetKubernetesMaxResourceLimitsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesMaxResourceLimitsResponses,
    GetKubernetesMaxResourceLimitsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesMaxResourceLimitsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesMaxResourceLimitsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/max_resource_limits',
    ...options,
  });

/**
 * Get the total CPU (cores) and memory requests (MB) and limits of all applications across all namespaces
 *
 * Get the total CPU (cores) and memory (bytes) requests and limits of all applications across all namespaces.
 * **Access policy**: authenticated
 */
export const getApplicationsResources = <ThrowOnError extends boolean = true>(
  options: Options<GetApplicationsResourcesData, ThrowOnError>
): RequestResult<
  GetApplicationsResourcesResponses,
  GetApplicationsResourcesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApplicationsResourcesResponses,
    GetApplicationsResourcesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetApplicationsResourcesPath,
          query: zGetApplicationsResourcesQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetApplicationsResourcesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/metrics/applications_resources',
    ...options,
  });

/**
 * Get a list of nodes with their live metrics
 *
 * Get a list of metrics associated with all nodes of a cluster.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesMetricsForAllNodes = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesMetricsForAllNodesData, ThrowOnError>
): RequestResult<
  GetKubernetesMetricsForAllNodesResponses,
  GetKubernetesMetricsForAllNodesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesMetricsForAllNodesResponses,
    GetKubernetesMetricsForAllNodesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesMetricsForAllNodesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesMetricsForAllNodesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/metrics/nodes',
    ...options,
  });

/**
 * Get live metrics for a node
 *
 * Get live metrics for the specified node.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesMetricsForNode = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesMetricsForNodeData, ThrowOnError>
): RequestResult<
  GetKubernetesMetricsForNodeResponses,
  GetKubernetesMetricsForNodeErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesMetricsForNodeResponses,
    GetKubernetesMetricsForNodeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesMetricsForNodePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesMetricsForNodeResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/metrics/nodes/{name}',
    ...options,
  });

/**
 * Get live metrics for a pod
 *
 * Get live metrics for the specified pod.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesMetricsForPod = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesMetricsForPodData, ThrowOnError>
): RequestResult<
  GetKubernetesMetricsForPodResponses,
  GetKubernetesMetricsForPodErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesMetricsForPodResponses,
    GetKubernetesMetricsForPodErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesMetricsForPodPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesMetricsForPodResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/metrics/pods/{namespace}/{name}',
    ...options,
  });

/**
 * Get a list of pods with their live metrics
 *
 * Get a list of pods with their live metrics for the specified namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesMetricsForAllPods = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesMetricsForAllPodsData, ThrowOnError>
): RequestResult<
  GetKubernetesMetricsForAllPodsResponses,
  GetKubernetesMetricsForAllPodsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesMetricsForAllPodsResponses,
    GetKubernetesMetricsForAllPodsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesMetricsForAllPodsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesMetricsForAllPodsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/metrics/pods/namespace/{namespace}',
    ...options,
  });

/**
 * Delete kubernetes namespaces
 *
 * Delete one or more kubernetes namespaces within the given environment.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesNamespace = <ThrowOnError extends boolean = true>(
  options: Options<DeleteKubernetesNamespaceData, ThrowOnError>
): RequestResult<
  DeleteKubernetesNamespaceResponses,
  DeleteKubernetesNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesNamespaceResponses,
    DeleteKubernetesNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteKubernetesNamespaceBody,
          path: zDeleteKubernetesNamespacePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of namespaces
 *
 * Get a list of all namespaces within the given environment based on the user role and permissions. If the user is an admin, they can access all namespaces. If the user is not an admin, they can only access namespaces that they have access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesNamespaces = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesNamespacesData, ThrowOnError>
): RequestResult<
  GetKubernetesNamespacesResponses,
  GetKubernetesNamespacesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesNamespacesResponses,
    GetKubernetesNamespacesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesNamespacesPath,
          query: zGetKubernetesNamespacesQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesNamespacesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces',
    ...options,
  });

/**
 * Create a namespace
 *
 * Create a namespace within the given environment.
 * **Access policy**: Authenticated user.
 */
export const createKubernetesNamespace = <ThrowOnError extends boolean = true>(
  options: Options<CreateKubernetesNamespaceData, ThrowOnError>
): RequestResult<
  CreateKubernetesNamespaceResponses,
  CreateKubernetesNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateKubernetesNamespaceResponses,
    CreateKubernetesNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateKubernetesNamespaceBody,
          path: zCreateKubernetesNamespacePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCreateKubernetesNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a namespace
 *
 * Update a namespace within the given environment.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesNamespaceDeprecated = <
  ThrowOnError extends boolean = true,
>(
  options: Options<UpdateKubernetesNamespaceDeprecatedData, ThrowOnError>
): RequestResult<
  UpdateKubernetesNamespaceDeprecatedResponses,
  UpdateKubernetesNamespaceDeprecatedErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesNamespaceDeprecatedResponses,
    UpdateKubernetesNamespaceDeprecatedErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesNamespaceDeprecatedBody,
          path: zUpdateKubernetesNamespaceDeprecatedPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateKubernetesNamespaceDeprecatedResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get namespace details
 *
 * Get namespace details for the provided namespace within the given environment.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesNamespace = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesNamespaceData, ThrowOnError>
): RequestResult<
  GetKubernetesNamespaceResponses,
  GetKubernetesNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesNamespaceResponses,
    GetKubernetesNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesNamespacePath,
          query: zGetKubernetesNamespaceQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}',
    ...options,
  });

/**
 * Update a namespace
 *
 * Update a namespace within the given environment.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesNamespace = <ThrowOnError extends boolean = true>(
  options: Options<UpdateKubernetesNamespaceData, ThrowOnError>
): RequestResult<
  UpdateKubernetesNamespaceResponses,
  UpdateKubernetesNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesNamespaceResponses,
    UpdateKubernetesNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesNamespaceBody,
          path: zUpdateKubernetesNamespacePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateKubernetesNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Restart a Kubernetes application
 *
 * Restart a Kubernetes deployment, statefulset and daemonset application, using a kubectl rollout-restart
 * **Access policy**: authenticated
 */
export const restartKubernetesApplication = <
  ThrowOnError extends boolean = true,
>(
  options: Options<RestartKubernetesApplicationData, ThrowOnError>
): RequestResult<
  RestartKubernetesApplicationResponses,
  RestartKubernetesApplicationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RestartKubernetesApplicationResponses,
    RestartKubernetesApplicationErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zRestartKubernetesApplicationPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zRestartKubernetesApplicationResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/applications/{kind}/{name}/restart',
    ...options,
  });

/**
 * Get an application by name in a specific namespace
 *
 * Get an application by name in a specific namespace
 * **Access policy**: authenticated
 */
export const getAllKubernetesApplication = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesApplicationData, ThrowOnError>
): RequestResult<
  GetAllKubernetesApplicationResponses,
  GetAllKubernetesApplicationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesApplicationResponses,
    GetAllKubernetesApplicationErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesApplicationPath,
          query: zGetAllKubernetesApplicationQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesApplicationResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/applications/{name}',
    ...options,
  });

/**
 * Create a ConfigMap
 *
 * Create a ConfigMap in the given namespace. The response carries the
 * created ConfigMap's metadata only, not its data.
 * **Access policy**: Authenticated user.
 */
export const createKubernetesConfigMap = <ThrowOnError extends boolean = true>(
  options: Options<CreateKubernetesConfigMapData, ThrowOnError>
): RequestResult<
  CreateKubernetesConfigMapResponses,
  CreateKubernetesConfigMapErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateKubernetesConfigMapResponses,
    CreateKubernetesConfigMapErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateKubernetesConfigMapBody,
          path: zCreateKubernetesConfigMapPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCreateKubernetesConfigMapResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/configmaps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a ConfigMap
 *
 * Delete a ConfigMap in the given namespace.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesConfigMap = <ThrowOnError extends boolean = true>(
  options: Options<DeleteKubernetesConfigMapData, ThrowOnError>
): RequestResult<
  DeleteKubernetesConfigMapResponses,
  DeleteKubernetesConfigMapErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesConfigMapResponses,
    DeleteKubernetesConfigMapErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteKubernetesConfigMapPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesConfigMapResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/configmaps/{configmap}',
    ...options,
  });

/**
 * Get a ConfigMap
 *
 * Get a ConfigMap by name for a given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesConfigMap = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesConfigMapData, ThrowOnError>
): RequestResult<
  GetKubernetesConfigMapResponses,
  GetKubernetesConfigMapErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesConfigMapResponses,
    GetKubernetesConfigMapErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesConfigMapPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesConfigMapResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/configmaps/{configmap}',
    ...options,
  });

/**
 * Update a ConfigMap
 *
 * Update a ConfigMap in the given namespace. A nil field leaves the live
 * value untouched, so an empty map clears it, and binary data is preserved.
 * The response carries the updated ConfigMap's metadata only.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesConfigMap = <ThrowOnError extends boolean = true>(
  options: Options<UpdateKubernetesConfigMapData, ThrowOnError>
): RequestResult<
  UpdateKubernetesConfigMapResponses,
  UpdateKubernetesConfigMapErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesConfigMapResponses,
    UpdateKubernetesConfigMapErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesConfigMapBody,
          path: zUpdateKubernetesConfigMapPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateKubernetesConfigMapResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/configmaps/{configmap}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Kubernetes deployments within a namespace
 *
 * Get the list of Kubernetes deployments in the given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesDeploymentsForNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesDeploymentsForNamespaceData, ThrowOnError>
): RequestResult<
  GetKubernetesDeploymentsForNamespaceResponses,
  GetKubernetesDeploymentsForNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesDeploymentsForNamespaceResponses,
    GetKubernetesDeploymentsForNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesDeploymentsForNamespacePath,
          query: zGetKubernetesDeploymentsForNamespaceQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesDeploymentsForNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments',
    ...options,
  });

/**
 * Create a Kubernetes deployment
 *
 * Create a deployment in the given namespace. The namespace comes from the
 * route, and the payload models the fields the deployment forms drive.
 * **Access policy**: Authenticated user.
 */
export const createKubernetesDeployment = <ThrowOnError extends boolean = true>(
  options: Options<CreateKubernetesDeploymentData, ThrowOnError>
): RequestResult<
  CreateKubernetesDeploymentResponses,
  CreateKubernetesDeploymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateKubernetesDeploymentResponses,
    CreateKubernetesDeploymentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateKubernetesDeploymentBody,
          path: zCreateKubernetesDeploymentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCreateKubernetesDeploymentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a Kubernetes deployment
 *
 * Delete a deployment in the given namespace. The replica sets and pods it
 * owns are garbage collected by the cluster.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesDeployment = <ThrowOnError extends boolean = true>(
  options: Options<DeleteKubernetesDeploymentData, ThrowOnError>
): RequestResult<
  DeleteKubernetesDeploymentResponses,
  DeleteKubernetesDeploymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesDeploymentResponses,
    DeleteKubernetesDeploymentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteKubernetesDeploymentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesDeploymentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments/{name}',
    ...options,
  });

/**
 * Get a Kubernetes deployment
 *
 * Get a Kubernetes deployment in the given namespace. The response is
 * trimmed of server-managed and heavy fields (managed fields,
 * last-applied-config annotation) while preserving the full pod template,
 * spec and resourceVersion so an edit form can be reconstructed from the
 * live cluster and the workload subsequently updated.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesDeployment = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesDeploymentData, ThrowOnError>
): RequestResult<
  GetKubernetesDeploymentResponses,
  GetKubernetesDeploymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesDeploymentResponses,
    GetKubernetesDeploymentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesDeploymentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesDeploymentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments/{name}',
    ...options,
  });

/**
 * Annotate a Kubernetes deployment
 *
 * Add or overwrite annotations on a deployment and on the pods it creates.
 * Annotations the payload does not name are kept. Changing a pod annotation
 * rolls the workload, which is how a rollout restart is triggered.
 * **Access policy**: Authenticated user.
 */
export const patchKubernetesDeployment = <ThrowOnError extends boolean = true>(
  options: Options<PatchKubernetesDeploymentData, ThrowOnError>
): RequestResult<
  PatchKubernetesDeploymentResponses,
  PatchKubernetesDeploymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchKubernetesDeploymentResponses,
    PatchKubernetesDeploymentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zPatchKubernetesDeploymentBody,
          path: zPatchKubernetesDeploymentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPatchKubernetesDeploymentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a Kubernetes deployment
 *
 * Update a deployment in the given namespace. The payload is merged onto the
 * live deployment: fields it does not model, such as the update strategy or
 * the pod affinity rules, are preserved, and a field left out leaves the live
 * value untouched. The selector is immutable and is ignored.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesDeployment = <ThrowOnError extends boolean = true>(
  options: Options<UpdateKubernetesDeploymentData, ThrowOnError>
): RequestResult<
  UpdateKubernetesDeploymentResponses,
  UpdateKubernetesDeploymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesDeploymentResponses,
    UpdateKubernetesDeploymentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesDeploymentBody,
          path: zUpdateKubernetesDeploymentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateKubernetesDeploymentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Roll a Kubernetes deployment back
 *
 * Roll a deployment back to an earlier revision by replaying the pod template
 * the corresponding replica set recorded. A revision of 0, or an omitted one,
 * selects the revision immediately before the current.
 * **Access policy**: Authenticated user.
 */
export const rollbackKubernetesDeployment = <
  ThrowOnError extends boolean = true,
>(
  options: Options<RollbackKubernetesDeploymentData, ThrowOnError>
): RequestResult<
  RollbackKubernetesDeploymentResponses,
  RollbackKubernetesDeploymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RollbackKubernetesDeploymentResponses,
    RollbackKubernetesDeploymentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRollbackKubernetesDeploymentBody,
          path: zRollbackKubernetesDeploymentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRollbackKubernetesDeploymentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments/{name}/rollback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Scale a Kubernetes deployment
 *
 * Set the desired replica count of a deployment in the given namespace.
 * **Access policy**: Authenticated user.
 */
export const scaleKubernetesDeployment = <ThrowOnError extends boolean = true>(
  options: Options<ScaleKubernetesDeploymentData, ThrowOnError>
): RequestResult<
  ScaleKubernetesDeploymentResponses,
  ScaleKubernetesDeploymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ScaleKubernetesDeploymentResponses,
    ScaleKubernetesDeploymentErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zScaleKubernetesDeploymentBody,
          path: zScaleKubernetesDeploymentPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zScaleKubernetesDeploymentResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/deployments/{name}/scale',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Gets kubernetes events for namespace
 *
 * Get events by optional query param resourceId for a given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesEventsForNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesEventsForNamespaceData, ThrowOnError>
): RequestResult<
  GetKubernetesEventsForNamespaceResponses,
  GetKubernetesEventsForNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesEventsForNamespaceResponses,
    GetKubernetesEventsForNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesEventsForNamespacePath,
          query: zGetKubernetesEventsForNamespaceQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesEventsForNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/events',
    ...options,
  });

/**
 * Get a list ingress controllers by namespace
 *
 * Get a list of ingress controllers for the given environment in the provided namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesIngressControllersByNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesIngressControllersByNamespaceData, ThrowOnError>
): RequestResult<
  GetKubernetesIngressControllersByNamespaceResponses,
  GetKubernetesIngressControllersByNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesIngressControllersByNamespaceResponses,
    GetKubernetesIngressControllersByNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesIngressControllersByNamespacePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesIngressControllersByNamespaceResponse.parseAsync(
        data
      ),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/ingresscontrollers',
    ...options,
  });

/**
 * Update (block/unblock) ingress controllers by namespace
 *
 * Update (block/unblock) ingress controllers by namespace for the provided environment.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesIngressControllersByNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<
    UpdateKubernetesIngressControllersByNamespaceData,
    ThrowOnError
  >
): RequestResult<
  UpdateKubernetesIngressControllersByNamespaceResponses,
  UpdateKubernetesIngressControllersByNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesIngressControllersByNamespaceResponses,
    UpdateKubernetesIngressControllersByNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesIngressControllersByNamespaceBody,
          path: zUpdateKubernetesIngressControllersByNamespacePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUpdateKubernetesIngressControllersByNamespaceResponse.parseAsync(
        data
      ),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/ingresscontrollers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of Ingresses
 *
 * Get a list of Ingresses. If namespace is provided, it will return the list of Ingresses in that namespace.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesIngresses = <ThrowOnError extends boolean = true>(
  options: Options<GetAllKubernetesIngressesData, ThrowOnError>
): RequestResult<
  GetAllKubernetesIngressesResponses,
  GetAllKubernetesIngressesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesIngressesResponses,
    GetAllKubernetesIngressesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesIngressesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesIngressesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/ingresses',
    ...options,
  });

/**
 * Create an Ingress
 *
 * Create an Ingress for the provided environment.
 * **Access policy**: Authenticated user.
 */
export const createKubernetesIngress = <ThrowOnError extends boolean = true>(
  options: Options<CreateKubernetesIngressData, ThrowOnError>
): RequestResult<
  CreateKubernetesIngressResponses,
  CreateKubernetesIngressErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateKubernetesIngressResponses,
    CreateKubernetesIngressErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateKubernetesIngressBody,
          path: zCreateKubernetesIngressPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zCreateKubernetesIngressResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/ingresses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update an Ingress
 *
 * Update an Ingress for the provided environment.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesIngress = <ThrowOnError extends boolean = true>(
  options: Options<UpdateKubernetesIngressData, ThrowOnError>
): RequestResult<
  UpdateKubernetesIngressResponses,
  UpdateKubernetesIngressErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesIngressResponses,
    UpdateKubernetesIngressErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesIngressBody,
          path: zUpdateKubernetesIngressPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUpdateKubernetesIngressResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/ingresses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get an Ingress by name
 *
 * Get an Ingress by name for the provided environment.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesIngress = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesIngressData, ThrowOnError>
): RequestResult<
  GetKubernetesIngressResponses,
  GetKubernetesIngressErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesIngressResponses,
    GetKubernetesIngressErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesIngressPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesIngressResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/ingresses/{ingress}',
    ...options,
  });

/**
 * Get PersistentVolumeClaims in a namespace
 *
 * Get a list of PersistentVolumeClaims in the specified namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesPersistentVolumeClaimsInNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<
    GetKubernetesPersistentVolumeClaimsInNamespaceData,
    ThrowOnError
  >
): RequestResult<
  GetKubernetesPersistentVolumeClaimsInNamespaceResponses,
  GetKubernetesPersistentVolumeClaimsInNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesPersistentVolumeClaimsInNamespaceResponses,
    GetKubernetesPersistentVolumeClaimsInNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesPersistentVolumeClaimsInNamespacePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesPersistentVolumeClaimsInNamespaceResponse.parseAsync(
        data
      ),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/persistent_volume_claims',
    ...options,
  });

/**
 * Create a PersistentVolumeClaim
 *
 * Create a PersistentVolumeClaim in the given namespace. The access mode
 * defaults to ReadWriteOnce and an omitted storage class leaves the choice to
 * the cluster default.
 * **Access policy**: Authenticated user.
 */
export const createKubernetesPersistentVolumeClaim = <
  ThrowOnError extends boolean = true,
>(
  options: Options<CreateKubernetesPersistentVolumeClaimData, ThrowOnError>
): RequestResult<
  CreateKubernetesPersistentVolumeClaimResponses,
  CreateKubernetesPersistentVolumeClaimErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateKubernetesPersistentVolumeClaimResponses,
    CreateKubernetesPersistentVolumeClaimErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateKubernetesPersistentVolumeClaimBody,
          path: zCreateKubernetesPersistentVolumeClaimPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCreateKubernetesPersistentVolumeClaimResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/persistent_volume_claims',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a specific PersistentVolumeClaim
 *
 * Get a PersistentVolumeClaim by name within a namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesPersistentVolumeClaim = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesPersistentVolumeClaimData, ThrowOnError>
): RequestResult<
  GetKubernetesPersistentVolumeClaimResponses,
  GetKubernetesPersistentVolumeClaimErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesPersistentVolumeClaimResponses,
    GetKubernetesPersistentVolumeClaimErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesPersistentVolumeClaimPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesPersistentVolumeClaimResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/persistent_volume_claims/{name}',
    ...options,
  });

/**
 * Get Kubernetes pods within a namespace
 *
 * Get the list of Kubernetes pods in the given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesPodsForNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesPodsForNamespaceData, ThrowOnError>
): RequestResult<
  GetKubernetesPodsForNamespaceResponses,
  GetKubernetesPodsForNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesPodsForNamespaceResponses,
    GetKubernetesPodsForNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesPodsForNamespacePath,
          query: zGetKubernetesPodsForNamespaceQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesPodsForNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/pods',
    ...options,
  });

/**
 * Delete a kubernetes pod
 *
 * Delete a single Kubernetes pod in the given namespace. The owning
 * controller (Deployment, StatefulSet, DaemonSet, ...) is responsible
 * for recreating the pod. For naked pods the pod is removed permanently.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesPod = <ThrowOnError extends boolean = true>(
  options: Options<DeleteKubernetesPodData, ThrowOnError>
): RequestResult<
  DeleteKubernetesPodResponses,
  DeleteKubernetesPodErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesPodResponses,
    DeleteKubernetesPodErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteKubernetesPodPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesPodResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/pods/{name}',
    ...options,
  });

/**
 * Get logs for a Kubernetes pod
 *
 * Stream the logs for a pod in the given namespace as text/plain. When
 * follow is set the response stays open and emits new log lines until the
 * client disconnects. When the pod has more than one container, the
 * container query parameter is required.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesPodLogs = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesPodLogsData, ThrowOnError>
): RequestResult<
  GetKubernetesPodLogsResponses,
  GetKubernetesPodLogsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesPodLogsResponses,
    GetKubernetesPodLogsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesPodLogsPath,
          query: zGetKubernetesPodLogsQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'text',
    responseValidator: async (data) =>
      await zGetKubernetesPodLogsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/pods/{name}/log',
    ...options,
  });

/**
 * Restart all containers in a Kubernetes pod
 *
 * Restart all containers in a single Kubernetes pod in place using
 * the Kubernetes 1.35 alpha pod-restart subresource. The pod itself
 * is preserved. Requires the cluster to expose the corresponding
 * subresource (and the matching feature gate to be enabled).
 * **Access policy**: Authenticated user.
 */
export const restartKubernetesPod = <ThrowOnError extends boolean = true>(
  options: Options<RestartKubernetesPodData, ThrowOnError>
): RequestResult<
  RestartKubernetesPodResponses,
  RestartKubernetesPodErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RestartKubernetesPodResponses,
    RestartKubernetesPodErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zRestartKubernetesPodPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zRestartKubernetesPodResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/pods/{name}/restart',
    ...options,
  });

/**
 * Get Kubernetes replica sets within a namespace
 *
 * Get the list of Kubernetes replica sets in the given namespace, optionally
 * restricted to those owned by a given deployment. This backs the deployment
 * revisions view. The response uses the Kubernetes list shape ({items: [...]}).
 * **Access policy**: Authenticated user.
 */
export const getKubernetesReplicaSets = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesReplicaSetsData, ThrowOnError>
): RequestResult<
  GetKubernetesReplicaSetsResponses,
  GetKubernetesReplicaSetsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesReplicaSetsResponses,
    GetKubernetesReplicaSetsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesReplicaSetsPath,
          query: zGetKubernetesReplicaSetsQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesReplicaSetsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/replicasets',
    ...options,
  });

/**
 * Get Kubernetes resource quotas within a namespace
 *
 * Get the list of Kubernetes resource quotas in the given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesResourceQuotas = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesResourceQuotasData, ThrowOnError>
): RequestResult<
  GetKubernetesResourceQuotasResponses,
  GetKubernetesResourceQuotasErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesResourceQuotasResponses,
    GetKubernetesResourceQuotasErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesResourceQuotasPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesResourceQuotasResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/resource_quotas',
    ...options,
  });

/**
 * Create a Secret
 *
 * Create a Secret in the given namespace. Data values are sent as plain
 * strings and encoded server-side. The response carries the created
 * Secret's metadata only, not its data.
 * **Access policy**: Authenticated user.
 */
export const createKubernetesSecret = <ThrowOnError extends boolean = true>(
  options: Options<CreateKubernetesSecretData, ThrowOnError>
): RequestResult<
  CreateKubernetesSecretResponses,
  CreateKubernetesSecretErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateKubernetesSecretResponses,
    CreateKubernetesSecretErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateKubernetesSecretBody,
          path: zCreateKubernetesSecretPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCreateKubernetesSecretResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/secrets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a Secret
 *
 * Delete a Secret in the given namespace.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesSecret = <ThrowOnError extends boolean = true>(
  options: Options<DeleteKubernetesSecretData, ThrowOnError>
): RequestResult<
  DeleteKubernetesSecretResponses,
  DeleteKubernetesSecretErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteKubernetesSecretResponses,
    DeleteKubernetesSecretErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteKubernetesSecretPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesSecretResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/secrets/{secret}',
    ...options,
  });

/**
 * Get a Secret
 *
 * Get a Secret by name for a given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesSecret = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesSecretData, ThrowOnError>
): RequestResult<
  GetKubernetesSecretResponses,
  GetKubernetesSecretErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesSecretResponses,
    GetKubernetesSecretErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesSecretPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesSecretResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/secrets/{secret}',
    ...options,
  });

/**
 * Update a Secret
 *
 * Update a Secret in the given namespace. A nil field leaves the live value
 * untouched, so an empty map clears it, and the secret type cannot be
 * changed. The response carries the updated Secret's metadata only.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesSecret = <ThrowOnError extends boolean = true>(
  options: Options<UpdateKubernetesSecretData, ThrowOnError>
): RequestResult<
  UpdateKubernetesSecretResponses,
  UpdateKubernetesSecretErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesSecretResponses,
    UpdateKubernetesSecretErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesSecretBody,
          path: zUpdateKubernetesSecretPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateKubernetesSecretResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/secrets/{secret}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a kubernetes service account
 *
 * Get a kubernetes service account in the given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesServiceAccount = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesServiceAccountData, ThrowOnError>
): RequestResult<
  GetKubernetesServiceAccountResponses,
  GetKubernetesServiceAccountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesServiceAccountResponses,
    GetKubernetesServiceAccountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesServiceAccountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesServiceAccountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/service_accounts/{name}',
    ...options,
  });

/**
 * Update image pull secrets for a service account
 *
 * Replace the imagePullSecrets list on a service account with the provided list.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesServiceAccountImagePullSecrets = <
  ThrowOnError extends boolean = true,
>(
  options: Options<
    UpdateKubernetesServiceAccountImagePullSecretsData,
    ThrowOnError
  >
): RequestResult<
  UpdateKubernetesServiceAccountImagePullSecretsResponses,
  UpdateKubernetesServiceAccountImagePullSecretsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesServiceAccountImagePullSecretsResponses,
    UpdateKubernetesServiceAccountImagePullSecretsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesServiceAccountImagePullSecretsBody,
          path: zUpdateKubernetesServiceAccountImagePullSecretsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUpdateKubernetesServiceAccountImagePullSecretsResponse.parseAsync(
        data
      ),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/service_accounts/{name}/image_pull_secrets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of services for a given namespace
 *
 * Get a list of services for a given namespace.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesServicesByNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesServicesByNamespaceData, ThrowOnError>
): RequestResult<
  GetKubernetesServicesByNamespaceResponses,
  GetKubernetesServicesByNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesServicesByNamespaceResponses,
    GetKubernetesServicesByNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesServicesByNamespacePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesServicesByNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/services',
    ...options,
  });

/**
 * Create a service
 *
 * Create a service within a given namespace
 * **Access policy**: Authenticated user.
 */
export const createKubernetesService = <ThrowOnError extends boolean = true>(
  options: Options<CreateKubernetesServiceData, ThrowOnError>
): RequestResult<
  CreateKubernetesServiceResponses,
  CreateKubernetesServiceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateKubernetesServiceResponses,
    CreateKubernetesServiceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateKubernetesServiceBody,
          path: zCreateKubernetesServicePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zCreateKubernetesServiceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/services',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a service
 *
 * Update a service within a given namespace.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesService = <ThrowOnError extends boolean = true>(
  options: Options<UpdateKubernetesServiceData, ThrowOnError>
): RequestResult<
  UpdateKubernetesServiceResponses,
  UpdateKubernetesServiceErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesServiceResponses,
    UpdateKubernetesServiceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesServiceBody,
          path: zUpdateKubernetesServicePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUpdateKubernetesServiceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/services',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Toggle the system state for a namespace
 *
 * Toggle the system state for a namespace
 * **Access policy**: Administrator or environment administrator.
 */
export const kubernetesNamespacesToggleSystem = <
  ThrowOnError extends boolean = true,
>(
  options: Options<KubernetesNamespacesToggleSystemData, ThrowOnError>
): RequestResult<
  KubernetesNamespacesToggleSystemResponses,
  KubernetesNamespacesToggleSystemErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    KubernetesNamespacesToggleSystemResponses,
    KubernetesNamespacesToggleSystemErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zKubernetesNamespacesToggleSystemBody,
          path: zKubernetesNamespacesToggleSystemPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zKubernetesNamespacesToggleSystemResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/system',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Kubernetes volumes within a namespace in the given Portainer environment
 *
 * Get a list of kubernetes volumes within the specified namespace in the given environment (Endpoint). The Endpoint ID must be a valid Portainer environment identifier.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesVolumesInNamespace = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesVolumesInNamespaceData, ThrowOnError>
): RequestResult<
  GetKubernetesVolumesInNamespaceResponses,
  GetKubernetesVolumesInNamespaceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesVolumesInNamespaceResponses,
    GetKubernetesVolumesInNamespaceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesVolumesInNamespacePath,
          query: zGetKubernetesVolumesInNamespaceQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesVolumesInNamespaceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/{namespace}/volumes',
    ...options,
  });

/**
 * Get the total number of kubernetes namespaces within the given Portainer environment.
 *
 * Get the total number of kubernetes namespaces within the given environment, including the system namespaces. The total count depends on the user's role and permissions.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesNamespacesCount = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesNamespacesCountData, ThrowOnError>
): RequestResult<
  GetKubernetesNamespacesCountResponses,
  GetKubernetesNamespacesCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesNamespacesCountResponses,
    GetKubernetesNamespacesCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesNamespacesCountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesNamespacesCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/namespaces/count',
    ...options,
  });

/**
 * Get Kubernetes cluster nodes
 *
 * Returns the list of Kubernetes nodes for the selected environment.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesNodes = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesNodesData, ThrowOnError>
): RequestResult<
  GetKubernetesNodesResponses,
  GetKubernetesNodesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesNodesResponses,
    GetKubernetesNodesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesNodesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesNodesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/nodes',
    ...options,
  });

/**
 * Drain a Kubernetes node
 *
 * Drain a Kubernetes node by safely evicting all pods from the node, preparing it for maintenance or removal
 * **Access policy**: authenticated
 */
export const drainNode = <ThrowOnError extends boolean = true>(
  options: Options<DrainNodeData, ThrowOnError>
): RequestResult<DrainNodeResponses, DrainNodeErrors, ThrowOnError> =>
  (options.client ?? client).post<
    DrainNodeResponses,
    DrainNodeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDrainNodeBody.optional(),
          path: zDrainNodePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDrainNodeResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/nodes/{name}/drain',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get CPU and memory limits of all nodes within k8s cluster.
 *
 * Get CPU and memory limits of all nodes within k8s cluster.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesNodesLimits = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesNodesLimitsData, ThrowOnError>
): RequestResult<
  GetKubernetesNodesLimitsResponses,
  GetKubernetesNodesLimitsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesNodesLimitsResponses,
    GetKubernetesNodesLimitsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesNodesLimitsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesNodesLimitsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/nodes_limits',
    ...options,
  });

/**
 * Get all PersistentVolumeClaims
 *
 * Get a list of all PersistentVolumeClaims within the given environment. Scoped by namespace for non-admin users.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesPersistentVolumeClaims = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesPersistentVolumeClaimsData, ThrowOnError>
): RequestResult<
  GetAllKubernetesPersistentVolumeClaimsResponses,
  GetAllKubernetesPersistentVolumeClaimsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesPersistentVolumeClaimsResponses,
    GetAllKubernetesPersistentVolumeClaimsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesPersistentVolumeClaimsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesPersistentVolumeClaimsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/persistent_volume_claims',
    ...options,
  });

/**
 * Delete PersistentVolumeClaims
 *
 * Delete the provided list of PersistentVolumeClaims.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesPersistentVolumeClaims = <
  ThrowOnError extends boolean = true,
>(
  options: Options<DeleteKubernetesPersistentVolumeClaimsData, ThrowOnError>
): RequestResult<
  DeleteKubernetesPersistentVolumeClaimsResponses,
  DeleteKubernetesPersistentVolumeClaimsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteKubernetesPersistentVolumeClaimsResponses,
    DeleteKubernetesPersistentVolumeClaimsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteKubernetesPersistentVolumeClaimsBody,
          path: zDeleteKubernetesPersistentVolumeClaimsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesPersistentVolumeClaimsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/persistent_volume_claims/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Resize a PersistentVolumeClaim
 *
 * Resize a PVC to a new size. The StorageClass must support volume expansion.
 * **Access policy**: Authenticated user.
 */
export const resizeKubernetesPersistentVolumeClaim = <
  ThrowOnError extends boolean = true,
>(
  options: Options<ResizeKubernetesPersistentVolumeClaimData, ThrowOnError>
): RequestResult<
  ResizeKubernetesPersistentVolumeClaimResponses,
  ResizeKubernetesPersistentVolumeClaimErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ResizeKubernetesPersistentVolumeClaimResponses,
    ResizeKubernetesPersistentVolumeClaimErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zResizeKubernetesPersistentVolumeClaimBody,
          path: zResizeKubernetesPersistentVolumeClaimPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zResizeKubernetesPersistentVolumeClaimResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/persistent_volume_claims/resize',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all PersistentVolumes in the cluster
 *
 * Get a list of all PersistentVolumes in the given environment.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesPersistentVolumes = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesPersistentVolumesData, ThrowOnError>
): RequestResult<
  GetAllKubernetesPersistentVolumesResponses,
  GetAllKubernetesPersistentVolumesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesPersistentVolumesResponses,
    GetAllKubernetesPersistentVolumesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesPersistentVolumesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesPersistentVolumesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/persistent_volumes',
    ...options,
  });

/**
 * Get a specific PersistentVolume
 *
 * Get a PersistentVolume by name in the given environment.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesPersistentVolume = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesPersistentVolumeData, ThrowOnError>
): RequestResult<
  GetKubernetesPersistentVolumeResponses,
  GetKubernetesPersistentVolumeErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesPersistentVolumeResponses,
    GetKubernetesPersistentVolumeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesPersistentVolumePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesPersistentVolumeResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/persistent_volumes/{name}',
    ...options,
  });

/**
 * Delete PersistentVolumes
 *
 * Delete the provided list of PersistentVolumes.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesPersistentVolumes = <
  ThrowOnError extends boolean = true,
>(
  options: Options<DeleteKubernetesPersistentVolumesData, ThrowOnError>
): RequestResult<
  DeleteKubernetesPersistentVolumesResponses,
  DeleteKubernetesPersistentVolumesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteKubernetesPersistentVolumesResponses,
    DeleteKubernetesPersistentVolumesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteKubernetesPersistentVolumesBody,
          path: zDeleteKubernetesPersistentVolumesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesPersistentVolumesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/persistent_volumes/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update reclaim policy of a PersistentVolume
 *
 * Update the reclaim policy of a PersistentVolume.
 * **Access policy**: Authenticated user.
 */
export const updateKubernetesPersistentVolumeReclaimPolicy = <
  ThrowOnError extends boolean = true,
>(
  options: Options<
    UpdateKubernetesPersistentVolumeReclaimPolicyData,
    ThrowOnError
  >
): RequestResult<
  UpdateKubernetesPersistentVolumeReclaimPolicyResponses,
  UpdateKubernetesPersistentVolumeReclaimPolicyErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateKubernetesPersistentVolumeReclaimPolicyResponses,
    UpdateKubernetesPersistentVolumeReclaimPolicyErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateKubernetesPersistentVolumeReclaimPolicyBody,
          path: zUpdateKubernetesPersistentVolumeReclaimPolicyPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUpdateKubernetesPersistentVolumeReclaimPolicyResponse.parseAsync(
        data
      ),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/persistent_volumes/reclaim_policy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Kubernetes pods
 *
 * Get the list of Kubernetes pods across all namespaces the user can access.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesPods = <ThrowOnError extends boolean = true>(
  options: Options<GetAllKubernetesPodsData, ThrowOnError>
): RequestResult<
  GetAllKubernetesPodsResponses,
  GetAllKubernetesPodsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesPodsResponses,
    GetAllKubernetesPodsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesPodsPath,
          query: zGetAllKubernetesPodsQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesPodsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/pods',
    ...options,
  });

/**
 * Check if RBAC is enabled
 *
 * Check if RBAC is enabled in the specified Kubernetes cluster.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesRbacStatus = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesRbacStatusData, ThrowOnError>
): RequestResult<
  GetKubernetesRbacStatusResponses,
  GetKubernetesRbacStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesRbacStatusResponses,
    GetKubernetesRbacStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesRbacStatusPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesRbacStatusResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/rbac_enabled',
    ...options,
  });

/**
 * Delete role bindings
 *
 * Delete the provided list of role bindings.
 * **Access policy**: Authenticated user.
 */
export const deleteRoleBindings = <ThrowOnError extends boolean = true>(
  options: Options<DeleteRoleBindingsData, ThrowOnError>
): RequestResult<
  DeleteRoleBindingsResponses,
  DeleteRoleBindingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteRoleBindingsResponses,
    DeleteRoleBindingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteRoleBindingsBody,
          path: zDeleteRoleBindingsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteRoleBindingsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/role_bindings/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of kubernetes role bindings
 *
 * Get a list of kubernetes role bindings that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesRoleBindings = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesRoleBindingsData, ThrowOnError>
): RequestResult<
  GetKubernetesRoleBindingsResponses,
  GetKubernetesRoleBindingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesRoleBindingsResponses,
    GetKubernetesRoleBindingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesRoleBindingsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesRoleBindingsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/rolebindings',
    ...options,
  });

/**
 * Get a list of kubernetes roles
 *
 * Get a list of kubernetes roles that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesRoles = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesRolesData, ThrowOnError>
): RequestResult<
  GetKubernetesRolesResponses,
  GetKubernetesRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesRolesResponses,
    GetKubernetesRolesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesRolesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesRolesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/roles',
    ...options,
  });

/**
 * Delete roles
 *
 * Delete the provided list of roles.
 * **Access policy**: Authenticated user.
 */
export const deleteRoles = <ThrowOnError extends boolean = true>(
  options: Options<DeleteRolesData, ThrowOnError>
): RequestResult<DeleteRolesResponses, DeleteRolesErrors, ThrowOnError> =>
  (options.client ?? client).post<
    DeleteRolesResponses,
    DeleteRolesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteRolesBody,
          path: zDeleteRolesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteRolesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/roles/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of Secrets
 *
 * Get a list of Secrets for a given namespace. If isUsed is set to true, information about the applications that use the secrets is also returned.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesSecrets = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesSecretsData, ThrowOnError>
): RequestResult<
  GetKubernetesSecretsResponses,
  GetKubernetesSecretsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesSecretsResponses,
    GetKubernetesSecretsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesSecretsPath,
          query: zGetKubernetesSecretsQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesSecretsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/secrets',
    ...options,
  });

/**
 * Get Secrets count
 *
 * Get the count of Secrets across all namespaces that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesSecretsCount = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesSecretsCountData, ThrowOnError>
): RequestResult<
  GetKubernetesSecretsCountResponses,
  GetKubernetesSecretsCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesSecretsCountResponses,
    GetKubernetesSecretsCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesSecretsCountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesSecretsCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/secrets/count',
    ...options,
  });

/**
 * Delete service accounts
 *
 * Delete the provided list of service accounts.
 * **Access policy**: Authenticated user.
 */
export const deleteServiceAccounts = <ThrowOnError extends boolean = true>(
  options: Options<DeleteServiceAccountsData, ThrowOnError>
): RequestResult<
  DeleteServiceAccountsResponses,
  DeleteServiceAccountsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteServiceAccountsResponses,
    DeleteServiceAccountsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteServiceAccountsBody,
          path: zDeleteServiceAccountsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteServiceAccountsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/service_accounts/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a list of kubernetes service accounts
 *
 * Get a list of kubernetes service accounts that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesServiceAccounts = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetKubernetesServiceAccountsData, ThrowOnError>
): RequestResult<
  GetKubernetesServiceAccountsResponses,
  GetKubernetesServiceAccountsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesServiceAccountsResponses,
    GetKubernetesServiceAccountsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesServiceAccountsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesServiceAccountsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/serviceaccounts',
    ...options,
  });

/**
 * Get a list of services
 *
 * Get a list of services that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesServices = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesServicesData, ThrowOnError>
): RequestResult<
  GetKubernetesServicesResponses,
  GetKubernetesServicesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesServicesResponses,
    GetKubernetesServicesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesServicesPath,
          query: zGetKubernetesServicesQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesServicesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/services',
    ...options,
  });

/**
 * Get services count
 *
 * Get the count of services that the user has access to.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesServicesCount = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesServicesCountData, ThrowOnError>
): RequestResult<
  GetAllKubernetesServicesCountResponses,
  GetAllKubernetesServicesCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesServicesCountResponses,
    GetAllKubernetesServicesCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesServicesCountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesServicesCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/services/count',
    ...options,
  });

/**
 * Delete services
 *
 * Delete the provided list of services.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesServices = <ThrowOnError extends boolean = true>(
  options: Options<DeleteKubernetesServicesData, ThrowOnError>
): RequestResult<
  DeleteKubernetesServicesResponses,
  DeleteKubernetesServicesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteKubernetesServicesResponses,
    DeleteKubernetesServicesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteKubernetesServicesBody,
          path: zDeleteKubernetesServicesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesServicesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/services/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all StorageClasses
 *
 * Get a list of all StorageClasses in the given environment.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesStorageClasses = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesStorageClassesData, ThrowOnError>
): RequestResult<
  GetAllKubernetesStorageClassesResponses,
  GetAllKubernetesStorageClassesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesStorageClassesResponses,
    GetAllKubernetesStorageClassesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesStorageClassesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesStorageClassesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/storage_classes',
    ...options,
  });

/**
 * Get a specific StorageClass
 *
 * Get a StorageClass by name in the given environment.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesStorageClass = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesStorageClassData, ThrowOnError>
): RequestResult<
  GetKubernetesStorageClassResponses,
  GetKubernetesStorageClassErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesStorageClassResponses,
    GetKubernetesStorageClassErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesStorageClassPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesStorageClassResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/storage_classes/{name}',
    ...options,
  });

/**
 * Set a StorageClass as default
 *
 * Set the specified StorageClass as the cluster default, removing default from any other.
 * **Access policy**: Authenticated user.
 */
export const setDefaultKubernetesStorageClass = <
  ThrowOnError extends boolean = true,
>(
  options: Options<SetDefaultKubernetesStorageClassData, ThrowOnError>
): RequestResult<
  SetDefaultKubernetesStorageClassResponses,
  SetDefaultKubernetesStorageClassErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetDefaultKubernetesStorageClassResponses,
    SetDefaultKubernetesStorageClassErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zSetDefaultKubernetesStorageClassPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zSetDefaultKubernetesStorageClassResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/storage_classes/{name}/default',
    ...options,
  });

/**
 * Delete StorageClasses
 *
 * Delete the provided list of StorageClasses.
 * **Access policy**: Authenticated user.
 */
export const deleteKubernetesStorageClasses = <
  ThrowOnError extends boolean = true,
>(
  options: Options<DeleteKubernetesStorageClassesData, ThrowOnError>
): RequestResult<
  DeleteKubernetesStorageClassesResponses,
  DeleteKubernetesStorageClassesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteKubernetesStorageClassesResponses,
    DeleteKubernetesStorageClassesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDeleteKubernetesStorageClassesBody,
          path: zDeleteKubernetesStorageClassesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteKubernetesStorageClassesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/storage_classes/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get the Kubernetes cluster version and Portainer-relevant capabilities
 *
 * Get the Kubernetes cluster version (major, minor, gitVersion, ...)
 * as reported by the cluster's discovery API, augmented with capability
 * flags Portainer uses to gate UI features (e.g. supportsPodRestart).
 * **Access policy**: Authenticated user.
 */
export const getKubernetesVersion = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesVersionData, ThrowOnError>
): RequestResult<
  GetKubernetesVersionResponses,
  GetKubernetesVersionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesVersionResponses,
    GetKubernetesVersionErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesVersionPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesVersionResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/version',
    ...options,
  });

/**
 * Get Kubernetes volumes within the given Portainer environment
 *
 * Get a list of all kubernetes volumes within the given environment (Endpoint). The Endpoint ID must be a valid Portainer environment identifier.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesVolumes = <ThrowOnError extends boolean = true>(
  options: Options<GetAllKubernetesVolumesData, ThrowOnError>
): RequestResult<
  GetAllKubernetesVolumesResponses,
  GetAllKubernetesVolumesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesVolumesResponses,
    GetAllKubernetesVolumesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesVolumesPath,
          query: zGetAllKubernetesVolumesQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesVolumesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/volumes',
    ...options,
  });

/**
 * Get a Kubernetes volume within the given Portainer environment
 *
 * Get a Kubernetes volume within the given environment (Endpoint). The Endpoint ID must be a valid Portainer environment identifier.
 * **Access policy**: Authenticated user.
 */
export const getKubernetesVolume = <ThrowOnError extends boolean = true>(
  options: Options<GetKubernetesVolumeData, ThrowOnError>
): RequestResult<
  GetKubernetesVolumeResponses,
  GetKubernetesVolumeErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetKubernetesVolumeResponses,
    GetKubernetesVolumeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetKubernetesVolumePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetKubernetesVolumeResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/volumes/{namespace}/{volume}',
    ...options,
  });

/**
 * Get the total number of kubernetes volumes within the given Portainer environment.
 *
 * Get the total number of kubernetes volumes within the given environment (Endpoint). The total count depends on the user's role and permissions. The Endpoint ID must be a valid Portainer environment identifier.
 * **Access policy**: Authenticated user.
 */
export const getAllKubernetesVolumesCount = <
  ThrowOnError extends boolean = true,
>(
  options: Options<GetAllKubernetesVolumesCountData, ThrowOnError>
): RequestResult<
  GetAllKubernetesVolumesCountResponses,
  GetAllKubernetesVolumesCountErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAllKubernetesVolumesCountResponses,
    GetAllKubernetesVolumesCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAllKubernetesVolumesCountPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllKubernetesVolumesCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/kubernetes/{id}/volumes/count',
    ...options,
  });

/**
 * Fetch LDAP admin groups
 *
 * Fetch LDAP admin groups from LDAP server based on AdminGroupSearchSettings
 * **Access policy**: administrator
 */
export const ldapAdminGroups = <ThrowOnError extends boolean = true>(
  options: Options<LdapAdminGroupsData, ThrowOnError>
): RequestResult<
  LdapAdminGroupsResponses,
  LdapAdminGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    LdapAdminGroupsResponses,
    LdapAdminGroupsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zLdapAdminGroupsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zLdapAdminGroupsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/ldap/admin-groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Test LDAP connectivity
 *
 * Test LDAP connectivity using LDAP details
 * **Access policy**: administrator
 */
export const ldapCheck = <ThrowOnError extends boolean = true>(
  options: Options<LdapCheckData, ThrowOnError>
): RequestResult<LdapCheckResponses, LdapCheckErrors, ThrowOnError> =>
  (options.client ?? client).post<
    LdapCheckResponses,
    LdapCheckErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zLdapCheckBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zLdapCheckResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/ldap/check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search LDAP Groups
 *
 * **Access policy**: administrator
 */
export const ldapGroups = <ThrowOnError extends boolean = true>(
  options: Options<LdapGroupsData, ThrowOnError>
): RequestResult<LdapGroupsResponses, LdapGroupsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    LdapGroupsResponses,
    LdapGroupsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zLdapGroupsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zLdapGroupsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/ldap/groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Test Login to ldap server
 *
 * **Access policy**: administrator
 */
export const ldapTestLogin = <ThrowOnError extends boolean = true>(
  options: Options<LdapTestLoginData, ThrowOnError>
): RequestResult<LdapTestLoginResponses, LdapTestLoginErrors, ThrowOnError> =>
  (options.client ?? client).post<
    LdapTestLoginResponses,
    LdapTestLoginErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zLdapTestLoginBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zLdapTestLoginResponse2.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/ldap/test',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search LDAP Users
 *
 * **Access policy**: administrator
 */
export const ldapUsers = <ThrowOnError extends boolean = true>(
  options: Options<LdapUsersData, ThrowOnError>
): RequestResult<LdapUsersResponses, LdapUsersErrors, ThrowOnError> =>
  (options.client ?? client).post<
    LdapUsersResponses,
    LdapUsersErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zLdapUsersBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zLdapUsersResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/ldap/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * fetches the list of licenses on Portainer
 *
 * **Access policy**: administrator
 */
export const licensesList = <ThrowOnError extends boolean = true>(
  options?: Options<LicensesListData, ThrowOnError>
): RequestResult<LicensesListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<LicensesListResponses, unknown, ThrowOnError>(
    {
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await zLicensesListResponse.parseAsync(data),
      security: [
        { name: 'X-API-KEY', type: 'apiKey' },
        { name: 'Authorization', type: 'apiKey' },
      ],
      url: '/licenses',
      ...options,
    }
  );

/**
 * attaches a list of licenses to Portainer
 *
 * **Access policy**: administrator
 */
export const licensesAttach = <ThrowOnError extends boolean = true>(
  options: Options<LicensesAttachData2, ThrowOnError>
): RequestResult<LicensesAttachResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    LicensesAttachResponses,
    unknown,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zLicensesAttachBody,
          path: z.never().optional(),
          query: zLicensesAttachQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zLicensesAttachResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/licenses/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * summarizes licenses on Portainer
 *
 * **Access policy**: administrator
 */
export const licensesInfo = <ThrowOnError extends boolean = true>(
  options?: Options<LicensesInfoData, ThrowOnError>
): RequestResult<LicensesInfoResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<LicensesInfoResponses, unknown, ThrowOnError>(
    {
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await zLicensesInfoResponse.parseAsync(data),
      security: [
        { name: 'X-API-KEY', type: 'apiKey' },
        { name: 'Authorization', type: 'apiKey' },
      ],
      url: '/licenses/info',
      ...options,
    }
  );

/**
 * delete license from portainer instance
 *
 * **Access policy**: administrator
 */
export const licensesDelete = <ThrowOnError extends boolean = true>(
  options: Options<LicensesDeleteData, ThrowOnError>
): RequestResult<LicensesDeleteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    LicensesDeleteResponses,
    unknown,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zLicensesDeleteBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/licenses/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * fetches the message of the day
 *
 * **Access policy**: restricted
 */
export const motd = <ThrowOnError extends boolean = true>(
  options?: Options<MotdData, ThrowOnError>
): RequestResult<MotdResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MotdResponses, unknown, ThrowOnError>({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zMotdResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/motd',
    ...options,
  });

/**
 * Get active or silenced alerts
 *
 * Get a list of active or silenced alerts from the AlertManager.
 * **Access policy**: Administrator.
 */
export const getAlerts = <ThrowOnError extends boolean = true>(
  options: Options<GetAlertsData, ThrowOnError>
): RequestResult<GetAlertsResponses, GetAlertsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetAlertsResponses,
    GetAlertsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zGetAlertsQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAlertsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/alerts',
    ...options,
  });

/**
 * Test AlertManager connectivity
 *
 * Test connectivity to an AlertManager instance by retrieving its status.
 * **Access policy**: Administrator.
 */
export const testAlertManagerConnectivity = <
  ThrowOnError extends boolean = true,
>(
  options: Options<TestAlertManagerConnectivityData, ThrowOnError>
): RequestResult<
  TestAlertManagerConnectivityResponses,
  TestAlertManagerConnectivityErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    TestAlertManagerConnectivityResponses,
    TestAlertManagerConnectivityErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zTestAlertManagerConnectivityQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTestAlertManagerConnectivityResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/connectivity',
    ...options,
  });

/**
 * Get all alert rules
 *
 * Get a list of all alert rules from the AlertManager.
 * **Access policy**: Administrator.
 */
export const getAllAlertRules = <ThrowOnError extends boolean = true>(
  options?: Options<GetAllAlertRulesData, ThrowOnError>
): RequestResult<
  GetAllAlertRulesResponses,
  GetAllAlertRulesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAllAlertRulesResponses,
    GetAllAlertRulesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllAlertRulesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules',
    ...options,
  });

/**
 * Create an alert rule
 *
 * Create a new alert rule.
 * **Access policy**: Administrator.
 */
export const createAlertRule = <ThrowOnError extends boolean = true>(
  options: Options<CreateAlertRuleData, ThrowOnError>
): RequestResult<
  CreateAlertRuleResponses,
  CreateAlertRuleErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAlertRuleResponses,
    CreateAlertRuleErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateAlertRuleBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCreateAlertRuleResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete an alert rule
 *
 * Delete a specific alert rule by its identifier.
 * **Access policy**: Administrator.
 */
export const deleteAlertRule = <ThrowOnError extends boolean = true>(
  options: Options<DeleteAlertRuleData, ThrowOnError>
): RequestResult<
  DeleteAlertRuleResponses,
  DeleteAlertRuleErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAlertRuleResponses,
    DeleteAlertRuleErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteAlertRulePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zDeleteAlertRuleResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules/{id}',
    ...options,
  });

/**
 * Get an alert rule by ID
 *
 * Get a specific alert rule by its identifier.
 * **Access policy**: Administrator.
 */
export const getAlertRule = <ThrowOnError extends boolean = true>(
  options: Options<GetAlertRuleData, ThrowOnError>
): RequestResult<GetAlertRuleResponses, GetAlertRuleErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetAlertRuleResponses,
    GetAlertRuleErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAlertRulePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAlertRuleResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules/{id}',
    ...options,
  });

/**
 * Update an alert rule
 *
 * Update a specific alert rule by its identifier.
 * **Access policy**: Administrator.
 */
export const updateAlertRule = <ThrowOnError extends boolean = true>(
  options: Options<UpdateAlertRuleData, ThrowOnError>
): RequestResult<
  UpdateAlertRuleResponses,
  UpdateAlertRuleErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAlertRuleResponses,
    UpdateAlertRuleErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateAlertRuleBody,
          path: zUpdateAlertRulePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateAlertRuleResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get alert rule environments
 *
 * Get alert rule delivery status grouped by environment(endpoint) group.
 * **Access policy**: Administrator.
 */
export const getAlertRuleEnvironments = <ThrowOnError extends boolean = true>(
  options: Options<GetAlertRuleEnvironmentsData, ThrowOnError>
): RequestResult<
  GetAlertRuleEnvironmentsResponses,
  GetAlertRuleEnvironmentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAlertRuleEnvironmentsResponses,
    GetAlertRuleEnvironmentsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAlertRuleEnvironmentsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAlertRuleEnvironmentsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules/{id}/environments',
    ...options,
  });

/**
 * Update alert rule endpoint groups
 *
 * Replace the endpoint group attachments for an alert rule.
 * **Access policy**: Administrator.
 */
export const updateAlertRuleGroups = <ThrowOnError extends boolean = true>(
  options: Options<UpdateAlertRuleGroupsData, ThrowOnError>
): RequestResult<
  UpdateAlertRuleGroupsResponses,
  UpdateAlertRuleGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAlertRuleGroupsResponses,
    UpdateAlertRuleGroupsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateAlertRuleGroupsBody,
          path: zUpdateAlertRuleGroupsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateAlertRuleGroupsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules/{id}/groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update alert rule tiers
 *
 * Update multi-severity tier configuration for an editable internal alert rule.
 * **Access policy**: Administrator.
 */
export const updateAlertRuleTiers = <ThrowOnError extends boolean = true>(
  options: Options<UpdateAlertRuleTiersData, ThrowOnError>
): RequestResult<
  UpdateAlertRuleTiersResponses,
  UpdateAlertRuleTiersErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAlertRuleTiersResponses,
    UpdateAlertRuleTiersErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateAlertRuleTiersBody,
          path: zUpdateAlertRuleTiersPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateAlertRuleTiersResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/rules/{id}/tiers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all alerting settings
 *
 * Get a list of all alerting settings with their connection status.
 * **Access policy**: Administrator.
 */
export const getAllAlertingSettings = <ThrowOnError extends boolean = true>(
  options?: Options<GetAllAlertingSettingsData, ThrowOnError>
): RequestResult<
  GetAllAlertingSettingsResponses,
  GetAllAlertingSettingsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAllAlertingSettingsResponses,
    GetAllAlertingSettingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAllAlertingSettingsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/settings',
    ...options,
  });

/**
 * Update alerting settings
 *
 * Update alerting settings and manage internal AlertManager lifecycle.
 * **Access policy**: Administrator.
 */
export const updateAlertingSettings = <ThrowOnError extends boolean = true>(
  options: Options<UpdateAlertingSettingsData, ThrowOnError>
): RequestResult<
  UpdateAlertingSettingsResponses,
  UpdateAlertingSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAlertingSettingsResponses,
    UpdateAlertingSettingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUpdateAlertingSettingsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUpdateAlertingSettingsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get alerting settings by ID
 *
 * Get specific alerting settings by its identifier, including connection status.
 * **Access policy**: Administrator.
 */
export const getAlertingSettings = <ThrowOnError extends boolean = true>(
  options: Options<GetAlertingSettingsData, ThrowOnError>
): RequestResult<
  GetAlertingSettingsResponses,
  GetAlertingSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAlertingSettingsResponses,
    GetAlertingSettingsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zGetAlertingSettingsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetAlertingSettingsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/settings/{id}',
    ...options,
  });

/**
 * Create an alert silence
 *
 * Create a new silence for alerts in the specified AlertManager.
 * **Access policy**: Administrator.
 */
export const createSilence = <ThrowOnError extends boolean = true>(
  options: Options<CreateSilenceData, ThrowOnError>
): RequestResult<CreateSilenceResponses, CreateSilenceErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateSilenceResponses,
    CreateSilenceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zCreateSilenceBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCreateSilenceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/silence',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete an alert silence
 *
 * Delete a specific alert silence by its identifier from the specified AlertManager.
 * **Access policy**: Administrator.
 */
export const deleteSilence = <ThrowOnError extends boolean = true>(
  options: Options<DeleteSilenceData, ThrowOnError>
): RequestResult<DeleteSilenceResponses, DeleteSilenceErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteSilenceResponses,
    DeleteSilenceErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zDeleteSilencePath,
          query: zDeleteSilenceQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zDeleteSilenceResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/alerting/silence/{id}',
    ...options,
  });

/**
 * Discover the observability provider for an environment
 *
 * Report whether observability is enabled for the environment, which provider serves it, and the non-secret connection details.
 * **Access policy**: authenticated
 */
export const environmentObservabilityDiscovery = <
  ThrowOnError extends boolean = true,
>(
  options: Options<EnvironmentObservabilityDiscoveryData, ThrowOnError>
): RequestResult<
  EnvironmentObservabilityDiscoveryResponses,
  EnvironmentObservabilityDiscoveryErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EnvironmentObservabilityDiscoveryResponses,
    EnvironmentObservabilityDiscoveryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEnvironmentObservabilityDiscoveryPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zEnvironmentObservabilityDiscoveryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/environments/{id}',
    ...options,
  });

/**
 * Query resource-scoped logs for an environment
 *
 * Returns a normalized log stream from the environment's observability
 * provider (OneUptime), scoped to an optional namespace and optionally a workload
 * or pod, over a time range. When namespace is omitted, cluster-wide logs are
 * returned; this requires admin, edge-admin, or cluster-wide namespace access.
 * **Access policy**: authenticated
 */
export const observabilityEnvironmentLogs = <
  ThrowOnError extends boolean = true,
>(
  options: Options<ObservabilityEnvironmentLogsData, ThrowOnError>
): RequestResult<
  ObservabilityEnvironmentLogsResponses,
  ObservabilityEnvironmentLogsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ObservabilityEnvironmentLogsResponses,
    ObservabilityEnvironmentLogsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: { severity: { array: { explode: false } } },
    },
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zObservabilityEnvironmentLogsPath,
          query: zObservabilityEnvironmentLogsQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zObservabilityEnvironmentLogsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/environments/{id}/logs',
    ...options,
  });

/**
 * Query resource-scoped metrics for an environment
 *
 * Returns aggregated metrics from the environment's observability
 * provider (OneUptime), scoped to a namespace and optionally a workload
 * or pod, over a time range.
 * **Access policy**: authenticated
 */
export const observabilityEnvironmentMetrics = <
  ThrowOnError extends boolean = true,
>(
  options: Options<ObservabilityEnvironmentMetricsData, ThrowOnError>
): RequestResult<
  ObservabilityEnvironmentMetricsResponses,
  ObservabilityEnvironmentMetricsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ObservabilityEnvironmentMetricsResponses,
    ObservabilityEnvironmentMetricsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zObservabilityEnvironmentMetricsPath,
          query: zObservabilityEnvironmentMetricsQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zObservabilityEnvironmentMetricsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/observability/environments/{id}/metrics',
    ...options,
  });

/**
 * Get an Omni cluster
 *
 * Retrieve details of an Omni cluster by name.
 * **Access policy**: administrator
 */
export const omniGetCluster = <ThrowOnError extends boolean = true>(
  options: Options<OmniGetClusterData, ThrowOnError>
): RequestResult<OmniGetClusterResponses, OmniGetClusterErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OmniGetClusterResponses,
    OmniGetClusterErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniGetClusterPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniGetClusterResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/{name}',
    ...options,
  });

/**
 * Get Kubernetes upgrade status for an Omni cluster
 *
 * Retrieve the Kubernetes version upgrade status for the specified Omni cluster.
 * **Access policy**: administrator
 */
export const omniGetK8sVersionUpgradeStatus = <
  ThrowOnError extends boolean = true,
>(
  options: Options<OmniGetK8sVersionUpgradeStatusData, ThrowOnError>
): RequestResult<
  OmniGetK8sVersionUpgradeStatusResponses,
  OmniGetK8sVersionUpgradeStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OmniGetK8sVersionUpgradeStatusResponses,
    OmniGetK8sVersionUpgradeStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniGetK8sVersionUpgradeStatusPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniGetK8sVersionUpgradeStatusResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/{name}/upgrade/status/k8s',
    ...options,
  });

/**
 * Get Talos upgrade status for an Omni cluster
 *
 * Retrieve the Talos version upgrade status for the specified Omni cluster.
 * **Access policy**: administrator
 */
export const omniGetTalosVersionUpgradeStatus = <
  ThrowOnError extends boolean = true,
>(
  options: Options<OmniGetTalosVersionUpgradeStatusData, ThrowOnError>
): RequestResult<
  OmniGetTalosVersionUpgradeStatusResponses,
  OmniGetTalosVersionUpgradeStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OmniGetTalosVersionUpgradeStatusResponses,
    OmniGetTalosVersionUpgradeStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniGetTalosVersionUpgradeStatusPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniGetTalosVersionUpgradeStatusResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/{name}/upgrade/status/talos',
    ...options,
  });

/**
 * Create an Omni cluster
 *
 * Create a new Talos cluster via Omni using the provided cloud credential.
 * **Access policy**: administrator
 */
export const omniCreateCluster = <ThrowOnError extends boolean = true>(
  options: Options<OmniCreateClusterData, ThrowOnError>
): RequestResult<
  OmniCreateClusterResponses,
  OmniCreateClusterErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OmniCreateClusterResponses,
    OmniCreateClusterErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zOmniCreateClusterBody,
          path: zOmniCreateClusterPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniCreateClusterResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete an Omni cluster
 *
 * Delete an Omni cluster by name.
 * **Access policy**: administrator
 */
export const omniDeleteCluster = <ThrowOnError extends boolean = true>(
  options: Options<OmniDeleteClusterData, ThrowOnError>
): RequestResult<
  OmniDeleteClusterResponses,
  OmniDeleteClusterErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    OmniDeleteClusterResponses,
    OmniDeleteClusterErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniDeleteClusterPath,
          query: zOmniDeleteClusterQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zOmniDeleteClusterResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/delete',
    ...options,
  });

/**
 * Cancel an Omni cluster provisioning
 *
 * Stop the provisioning of an Omni environment and mark it as errored, optionally deleting the partially created cluster in Omni.
 * **Access policy**: administrator
 */
export const omniCancelProvisioning = <ThrowOnError extends boolean = true>(
  options: Options<OmniCancelProvisioningData, ThrowOnError>
): RequestResult<
  OmniCancelProvisioningResponses,
  OmniCancelProvisioningErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OmniCancelProvisioningResponses,
    OmniCancelProvisioningErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zOmniCancelProvisioningBody,
          path: zOmniCancelProvisioningPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zOmniCancelProvisioningResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/provision/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update an Omni cluster
 *
 * Update a cluster's Kubernetes version, Talos version, or node membership.
 * **Access policy**: administrator
 */
export const omniUpdateCluster = <ThrowOnError extends boolean = true>(
  options: Options<OmniUpdateClusterData, ThrowOnError>
): RequestResult<
  OmniUpdateClusterResponses,
  OmniUpdateClusterErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    OmniUpdateClusterResponses,
    OmniUpdateClusterErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zOmniUpdateClusterBody,
          path: zOmniUpdateClusterPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zOmniUpdateClusterResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Validate an Omni cluster configuration
 *
 * Run an Omni dry-run sync of the provided cluster configuration without creating any
 * resources in Omni or Portainer. Used by the cluster creation wizard to surface
 * configuration errors before provisioning.
 * **Access policy**: administrator
 */
export const omniValidateCluster = <ThrowOnError extends boolean = true>(
  options: Options<OmniValidateClusterData, ThrowOnError>
): RequestResult<
  OmniValidateClusterResponses,
  OmniValidateClusterErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OmniValidateClusterResponses,
    OmniValidateClusterErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zOmniValidateClusterBody,
          path: zOmniValidateClusterPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zOmniValidateClusterResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get supported Talos versions
 *
 * Retrieve all supported Talos versions and their compatible Kubernetes versions.
 * **Access policy**: administrator
 */
export const omniGetSupportedTalosVersions = <
  ThrowOnError extends boolean = true,
>(
  options: Options<OmniGetSupportedTalosVersionsData, ThrowOnError>
): RequestResult<
  OmniGetSupportedTalosVersionsResponses,
  OmniGetSupportedTalosVersionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OmniGetSupportedTalosVersionsResponses,
    OmniGetSupportedTalosVersionsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniGetSupportedTalosVersionsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniGetSupportedTalosVersionsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/cluster/version/talos',
    ...options,
  });

/**
 * Get an Omni machine
 *
 * Retrieve details of an Omni machine by name.
 * **Access policy**: administrator
 */
export const omniGetMachine = <ThrowOnError extends boolean = true>(
  options: Options<OmniGetMachineData, ThrowOnError>
): RequestResult<OmniGetMachineResponses, OmniGetMachineErrors, ThrowOnError> =>
  (options.client ?? client).get<
    OmniGetMachineResponses,
    OmniGetMachineErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniGetMachinePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniGetMachineResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/machine/{name}',
    ...options,
  });

/**
 * Get logs for an Omni machine
 *
 * Retrieve logs from an Omni machine by name.
 * **Access policy**: administrator
 */
export const omniGetMachineLogs = <ThrowOnError extends boolean = true>(
  options: Options<OmniGetMachineLogsData, ThrowOnError>
): RequestResult<
  OmniGetMachineLogsResponses,
  OmniGetMachineLogsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OmniGetMachineLogsResponses,
    OmniGetMachineLogsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniGetMachineLogsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniGetMachineLogsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/machine/{name}/logs',
    ...options,
  });

/**
 * List Omni machines
 *
 * List machines registered in Omni, optionally filtered by cluster or availability.
 * **Access policy**: administrator
 */
export const omniListMachines = <ThrowOnError extends boolean = true>(
  options: Options<OmniListMachinesData, ThrowOnError>
): RequestResult<
  OmniListMachinesResponses,
  OmniListMachinesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    OmniListMachinesResponses,
    OmniListMachinesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniListMachinesPath,
          query: zOmniListMachinesQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zOmniListMachinesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/machines',
    ...options,
  });

/**
 * Reboot an Omni node
 *
 * Reboot a node in an Omni-managed Talos cluster.
 * **Access policy**: administrator
 */
export const omniRebootNode = <ThrowOnError extends boolean = true>(
  options: Options<OmniRebootNodeData, ThrowOnError>
): RequestResult<OmniRebootNodeResponses, OmniRebootNodeErrors, ThrowOnError> =>
  (options.client ?? client).post<
    OmniRebootNodeResponses,
    OmniRebootNodeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zOmniRebootNodePath,
          query: zOmniRebootNodeQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zOmniRebootNodeResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/{credentialID}/node/{name}',
    ...options,
  });

/**
 * Validate an Omni service account
 *
 * Validate Omni service account credentials by testing connectivity to the Omni endpoint.
 * **Access policy**: administrator
 */
export const omniValidateServiceAccount = <ThrowOnError extends boolean = true>(
  options?: Options<OmniValidateServiceAccountData, ThrowOnError>
): RequestResult<
  OmniValidateServiceAccountResponses,
  OmniValidateServiceAccountErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    OmniValidateServiceAccountResponses,
    OmniValidateServiceAccountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zOmniValidateServiceAccountQuery.optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/omni/serviceaccount/validate',
    ...options,
  });

/**
 * List policies
 *
 * List all policies in the bucket.
 * **Access policy**: administrator
 */
export const policyList = <ThrowOnError extends boolean = true>(
  options?: Options<PolicyListData, ThrowOnError>
): RequestResult<PolicyListResponses, PolicyListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    PolicyListResponses,
    PolicyListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies',
    ...options,
  });

/**
 * Create a new policy
 *
 * Create a new policy.
 * **Access policy**: administrator
 */
export const policyCreate = <ThrowOnError extends boolean = true>(
  options: Options<PolicyCreateData, ThrowOnError>
): RequestResult<PolicyCreateResponses, PolicyCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PolicyCreateResponses,
    PolicyCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zPolicyCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a policy
 *
 * Delete a policy.
 * **Access policy**: administrator
 */
export const policyDelete = <ThrowOnError extends boolean = true>(
  options: Options<PolicyDeleteData, ThrowOnError>
): RequestResult<PolicyDeleteResponses, PolicyDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    PolicyDeleteResponses,
    PolicyDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zPolicyDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zPolicyDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies/{id}',
    ...options,
  });

/**
 * Inspect a policy
 *
 * Retrieve details about a policy.
 * **Access policy**: authenticated
 */
export const policyInspect = <ThrowOnError extends boolean = true>(
  options: Options<PolicyInspectData, ThrowOnError>
): RequestResult<PolicyInspectResponses, PolicyInspectErrors, ThrowOnError> =>
  (options.client ?? client).get<
    PolicyInspectResponses,
    PolicyInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zPolicyInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies/{id}',
    ...options,
  });

/**
 * Update a policy
 *
 * Update an existing policy.
 * **Access policy**: administrator
 */
export const policyUpdate = <ThrowOnError extends boolean = true>(
  options: Options<PolicyUpdateData, ThrowOnError>
): RequestResult<PolicyUpdateResponses, PolicyUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    PolicyUpdateResponses,
    PolicyUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zPolicyUpdateBody,
          path: zPolicyUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get policy conflicts preview
 *
 * Returns detailed information about what will be affected when creating or updating a policy with specific environment groups.
 * **Access policy**: administrator
 */
export const policyConflicts = <ThrowOnError extends boolean = true>(
  options: Options<PolicyConflictsData, ThrowOnError>
): RequestResult<
  PolicyConflictsResponses,
  PolicyConflictsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PolicyConflictsResponses,
    PolicyConflictsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zPolicyConflictsBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyConflictsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies/conflicts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get policy metadata
 *
 * Retrieve policy metadata including minimum agent versions for each policy type.
 * **Access policy**: administrator
 */
export const policyMetadata = <ThrowOnError extends boolean = true>(
  options?: Options<PolicyMetadataData, ThrowOnError>
): RequestResult<PolicyMetadataResponses, PolicyMetadataErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    PolicyMetadataResponses,
    PolicyMetadataErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyMetadataResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies/metadata',
    ...options,
  });

/**
 * Test OneUptime connection
 *
 * Validates that the supplied OneUptime URL, API key and project ID are accepted by the OneUptime API.
 * **Access policy**: administrator
 */
export const policyTestObservabilityConnection = <
  ThrowOnError extends boolean = true,
>(
  options: Options<PolicyTestObservabilityConnectionData, ThrowOnError>
): RequestResult<
  PolicyTestObservabilityConnectionResponses,
  PolicyTestObservabilityConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PolicyTestObservabilityConnectionResponses,
    PolicyTestObservabilityConnectionErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zPolicyTestObservabilityConnectionBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyTestObservabilityConnectionResponse.parseAsync(data),
    url: '/policies/observability-k8s/test',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List policy templates
 *
 * List all built-in policy templates. Templates can be filtered by category or type.
 * **Access policy**: administrator
 */
export const policyTemplateList = <ThrowOnError extends boolean = true>(
  options?: Options<PolicyTemplateListData, ThrowOnError>
): RequestResult<PolicyTemplateListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    PolicyTemplateListResponses,
    unknown,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zPolicyTemplateListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyTemplateListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies/templates',
    ...options,
  });

/**
 * Inspect a policy template
 *
 * Retrieve a specific policy template by ID.
 * **Access policy**: administrator
 */
export const policyTemplateInspect = <ThrowOnError extends boolean = true>(
  options: Options<PolicyTemplateInspectData, ThrowOnError>
): RequestResult<
  PolicyTemplateInspectResponses,
  PolicyTemplateInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PolicyTemplateInspectResponses,
    PolicyTemplateInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zPolicyTemplateInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zPolicyTemplateInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/policies/templates/{id}',
    ...options,
  });

/**
 * List recommendations
 *
 * Computes and returns all active recommendations. Returns an error if any provider fails. Admin-only.
 */
export const recommendationList = <ThrowOnError extends boolean = true>(
  options?: Options<RecommendationListData, ThrowOnError>
): RequestResult<
  RecommendationListResponses,
  RecommendationListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    RecommendationListResponses,
    RecommendationListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zRecommendationListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRecommendationListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/recommendations',
    ...options,
  });

/**
 * Get recommendation summary
 *
 * Returns counts by severity and category for sidebar badge. Admin-only.
 */
export const recommendationSummary = <ThrowOnError extends boolean = true>(
  options?: Options<RecommendationSummaryData, ThrowOnError>
): RequestResult<RecommendationSummaryResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    RecommendationSummaryResponses,
    unknown,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRecommendationSummaryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/recommendations/summary',
    ...options,
  });

/**
 * List Registries
 *
 * List all registries.
 * Administrators and edge-admins receive the full registry record (minus passwords).
 * All other authenticated users receive a scrubbed record containing only ID, Name, and Type.
 * **Access policy**: authenticated
 */
export const registryList = <ThrowOnError extends boolean = true>(
  options?: Options<RegistryListData, ThrowOnError>
): RequestResult<RegistryListResponses, RegistryListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    RegistryListResponses,
    RegistryListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRegistryListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries',
    ...options,
  });

/**
 * Create a new registry
 *
 * Create a new registry.
 * **Access policy**: restricted
 */
export const registryCreate = <ThrowOnError extends boolean = true>(
  options: Options<RegistryCreateData, ThrowOnError>
): RequestResult<RegistryCreateResponses, RegistryCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RegistryCreateResponses,
    RegistryCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRegistryCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRegistryCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a registry
 *
 * Remove a registry
 * **Access policy**: restricted
 */
export const registryDelete = <ThrowOnError extends boolean = true>(
  options: Options<RegistryDeleteData, ThrowOnError>
): RequestResult<RegistryDeleteResponses, RegistryDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RegistryDeleteResponses,
    RegistryDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zRegistryDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zRegistryDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries/{id}',
    ...options,
  });

/**
 * Inspect a registry
 *
 * Retrieve details about a registry. If endpointId is provided, applies policy overrides for that environment.
 * **Access policy**: restricted
 */
export const registryInspect = <ThrowOnError extends boolean = true>(
  options: Options<RegistryInspectData, ThrowOnError>
): RequestResult<
  RegistryInspectResponses,
  RegistryInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RegistryInspectResponses,
    RegistryInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zRegistryInspectPath,
          query: zRegistryInspectQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRegistryInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries/{id}',
    ...options,
  });

/**
 * Update a registry
 *
 * Update a registry
 * **Access policy**: restricted
 */
export const registryUpdate = <ThrowOnError extends boolean = true>(
  options: Options<RegistryUpdateData, ThrowOnError>
): RequestResult<RegistryUpdateResponses, RegistryUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    RegistryUpdateResponses,
    RegistryUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRegistryUpdateBody,
          path: zRegistryUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRegistryUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Configures a registry
 *
 * Configures a registry.
 * **Access policy**: restricted
 */
export const registryConfigure = <ThrowOnError extends boolean = true>(
  options: Options<RegistryConfigureData, ThrowOnError>
): RequestResult<
  RegistryConfigureResponses,
  RegistryConfigureErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RegistryConfigureResponses,
    RegistryConfigureErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRegistryConfigureBody,
          path: zRegistryConfigurePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zRegistryConfigureResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries/{id}/configure',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete ECR repository
 *
 * Delete ECR repository.
 * **Access policy**: restricted
 */
export const ecrDeleteRepository = <ThrowOnError extends boolean = true>(
  options: Options<EcrDeleteRepositoryData, ThrowOnError>
): RequestResult<
  EcrDeleteRepositoryResponses,
  EcrDeleteRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    EcrDeleteRepositoryResponses,
    EcrDeleteRepositoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zEcrDeleteRepositoryPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/registries/{id}/ecr/repositories/{repositoryName}',
    ...options,
  });

/**
 * Delete tags
 *
 * Delete tags for a given ECR repository
 * **Access policy**: restricted
 */
export const ecrDeleteTags = <ThrowOnError extends boolean = true>(
  options: Options<EcrDeleteTagsData, ThrowOnError>
): RequestResult<EcrDeleteTagsResponses, EcrDeleteTagsErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    EcrDeleteTagsResponses,
    EcrDeleteTagsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zEcrDeleteTagsBody,
          path: zEcrDeleteTagsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zEcrDeleteTagsResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/registries/{id}/ecr/repositories/{repositoryName}/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete repository tags
 *
 * Delete tags for a given repository
 * **Access policy**: restricted
 */
export const repositoryTagsDelete = <ThrowOnError extends boolean = true>(
  options: Options<RepositoryTagsDeleteData, ThrowOnError>
): RequestResult<
  RepositoryTagsDeleteResponses,
  RepositoryTagsDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RepositoryTagsDeleteResponses,
    RepositoryTagsDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRepositoryTagsDeleteBody,
          path: zRepositoryTagsDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zRepositoryTagsDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries/{id}/repositories/{repositoryName}/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetch repository tag details
 *
 * Fetch OS/architecture, size, image ID and created date for the given tags of a repository, keyed by tag name. Tags that fail to resolve are omitted from the response; if none of the requested tags resolve, the request fails.
 * **Access policy**: authenticated
 */
export const repositoryTagsDetails = <ThrowOnError extends boolean = true>(
  options: Options<RepositoryTagsDetailsData, ThrowOnError>
): RequestResult<
  RepositoryTagsDetailsResponses,
  RepositoryTagsDetailsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RepositoryTagsDetailsResponses,
    RepositoryTagsDetailsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zRepositoryTagsDetailsPath,
          query: zRepositoryTagsDetailsQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRepositoryTagsDetailsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries/{id}/repositories/{repositoryName}/tags/details',
    ...options,
  });

/**
 * Test registry connection
 *
 * Test connection to a registry with provided credentials
 * **Access policy**: authenticated
 */
export const registryPing = <ThrowOnError extends boolean = true>(
  options: Options<RegistryPingData, ThrowOnError>
): RequestResult<RegistryPingResponses, RegistryPingErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RegistryPingResponses,
    RegistryPingErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRegistryPingBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zRegistryPingResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/registries/ping',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a new resource control
 *
 * Create a new resource control to restrict access to a Docker resource.
 * **Access policy**: administrator
 */
export const resourceControlCreate = <ThrowOnError extends boolean = true>(
  options: Options<ResourceControlCreateData, ThrowOnError>
): RequestResult<
  ResourceControlCreateResponses,
  ResourceControlCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResourceControlCreateResponses,
    ResourceControlCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zResourceControlCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zResourceControlCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/resource_controls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a resource control
 *
 * Remove a resource control.
 * **Access policy**: administrator
 */
export const resourceControlDelete = <ThrowOnError extends boolean = true>(
  options: Options<ResourceControlDeleteData, ThrowOnError>
): RequestResult<
  ResourceControlDeleteResponses,
  ResourceControlDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ResourceControlDeleteResponses,
    ResourceControlDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zResourceControlDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zResourceControlDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/resource_controls/{id}',
    ...options,
  });

/**
 * Update a resource control
 *
 * Update a resource control
 * **Access policy**: authenticated
 */
export const resourceControlUpdate = <ThrowOnError extends boolean = true>(
  options: Options<ResourceControlUpdateData, ThrowOnError>
): RequestResult<
  ResourceControlUpdateResponses,
  ResourceControlUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ResourceControlUpdateResponses,
    ResourceControlUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zResourceControlUpdateBody,
          path: zResourceControlUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zResourceControlUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/resource_controls/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Triggers a system restore using provided backup file
 *
 * Triggers a system restore using provided backup file
 * **Access policy**: public (requires the X-Setup-Token header on an uninitialized instance unless --no-setup-token is set)
 */
export const restore = <ThrowOnError extends boolean = true>(
  options: Options<RestoreData, ThrowOnError>
): RequestResult<RestoreResponses, RestoreErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RestoreResponses,
    RestoreErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zRestoreBody,
          headers: zRestoreHeaders.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    url: '/restore',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List roles
 *
 * List all roles available for use
 * **Access policy**: administrator
 */
export const roleList = <ThrowOnError extends boolean = true>(
  options?: Options<RoleListData, ThrowOnError>
): RequestResult<RoleListResponses, RoleListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    RoleListResponses,
    RoleListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRoleListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/roles',
    ...options,
  });

/**
 * Retrieve Portainer settings
 *
 * Retrieve Portainer settings.
 * **Access policy**: administrator
 */
export const settingsInspect = <ThrowOnError extends boolean = true>(
  options?: Options<SettingsInspectData, ThrowOnError>
): RequestResult<
  SettingsInspectResponses,
  SettingsInspectErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SettingsInspectResponses,
    SettingsInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSettingsInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings',
    ...options,
  });

/**
 * Update Portainer settings
 *
 * Update Portainer settings.
 * **Access policy**: administrator
 */
export const settingsUpdate = <ThrowOnError extends boolean = true>(
  options: Options<SettingsUpdateData, ThrowOnError>
): RequestResult<SettingsUpdateResponses, SettingsUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    SettingsUpdateResponses,
    SettingsUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSettingsUpdateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSettingsUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieve Portainer additional functionality settings
 *
 * Retrieve Portainer additional functionality settings.
 * **Access policy**: authenticated
 */
export const settingsAdditionalFunctionalityInspect = <
  ThrowOnError extends boolean = true,
>(
  options?: Options<SettingsAdditionalFunctionalityInspectData, ThrowOnError>
): RequestResult<
  SettingsAdditionalFunctionalityInspectResponses,
  SettingsAdditionalFunctionalityInspectErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SettingsAdditionalFunctionalityInspectResponses,
    SettingsAdditionalFunctionalityInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSettingsAdditionalFunctionalityInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings/additional_functionality',
    ...options,
  });

/**
 * Update Portainer additional functionality settings
 *
 * Update Portainer additional functionality settings.
 * **Access policy**: administrator
 */
export const settingsAdditionalFunctionalityUpdate = <
  ThrowOnError extends boolean = true,
>(
  options: Options<SettingsAdditionalFunctionalityUpdateData, ThrowOnError>
): RequestResult<
  SettingsAdditionalFunctionalityUpdateResponses,
  SettingsAdditionalFunctionalityUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SettingsAdditionalFunctionalityUpdateResponses,
    SettingsAdditionalFunctionalityUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSettingsAdditionalFunctionalityUpdateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zSettingsAdditionalFunctionalityUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings/additional_functionality',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Portainer default registry settings
 *
 * Update Portainer default registry settings.
 * **Access policy**: administrator
 */
export const defaultRegistryUpdate = <ThrowOnError extends boolean = true>(
  options: Options<DefaultRegistryUpdateData, ThrowOnError>
): RequestResult<
  DefaultRegistryUpdateResponses,
  DefaultRegistryUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    DefaultRegistryUpdateResponses,
    DefaultRegistryUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zDefaultRegistryUpdateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zDefaultRegistryUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings/default_registry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieve Portainer Edge MTLS CA Certificates
 *
 * Retrieve Portainer Edge MTLS CA Certificates.
 * **Access policy**: administrator
 */
export const settingsEdgeMtlscaCertificates = <
  ThrowOnError extends boolean = true,
>(
  options?: Options<SettingsEdgeMtlscaCertificatesData, ThrowOnError>
): RequestResult<
  SettingsEdgeMtlscaCertificatesResponses,
  SettingsEdgeMtlscaCertificatesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SettingsEdgeMtlscaCertificatesResponses,
    SettingsEdgeMtlscaCertificatesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSettingsEdgeMtlscaCertificatesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings/edge/mtls_ca_certificate',
    ...options,
  });

/**
 * Retrieve Portainer Edge MTLS Certificates
 *
 * Retrieve Portainer Edge MTLS Certificates.
 * **Access policy**: administrator
 */
export const settingsEdgeMtlsCertificates = <
  ThrowOnError extends boolean = true,
>(
  options?: Options<SettingsEdgeMtlsCertificatesData, ThrowOnError>
): RequestResult<
  SettingsEdgeMtlsCertificatesResponses,
  SettingsEdgeMtlsCertificatesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SettingsEdgeMtlsCertificatesResponses,
    SettingsEdgeMtlsCertificatesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSettingsEdgeMtlsCertificatesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings/edge/mtls_certificate',
    ...options,
  });

/**
 * Retrieve Portainer experimental settings
 *
 * Retrieve Portainer experimental settings.
 * **Access policy**: authenticated
 */
export const settingsExperimentalInspect = <
  ThrowOnError extends boolean = true,
>(
  options?: Options<SettingsExperimentalInspectData, ThrowOnError>
): RequestResult<
  SettingsExperimentalInspectResponses,
  SettingsExperimentalInspectErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SettingsExperimentalInspectResponses,
    SettingsExperimentalInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSettingsExperimentalInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings/experimental',
    ...options,
  });

/**
 * Update Portainer experimental settings
 *
 * Update Portainer experimental settings.
 * **Access policy**: administrator
 */
export const settingsExperimentalUpdate = <ThrowOnError extends boolean = true>(
  options: Options<SettingsExperimentalUpdateData, ThrowOnError>
): RequestResult<
  SettingsExperimentalUpdateResponses,
  SettingsExperimentalUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SettingsExperimentalUpdateResponses,
    SettingsExperimentalUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSettingsExperimentalUpdateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zSettingsExperimentalUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/settings/experimental',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieve Portainer public settings
 *
 * Retrieve public settings. Returns a small set of settings that are not reserved to administrators only.
 * **Access policy**: public
 */
export const settingsPublic = <ThrowOnError extends boolean = true>(
  options?: Options<SettingsPublicData, ThrowOnError>
): RequestResult<SettingsPublicResponses, SettingsPublicErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    SettingsPublicResponses,
    SettingsPublicErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSettingsPublicResponse.parseAsync(data),
    url: '/settings/public',
    ...options,
  });

/**
 * Generate ssh keypair
 *
 * Generate an ssh public / private keypair
 * **Access policy**: authenticated
 */
export const generate = <ThrowOnError extends boolean = true>(
  options?: Options<GenerateData, ThrowOnError>
): RequestResult<GenerateResponses, GenerateErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    GenerateResponses,
    GenerateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGenerateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/sshkeygen',
    ...options,
  });

/**
 * Inspect the ssl settings
 *
 * Retrieve the ssl settings.
 * **Access policy**: administrator
 */
export const sslInspect = <ThrowOnError extends boolean = true>(
  options?: Options<SslInspectData, ThrowOnError>
): RequestResult<SslInspectResponses, SslInspectErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    SslInspectResponses,
    SslInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSslInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/ssl',
    ...options,
  });

/**
 * Update the ssl settings
 *
 * Update the ssl settings.
 * **Access policy**: administrator
 */
export const sslUpdate = <ThrowOnError extends boolean = true>(
  options: Options<SslUpdateData, ThrowOnError>
): RequestResult<SslUpdateResponses, SslUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    SslUpdateResponses,
    SslUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSslUpdateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zSslUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/ssl',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List stacks
 *
 * List all stacks based on the current user authorizations.
 * Will return all stacks if using an administrator account otherwise it
 * will only return the list of stacks the user have access to.
 * Limited stacks will not be returned by this endpoint.
 * **Access policy**: authenticated
 */
export const stackList = <ThrowOnError extends boolean = true>(
  options?: Options<StackListData, ThrowOnError>
): RequestResult<StackListResponses, StackListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    StackListResponses,
    StackListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zStackListQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zStackListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks',
    ...options,
  });

/**
 * Remove a stack
 *
 * Remove a stack.
 * **Access policy**: restricted
 */
export const stackDelete = <ThrowOnError extends boolean = true>(
  options: Options<StackDeleteData, ThrowOnError>
): RequestResult<StackDeleteResponses, StackDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    StackDeleteResponses,
    StackDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackDeletePath,
          query: zStackDeleteQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zStackDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}',
    ...options,
  });

/**
 * Inspect a stack
 *
 * Retrieve details about a stack.
 * **Access policy**: restricted
 */
export const stackInspect = <ThrowOnError extends boolean = true>(
  options: Options<StackInspectData, ThrowOnError>
): RequestResult<StackInspectResponses, StackInspectErrors, ThrowOnError> =>
  (options.client ?? client).get<
    StackInspectResponses,
    StackInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}',
    ...options,
  });

/**
 * Update a stack
 *
 * Update a stack, only for file based stacks.
 * **Access policy**: authenticated
 */
export const stackUpdate = <ThrowOnError extends boolean = true>(
  options: Options<StackUpdateData, ThrowOnError>
): RequestResult<StackUpdateResponses, StackUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    StackUpdateResponses,
    StackUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackUpdateBody,
          path: zStackUpdatePath,
          query: zStackUpdateQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Associate an orphaned stack to a new environment(endpoint)
 *
 * **Access policy**: administrator
 */
export const stackAssociate = <ThrowOnError extends boolean = true>(
  options: Options<StackAssociateData, ThrowOnError>
): RequestResult<StackAssociateResponses, StackAssociateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    StackAssociateResponses,
    StackAssociateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackAssociatePath,
          query: zStackAssociateQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackAssociateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/associate',
    ...options,
  });

/**
 * Convert a Docker Compose stack to Kubernetes manifests or Helm chart
 *
 * Convert a Docker Compose or Docker Swarm stack to Kubernetes manifests or Helm chart and return the results for preview.
 * **Access policy**: authenticated
 */
export const stackConvert = <ThrowOnError extends boolean = true>(
  options: Options<StackConvertData, ThrowOnError>
): RequestResult<StackConvertResponses, StackConvertErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StackConvertResponses,
    StackConvertErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackConvertBody,
          path: zStackConvertPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackConvertResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/convert',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Retrieve the content of the Stack file for the specified stack
 *
 * Get Stack file content.
 * **Access policy**: restricted
 */
export const stackFileInspect = <ThrowOnError extends boolean = true>(
  options: Options<StackFileInspectData, ThrowOnError>
): RequestResult<
  StackFileInspectResponses,
  StackFileInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    StackFileInspectResponses,
    StackFileInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackFileInspectPath,
          query: zStackFileInspectQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackFileInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/file',
    ...options,
  });

/**
 * Update a stack's Git configs
 *
 * Update the Git settings in a stack, e.g., RepositoryReferenceName and AutoUpdate. When SourceID is set, URL/auth/TLS are taken from the referenced Source.
 * **Access policy**: authenticated
 */
export const stackUpdateGit = <ThrowOnError extends boolean = true>(
  options: Options<StackUpdateGitData, ThrowOnError>
): RequestResult<StackUpdateGitResponses, StackUpdateGitErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StackUpdateGitResponses,
    StackUpdateGitErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackUpdateGitBody,
          path: zStackUpdateGitPath,
          query: zStackUpdateGitQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackUpdateGitResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/git',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Redeploy a stack
 *
 * Pull and redeploy a stack via Git
 * **Access policy**: authenticated
 */
export const stackGitRedeploy = <ThrowOnError extends boolean = true>(
  options: Options<StackGitRedeployData, ThrowOnError>
): RequestResult<
  StackGitRedeployResponses,
  StackGitRedeployErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    StackGitRedeployResponses,
    StackGitRedeployErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackGitRedeployBody,
          path: zStackGitRedeployPath,
          query: zStackGitRedeployQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackGitRedeployResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/git/redeploy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetch image status for stack
 *
 * **Access policy**:
 */
export const stackImagesStatus = <ThrowOnError extends boolean = true>(
  options: Options<StackImagesStatusData, ThrowOnError>
): RequestResult<
  StackImagesStatusResponses,
  StackImagesStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    StackImagesStatusResponses,
    StackImagesStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackImagesStatusPath,
          query: zStackImagesStatusQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackImagesStatusResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/stacks/{id}/images_status',
    ...options,
  });

/**
 * Migrate a stack to another environment(endpoint)
 *
 * Migrate a stack from an environment(endpoint) to another environment(endpoint). It will re-create the stack inside the target environment(endpoint) before removing the original stack.
 * **Access policy**: authenticated
 */
export const stackMigrate = <ThrowOnError extends boolean = true>(
  options: Options<StackMigrateData, ThrowOnError>
): RequestResult<StackMigrateResponses, StackMigrateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StackMigrateResponses,
    StackMigrateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackMigrateBody,
          path: zStackMigratePath,
          query: zStackMigrateQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackMigrateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/migrate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Starts a stopped Stack
 *
 * Starts a stopped Stack.
 * **Access policy**: authenticated
 */
export const stackStart = <ThrowOnError extends boolean = true>(
  options: Options<StackStartData, ThrowOnError>
): RequestResult<StackStartResponses, StackStartErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StackStartResponses,
    StackStartErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackStartPath,
          query: zStackStartQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zStackStartResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/start',
    ...options,
  });

/**
 * Stop a running Stack
 *
 * Stop a running Stack.
 * **Access policy**: authenticated
 */
export const stackStop = <ThrowOnError extends boolean = true>(
  options: Options<StackStopData, ThrowOnError>
): RequestResult<StackStopResponses, StackStopErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StackStopResponses,
    StackStopErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackStopPath,
          query: zStackStopQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zStackStopResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/{id}/stop',
    ...options,
  });

/**
 * Deploy a new kubernetes stack from a git repository
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateKubernetesGit = <ThrowOnError extends boolean = true>(
  options: Options<StackCreateKubernetesGitData, ThrowOnError>
): RequestResult<
  StackCreateKubernetesGitResponses,
  StackCreateKubernetesGitErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateKubernetesGitResponses,
    StackCreateKubernetesGitErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateKubernetesGitBody,
          path: z.never().optional(),
          query: zStackCreateKubernetesGitQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateKubernetesGitResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/kubernetes/repository',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deploy a new kubernetes stack from a file
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateKubernetesFile = <ThrowOnError extends boolean = true>(
  options: Options<StackCreateKubernetesFileData, ThrowOnError>
): RequestResult<
  StackCreateKubernetesFileResponses,
  StackCreateKubernetesFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateKubernetesFileResponses,
    StackCreateKubernetesFileErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateKubernetesFileBody,
          path: z.never().optional(),
          query: zStackCreateKubernetesFileQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateKubernetesFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/kubernetes/string',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deploy a new kubernetes stack from a url
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateKubernetesUrl = <ThrowOnError extends boolean = true>(
  options: Options<StackCreateKubernetesUrlData, ThrowOnError>
): RequestResult<
  StackCreateKubernetesUrlResponses,
  StackCreateKubernetesUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateKubernetesUrlResponses,
    StackCreateKubernetesUrlErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateKubernetesUrlBody,
          path: z.never().optional(),
          query: zStackCreateKubernetesUrlQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateKubernetesUrlResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/kubernetes/url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deploy a new compose stack from a file
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateDockerStandaloneFile = <
  ThrowOnError extends boolean = true,
>(
  options: Options<StackCreateDockerStandaloneFileData, ThrowOnError>
): RequestResult<
  StackCreateDockerStandaloneFileResponses,
  StackCreateDockerStandaloneFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateDockerStandaloneFileResponses,
    StackCreateDockerStandaloneFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateDockerStandaloneFileBody,
          path: z.never().optional(),
          query: zStackCreateDockerStandaloneFileQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateDockerStandaloneFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/standalone/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Deploy a new compose stack from repository
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateDockerStandaloneRepository = <
  ThrowOnError extends boolean = true,
>(
  options: Options<StackCreateDockerStandaloneRepositoryData, ThrowOnError>
): RequestResult<
  StackCreateDockerStandaloneRepositoryResponses,
  StackCreateDockerStandaloneRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateDockerStandaloneRepositoryResponses,
    StackCreateDockerStandaloneRepositoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateDockerStandaloneRepositoryBody,
          path: z.never().optional(),
          query: zStackCreateDockerStandaloneRepositoryQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateDockerStandaloneRepositoryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/standalone/repository',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deploy a new compose stack from a text
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateDockerStandaloneString = <
  ThrowOnError extends boolean = true,
>(
  options: Options<StackCreateDockerStandaloneStringData, ThrowOnError>
): RequestResult<
  StackCreateDockerStandaloneStringResponses,
  StackCreateDockerStandaloneStringErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateDockerStandaloneStringResponses,
    StackCreateDockerStandaloneStringErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateDockerStandaloneStringBody,
          path: z.never().optional(),
          query: zStackCreateDockerStandaloneStringQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateDockerStandaloneStringResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/standalone/string',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deploy a new swarm stack from a file
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateDockerSwarmFile = <ThrowOnError extends boolean = true>(
  options: Options<StackCreateDockerSwarmFileData, ThrowOnError>
): RequestResult<
  StackCreateDockerSwarmFileResponses,
  StackCreateDockerSwarmFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateDockerSwarmFileResponses,
    StackCreateDockerSwarmFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateDockerSwarmFileBody.optional(),
          path: z.never().optional(),
          query: zStackCreateDockerSwarmFileQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateDockerSwarmFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/swarm/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Deploy a new swarm stack from a git repository
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateDockerSwarmRepository = <
  ThrowOnError extends boolean = true,
>(
  options: Options<StackCreateDockerSwarmRepositoryData, ThrowOnError>
): RequestResult<
  StackCreateDockerSwarmRepositoryResponses,
  StackCreateDockerSwarmRepositoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateDockerSwarmRepositoryResponses,
    StackCreateDockerSwarmRepositoryErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateDockerSwarmRepositoryBody,
          path: z.never().optional(),
          query: zStackCreateDockerSwarmRepositoryQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateDockerSwarmRepositoryResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/swarm/repository',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Deploy a new swarm stack from a text
 *
 * Deploy a new stack into a Docker environment specified via the environment identifier.
 * **Access policy**: authenticated
 */
export const stackCreateDockerSwarmString = <
  ThrowOnError extends boolean = true,
>(
  options: Options<StackCreateDockerSwarmStringData, ThrowOnError>
): RequestResult<
  StackCreateDockerSwarmStringResponses,
  StackCreateDockerSwarmStringErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StackCreateDockerSwarmStringResponses,
    StackCreateDockerSwarmStringErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zStackCreateDockerSwarmStringBody,
          path: z.never().optional(),
          query: zStackCreateDockerSwarmStringQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zStackCreateDockerSwarmStringResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/create/swarm/string',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Clear stack image status cache
 *
 * Clear the image status cache for all stacks in the environment
 * **Access policy**:
 */
export const stacksImageStatusClear = <ThrowOnError extends boolean = true>(
  options?: Options<StacksImageStatusClearData, ThrowOnError>
): RequestResult<
  StacksImageStatusClearResponses,
  StacksImageStatusClearErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    StacksImageStatusClearResponses,
    StacksImageStatusClearErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zStacksImageStatusClearQuery.optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zStacksImageStatusClearResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/stacks/image_status/clear',
    ...options,
  });

/**
 * Remove Kubernetes stacks by name
 *
 * Remove a stack.
 * **Access policy**: restricted
 */
export const stackDeleteKubernetesByName = <
  ThrowOnError extends boolean = true,
>(
  options: Options<StackDeleteKubernetesByNameData, ThrowOnError>
): RequestResult<
  StackDeleteKubernetesByNameResponses,
  StackDeleteKubernetesByNameErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    StackDeleteKubernetesByNameResponses,
    StackDeleteKubernetesByNameErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStackDeleteKubernetesByNamePath,
          query: zStackDeleteKubernetesByNameQuery,
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zStackDeleteKubernetesByNameResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/stacks/name/{name}',
    ...options,
  });

/**
 * Webhook for triggering stack updates from git
 *
 * **Access policy**: public
 */
export const stacksWebhookInvoke = <ThrowOnError extends boolean = true>(
  options: Options<StacksWebhookInvokeData, ThrowOnError>
): RequestResult<
  StacksWebhookInvokeResponses,
  StacksWebhookInvokeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StacksWebhookInvokeResponses,
    StacksWebhookInvokeErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zStacksWebhookInvokePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zStacksWebhookInvokeResponse2.parseAsync(data),
    url: '/stacks/webhooks/{webhookID}',
    ...options,
  });

/**
 * Get status of the global debug log
 *
 * Checks if the global log level is enabled
 * **Access policy**: administrator
 */
export const getDebugLogStatus = <ThrowOnError extends boolean = true>(
  options?: Options<GetDebugLogStatusData, ThrowOnError>
): RequestResult<
  GetDebugLogStatusResponses,
  GetDebugLogStatusErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetDebugLogStatusResponses,
    GetDebugLogStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zGetDebugLogStatusResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/support/debug_log',
    ...options,
  });

/**
 * Enables or disables the global debug log
 *
 * Enables the debug log by setting the global log level to debug or info if disabled
 * **Access policy**: administrator
 */
export const setDebugLogStatus = <ThrowOnError extends boolean = true>(
  options: Options<SetDebugLogStatusData, ThrowOnError>
): RequestResult<
  SetDebugLogStatusResponses,
  SetDebugLogStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetDebugLogStatusResponses,
    SetDebugLogStatusErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zSetDebugLogStatusBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSetDebugLogStatusResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/support/debug_log',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Download a bundle of files to help support diagnose issues
 *
 * **Access policy**: administrator
 */
export const supportBundleDownload = <ThrowOnError extends boolean = true>(
  options?: Options<SupportBundleDownloadData, ThrowOnError>
): RequestResult<
  SupportBundleDownloadResponses,
  SupportBundleDownloadErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SupportBundleDownloadResponses,
    SupportBundleDownloadErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/support/download',
    ...options,
  });

/**
 * Retrieve system info
 *
 * **Access policy**: authenticated
 */
export const systemInfo = <ThrowOnError extends boolean = true>(
  options?: Options<SystemInfoData, ThrowOnError>
): RequestResult<SystemInfoResponses, SystemInfoErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    SystemInfoResponses,
    SystemInfoErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSystemInfoResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/system/info',
    ...options,
  });

/**
 * Retrieve the count of nodes
 *
 * **Access policy**: authenticated
 */
export const systemNodesCount = <ThrowOnError extends boolean = true>(
  options?: Options<SystemNodesCountData, ThrowOnError>
): RequestResult<
  SystemNodesCountResponses,
  SystemNodesCountErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    SystemNodesCountResponses,
    SystemNodesCountErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSystemNodesCountResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/system/nodes',
    ...options,
  });

/**
 * Check Portainer status
 *
 * Retrieve Portainer status
 * **Access policy**: public
 */
export const systemStatus = <ThrowOnError extends boolean = true>(
  options?: Options<SystemStatusData, ThrowOnError>
): RequestResult<SystemStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SystemStatusResponses, unknown, ThrowOnError>(
    {
      requestValidator: async (data) =>
        await z
          .object({
            body: z.never().optional(),
            path: z.never().optional(),
            query: z.never().optional(),
          })
          .parseAsync(data),
      responseType: 'json',
      responseValidator: async (data) =>
        await zSystemStatusResponse.parseAsync(data),
      url: '/system/status',
      ...options,
    }
  );

/**
 * Update Portainer to latest version
 *
 * Update Portainer to latest version
 * **Access policy**: administrator
 */
export const systemUpdate = <ThrowOnError extends boolean = true>(
  options?: Options<SystemUpdateData, ThrowOnError>
): RequestResult<SystemUpdateResponses, SystemUpdateErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    SystemUpdateResponses,
    SystemUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSystemUpdateResponse.parseAsync(data),
    url: '/system/update',
    ...options,
  });

/**
 * Check for portainer updates
 *
 * Check if portainer has an update available
 * **Access policy**: authenticated
 */
export const systemVersion = <ThrowOnError extends boolean = true>(
  options?: Options<SystemVersionData, ThrowOnError>
): RequestResult<SystemVersionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    SystemVersionResponses,
    unknown,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zSystemVersionResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/system/version',
    ...options,
  });

/**
 * List tags
 *
 * List tags.
 * **Access policy**: authenticated
 */
export const tagList = <ThrowOnError extends boolean = true>(
  options?: Options<TagListData, ThrowOnError>
): RequestResult<TagListResponses, TagListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    TagListResponses,
    TagListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zTagListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/tags',
    ...options,
  });

/**
 * Create a new tag
 *
 * Create a new tag.
 * **Access policy**: administrator
 */
export const tagCreate = <ThrowOnError extends boolean = true>(
  options: Options<TagCreateData, ThrowOnError>
): RequestResult<TagCreateResponses, TagCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    TagCreateResponses,
    TagCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zTagCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTagCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a tag
 *
 * Remove a tag.
 * **Access policy**: administrator
 */
export const tagDelete = <ThrowOnError extends boolean = true>(
  options: Options<TagDeleteData, ThrowOnError>
): RequestResult<TagDeleteResponses, TagDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    TagDeleteResponses,
    TagDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zTagDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zTagDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/tags/{id}',
    ...options,
  });

/**
 * List team memberships
 *
 * List team memberships. Access is only available to administrators and team leaders. Team leaders only see memberships of teams they lead.
 * **Access policy**: administrator or team leader
 */
export const teamMembershipList = <ThrowOnError extends boolean = true>(
  options?: Options<TeamMembershipListData, ThrowOnError>
): RequestResult<
  TeamMembershipListResponses,
  TeamMembershipListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    TeamMembershipListResponses,
    TeamMembershipListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTeamMembershipListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/team_memberships',
    ...options,
  });

/**
 * Create a new team membership
 *
 * Create a new team memberships. Access is only available to administrators or leaders of the associated team.
 * **Access policy**: administrator or leaders of the associated team
 */
export const teamMembershipCreate = <ThrowOnError extends boolean = true>(
  options: Options<TeamMembershipCreateData, ThrowOnError>
): RequestResult<
  TeamMembershipCreateResponses,
  TeamMembershipCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TeamMembershipCreateResponses,
    TeamMembershipCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zTeamMembershipCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTeamMembershipCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/team_memberships',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a team membership
 *
 * Remove a team membership. Access is only available to administrators or leaders of the associated team.
 * **Access policy**: administrator or leaders of the associated team
 */
export const teamMembershipDelete = <ThrowOnError extends boolean = true>(
  options: Options<TeamMembershipDeleteData, ThrowOnError>
): RequestResult<
  TeamMembershipDeleteResponses,
  TeamMembershipDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    TeamMembershipDeleteResponses,
    TeamMembershipDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zTeamMembershipDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zTeamMembershipDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/team_memberships/{id}',
    ...options,
  });

/**
 * Update a team membership
 *
 * Update a team membership. Access is only available to administrators or leaders of the associated team.
 * **Access policy**: administrator or leaders of the associated team
 */
export const teamMembershipUpdate = <ThrowOnError extends boolean = true>(
  options: Options<TeamMembershipUpdateData, ThrowOnError>
): RequestResult<
  TeamMembershipUpdateResponses,
  TeamMembershipUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    TeamMembershipUpdateResponses,
    TeamMembershipUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zTeamMembershipUpdateBody,
          path: zTeamMembershipUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTeamMembershipUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/team_memberships/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List teams
 *
 * List teams. For non-administrator users, will only list the teams they are member of.
 * **Access policy**: restricted
 */
export const teamList = <ThrowOnError extends boolean = true>(
  options?: Options<TeamListData, ThrowOnError>
): RequestResult<TeamListResponses, TeamListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    TeamListResponses,
    TeamListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zTeamListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zTeamListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/teams',
    ...options,
  });

/**
 * Create a new team
 *
 * Create a new team.
 * **Access policy**: administrator
 */
export const teamCreate = <ThrowOnError extends boolean = true>(
  options: Options<TeamCreateData, ThrowOnError>
): RequestResult<TeamCreateResponses, TeamCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    TeamCreateResponses,
    TeamCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zTeamCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTeamCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/teams',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a team
 *
 * Remove a team.
 * **Access policy**: administrator
 */
export const teamDelete = <ThrowOnError extends boolean = true>(
  options: Options<TeamDeleteData, ThrowOnError>
): RequestResult<TeamDeleteResponses, TeamDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    TeamDeleteResponses,
    TeamDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zTeamDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zTeamDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/teams/{id}',
    ...options,
  });

/**
 * Inspect a team
 *
 * Retrieve details about a team. Access is only available for administrator and leaders of that team.
 * **Access policy**: administrator or team leader
 */
export const teamInspect = <ThrowOnError extends boolean = true>(
  options: Options<TeamInspectData, ThrowOnError>
): RequestResult<TeamInspectResponses, TeamInspectErrors, ThrowOnError> =>
  (options.client ?? client).get<
    TeamInspectResponses,
    TeamInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zTeamInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTeamInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/teams/{id}',
    ...options,
  });

/**
 * Update a team
 *
 * Update a team.
 * **Access policy**: administrator
 */
export const teamUpdate = <ThrowOnError extends boolean = true>(
  options: Options<TeamUpdateData, ThrowOnError>
): RequestResult<TeamUpdateResponses, TeamUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    TeamUpdateResponses,
    TeamUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zTeamUpdateBody,
          path: zTeamUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTeamUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/teams/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List team memberships
 *
 * List team memberships. Access is only available to administrators and team leaders.
 * **Access policy**: restricted
 */
export const teamMemberships = <ThrowOnError extends boolean = true>(
  options: Options<TeamMembershipsData, ThrowOnError>
): RequestResult<
  TeamMembershipsResponses,
  TeamMembershipsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    TeamMembershipsResponses,
    TeamMembershipsErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zTeamMembershipsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTeamMembershipsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/teams/{id}/memberships',
    ...options,
  });

/**
 * List available templates
 *
 * List available templates.
 * **Access policy**: authenticated
 */
export const templateList = <ThrowOnError extends boolean = true>(
  options?: Options<TemplateListData, ThrowOnError>
): RequestResult<TemplateListResponses, TemplateListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    TemplateListResponses,
    TemplateListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTemplateListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/templates',
    ...options,
  });

/**
 * Get a template's file
 *
 * Get a template's file
 * **Access policy**: authenticated
 */
export const templateFile = <ThrowOnError extends boolean = true>(
  options: Options<TemplateFileData, ThrowOnError>
): RequestResult<TemplateFileResponses, TemplateFileErrors, ThrowOnError> =>
  (options.client ?? client).post<
    TemplateFileResponses,
    TemplateFileErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zTemplateFilePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zTemplateFileResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/templates/{id}/file',
    ...options,
  });

/**
 * Search Helm Charts
 *
 * **Access policy**: authenticated
 */
export const helmRepoSearch = <ThrowOnError extends boolean = true>(
  options?: Options<HelmRepoSearchData, ThrowOnError>
): RequestResult<HelmRepoSearchResponses, HelmRepoSearchErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    HelmRepoSearchResponses,
    HelmRepoSearchErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zHelmRepoSearchQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zHelmRepoSearchResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/templates/helm',
    ...options,
  });

/**
 * Show Helm Chart Information
 *
 * **Access policy**: authenticated
 * Either `repo` or `registryId` parameter is required (but not both),
 * unless `chart` is a self-contained "oci://host/path" reference.
 */
export const helmShow = <ThrowOnError extends boolean = true>(
  options: Options<HelmShowData, ThrowOnError>
): RequestResult<HelmShowResponses, HelmShowErrors, ThrowOnError> =>
  (options.client ?? client).get<
    HelmShowResponses,
    HelmShowErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHelmShowPath,
          query: zHelmShowQuery,
        })
        .parseAsync(data),
    responseType: 'text',
    responseValidator: async (data) => await zHelmShowResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/templates/helm/{command}',
    ...options,
  });

/**
 * Upload TLS files
 *
 * Use this environment(endpoint) to upload TLS files.
 * **Access policy**: administrator
 */
export const uploadTls = <ThrowOnError extends boolean = true>(
  options: Options<UploadTlsData, ThrowOnError>
): RequestResult<UploadTlsResponses, UploadTlsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UploadTlsResponses,
    UploadTlsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    requestValidator: async (data) =>
      await z
        .object({
          body: zUploadTlsBody,
          path: zUploadTlsPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUploadTlsResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/upload/tls/{certificate}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * List auth activity logs
 *
 * List logs by provided query
 * **Access policy**: admin
 */
export const authLogsList = <ThrowOnError extends boolean = true>(
  options?: Options<AuthLogsListData, ThrowOnError>
): RequestResult<AuthLogsListResponses, AuthLogsListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AuthLogsListResponses,
    AuthLogsListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zAuthLogsListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zAuthLogsListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/useractivity/authlogs',
    ...options,
  });

/**
 * Download auth logs as CSV
 *
 * Download auth logs as CSV by provided query
 * **Access policy**: admin
 */
export const authLogsCsv = <ThrowOnError extends boolean = true>(
  options?: Options<AuthLogsCsvData, ThrowOnError>
): RequestResult<AuthLogsCsvResponses, AuthLogsCsvErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AuthLogsCsvResponses,
    AuthLogsCsvErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zAuthLogsCsvQuery.optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/useractivity/authlogs.csv',
    ...options,
  });

/**
 * List user activity logs
 *
 * List logs by provided query
 * **Access policy**: admin
 */
export const logsList = <ThrowOnError extends boolean = true>(
  options?: Options<LogsListData, ThrowOnError>
): RequestResult<LogsListResponses, LogsListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    LogsListResponses,
    LogsListErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        context: { array: { explode: false } },
        username: { array: { explode: false } },
      },
    },
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zLogsListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zLogsListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/useractivity/logs',
    ...options,
  });

/**
 * Download user activity logs as CSV
 *
 * Download user activity logs as CSV by provided query
 * **Access policy**: admin
 */
export const logsCsv = <ThrowOnError extends boolean = true>(
  options?: Options<LogsCsvData, ThrowOnError>
): RequestResult<LogsCsvResponses, LogsCsvErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    LogsCsvResponses,
    LogsCsvErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zLogsCsvQuery.optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/useractivity/logs.csv',
    ...options,
  });

/**
 * List users
 *
 * List Portainer users.
 * Administrators can list every user account, and team leaders can list the users of the teams they lead.
 * When `environmentId` is provided, environment (endpoint) administrators and edge administrators can additionally list the non-administrator users with access to that environment.
 * All other authenticated users only receive their own user account.
 * User passwords are filtered out, and should never be accessible.
 * **Access policy**: restricted
 */
export const userList = <ThrowOnError extends boolean = true>(
  options?: Options<UserListData, ThrowOnError>
): RequestResult<UserListResponses, UserListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    UserListResponses,
    UserListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zUserListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zUserListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users',
    ...options,
  });

/**
 * Create a new user
 *
 * Create a new Portainer user.
 * Only administrators can create users.
 * **Access policy**: restricted
 */
export const userCreate = <ThrowOnError extends boolean = true>(
  options: Options<UserCreateData, ThrowOnError>
): RequestResult<UserCreateResponses, UserCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UserCreateResponses,
    UserCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUserCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a user
 *
 * Remove a user.
 * **Access policy**: administrator
 */
export const userDelete = <ThrowOnError extends boolean = true>(
  options: Options<UserDeleteData, ThrowOnError>
): RequestResult<UserDeleteResponses, UserDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    UserDeleteResponses,
    UserDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUserDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}',
    ...options,
  });

/**
 * Inspect a user
 *
 * Retrieve details about a user.
 * User passwords are filtered out, and should never be accessible.
 * **Access policy**: authenticated
 */
export const userInspect = <ThrowOnError extends boolean = true>(
  options: Options<UserInspectData, ThrowOnError>
): RequestResult<UserInspectResponses, UserInspectErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UserInspectResponses,
    UserInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}',
    ...options,
  });

/**
 * Update a user
 *
 * Update user details. A regular user account can only update his details.
 * A regular user account cannot change their username or role.
 * **Access policy**: authenticated
 */
export const userUpdate = <ThrowOnError extends boolean = true>(
  options: Options<UserUpdateData, ThrowOnError>
): RequestResult<UserUpdateResponses, UserUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    UserUpdateResponses,
    UserUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUserUpdateBody,
          path: zUserUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Inspect a user's effective access on every environment
 *
 * Returns the resolved role for each environment the user can access,
 * following the policy precedence used by the access viewer
 * (edge-admin override, RBAC policy, user-endpoint, user-group,
 * team-endpoint, team-group). Environments where the user has no
 * role are omitted.
 * **Access policy**: authenticated
 */
export const userEffectiveAccessInspect = <ThrowOnError extends boolean = true>(
  options: Options<UserEffectiveAccessInspectData, ThrowOnError>
): RequestResult<
  UserEffectiveAccessInspectResponses,
  UserEffectiveAccessInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    UserEffectiveAccessInspectResponses,
    UserEffectiveAccessInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserEffectiveAccessInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserEffectiveAccessInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/effective-access',
    ...options,
  });

/**
 * List a users helm repositories
 *
 * Inspect a user helm repositories.
 * **Access policy**: authenticated
 */
export const helmUserRepositoriesList = <ThrowOnError extends boolean = true>(
  options: Options<HelmUserRepositoriesListData, ThrowOnError>
): RequestResult<
  HelmUserRepositoriesListResponses,
  HelmUserRepositoriesListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    HelmUserRepositoriesListResponses,
    HelmUserRepositoriesListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHelmUserRepositoriesListPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zHelmUserRepositoriesListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/helm/repositories',
    ...options,
  });

/**
 * Create a user helm repository
 *
 * Create a user helm repository.
 * **Access policy**: authenticated
 */
export const helmUserRepositoryCreate = <ThrowOnError extends boolean = true>(
  options: Options<HelmUserRepositoryCreateData, ThrowOnError>
): RequestResult<
  HelmUserRepositoryCreateResponses,
  HelmUserRepositoryCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    HelmUserRepositoryCreateResponses,
    HelmUserRepositoryCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zHelmUserRepositoryCreateBody,
          path: zHelmUserRepositoryCreatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zHelmUserRepositoryCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/helm/repositories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a users helm repository
 *
 * **Access policy**: authenticated
 */
export const helmUserRepositoryDelete = <ThrowOnError extends boolean = true>(
  options: Options<HelmUserRepositoryDeleteData, ThrowOnError>
): RequestResult<
  HelmUserRepositoryDeleteResponses,
  HelmUserRepositoryDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    HelmUserRepositoryDeleteResponses,
    HelmUserRepositoryDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zHelmUserRepositoryDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zHelmUserRepositoryDeleteResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/helm/repositories/{repositoryID}',
    ...options,
  });

/**
 * Inspect a user memberships
 *
 * Inspect a user memberships.
 * **Access policy**: restricted
 */
export const userMembershipsInspect = <ThrowOnError extends boolean = true>(
  options: Options<UserMembershipsInspectData, ThrowOnError>
): RequestResult<
  UserMembershipsInspectResponses,
  UserMembershipsInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    UserMembershipsInspectResponses,
    UserMembershipsInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserMembershipsInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserMembershipsInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/memberships',
    ...options,
  });

/**
 * Synchronise a user's team memberships from the configured authentication provider
 *
 * Refresh the target user's team memberships by querying the configured LDAP/AD or
 * OAuth (Microsoft Entra ID) provider. Requires the instance to be configured with
 * an external authentication provider. Administrators may sync any user; standard
 * users may only sync their own memberships.
 * **Access policy**: restricted (admin or self)
 */
export const userMembershipsSync = <ThrowOnError extends boolean = true>(
  options: Options<UserMembershipsSyncData, ThrowOnError>
): RequestResult<
  UserMembershipsSyncResponses,
  UserMembershipsSyncErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UserMembershipsSyncResponses,
    UserMembershipsSyncErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserMembershipsSyncPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserMembershipsSyncResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/memberships/sync',
    ...options,
  });

/**
 * Retrieves all k8s namespaces for an user
 *
 * Retrieves user's role authorizations of all namespaces in all k8s environments(endpoints)
 * **Access policy**: restricted
 */
export const userNamespaces = <ThrowOnError extends boolean = true>(
  options: Options<UserNamespacesData, ThrowOnError>
): RequestResult<UserNamespacesResponses, UserNamespacesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UserNamespacesResponses,
    UserNamespacesErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserNamespacesPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserNamespacesResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/namespaces',
    ...options,
  });

/**
 * Update password for a user
 *
 * Update password for the specified user.
 * **Access policy**: authenticated
 */
export const userUpdatePassword = <ThrowOnError extends boolean = true>(
  options: Options<UserUpdatePasswordData, ThrowOnError>
): RequestResult<
  UserUpdatePasswordResponses,
  UserUpdatePasswordErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UserUpdatePasswordResponses,
    UserUpdatePasswordErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUserUpdatePasswordBody,
          path: zUserUpdatePasswordPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUserUpdatePasswordResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/passwd',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all API keys for a user
 *
 * Gets all API keys for a user.
 * Only the calling user or admin can retrieve api-keys.
 * **Access policy**: authenticated
 */
export const userGetApiKeys = <ThrowOnError extends boolean = true>(
  options: Options<UserGetApiKeysData, ThrowOnError>
): RequestResult<UserGetApiKeysResponses, UserGetApiKeysErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UserGetApiKeysResponses,
    UserGetApiKeysErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserGetApiKeysPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserGetApiKeysResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/tokens',
    ...options,
  });

/**
 * Generate an API key for a user
 *
 * Generates an API key for a user.
 * Only the calling user can generate a token for themselves.
 * Password is required only for internal authentication.
 * **Access policy**: restricted
 */
export const userGenerateApiKey = <ThrowOnError extends boolean = true>(
  options: Options<UserGenerateApiKeyData, ThrowOnError>
): RequestResult<
  UserGenerateApiKeyResponses,
  UserGenerateApiKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UserGenerateApiKeyResponses,
    UserGenerateApiKeyErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUserGenerateApiKeyBody,
          path: zUserGenerateApiKeyPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserGenerateApiKeyResponse.parseAsync(data),
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}/tokens',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove an api-key associated to a user
 *
 * Remove an api-key associated to a user..
 * Only the calling user or admin can remove api-key.
 * **Access policy**: authenticated
 */
export const userRemoveApiKey = <ThrowOnError extends boolean = true>(
  options: Options<UserRemoveApiKeyData, ThrowOnError>
): RequestResult<
  UserRemoveApiKeyResponses,
  UserRemoveApiKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    UserRemoveApiKeyResponses,
    UserRemoveApiKeyErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zUserRemoveApiKeyPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUserRemoveApiKeyResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/{id}/tokens/{keyID}',
    ...options,
  });

/**
 * Check administrator account existence
 *
 * Check if an administrator account exists in the database.
 * **Access policy**: public
 */
export const userAdminCheck = <ThrowOnError extends boolean = true>(
  options?: Options<UserAdminCheckData, ThrowOnError>
): RequestResult<UserAdminCheckResponses, UserAdminCheckErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    UserAdminCheckResponses,
    UserAdminCheckErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseValidator: async (data) =>
      await zUserAdminCheckResponse.parseAsync(data),
    url: '/users/admin/check',
    ...options,
  });

/**
 * Initialize administrator account
 *
 * Initialize the 'admin' user account.
 * **Access policy**: public (requires the X-Setup-Token header on an uninitialized instance unless --no-setup-token is set)
 */
export const userAdminInit = <ThrowOnError extends boolean = true>(
  options: Options<UserAdminInitData, ThrowOnError>
): RequestResult<UserAdminInitResponses, UserAdminInitErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UserAdminInitResponses,
    UserAdminInitErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zUserAdminInitBody,
          headers: zUserAdminInitHeaders.optional(),
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zUserAdminInitResponse.parseAsync(data),
    url: '/users/admin/init',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Inspect the current user
 *
 * Retrieve details about the current user.
 * User passwords are filtered out, and should never be accessible.
 * **Access policy**: authenticated
 */
export const currentUserInspect = <ThrowOnError extends boolean = true>(
  options: Options<CurrentUserInspectData, ThrowOnError>
): RequestResult<
  CurrentUserInspectResponses,
  CurrentUserInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CurrentUserInspectResponses,
    CurrentUserInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zCurrentUserInspectQuery,
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCurrentUserInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/me',
    ...options,
  });

/**
 * Inspect environment authorizations for the current user
 *
 * Retrieve environment authorizations for the current  user.
 * **Access policy**: authenticated
 */
export const currentUserEndpointAuthorizationsInspect = <
  ThrowOnError extends boolean = true,
>(
  options: Options<CurrentUserEndpointAuthorizationsInspectData, ThrowOnError>
): RequestResult<
  CurrentUserEndpointAuthorizationsInspectResponses,
  CurrentUserEndpointAuthorizationsInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CurrentUserEndpointAuthorizationsInspectResponses,
    CurrentUserEndpointAuthorizationsInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCurrentUserEndpointAuthorizationsInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCurrentUserEndpointAuthorizationsInspectResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/me/auth/{endpointID}',
    ...options,
  });

/**
 * Inspect per-namespace Kubernetes authorizations for the current user
 *
 * Returns the per-namespace authorization map for the current user
 * on the given Kubernetes environment. Empty for admins, for
 * non-Kubernetes environments, and when the user has cluster-wide
 * namespace access.
 * **Access policy**: authenticated
 */
export const currentUserEndpointNamespaceAuthorizationsInspect = <
  ThrowOnError extends boolean = true,
>(
  options: Options<
    CurrentUserEndpointNamespaceAuthorizationsInspectData,
    ThrowOnError
  >
): RequestResult<
  CurrentUserEndpointNamespaceAuthorizationsInspectResponses,
  CurrentUserEndpointNamespaceAuthorizationsInspectErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CurrentUserEndpointNamespaceAuthorizationsInspectResponses,
    CurrentUserEndpointNamespaceAuthorizationsInspectErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zCurrentUserEndpointNamespaceAuthorizationsInspectPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zCurrentUserEndpointNamespaceAuthorizationsInspectResponse.parseAsync(
        data
      ),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/users/me/auth/{endpointID}/namespaces',
    ...options,
  });

/**
 * List webhooks
 *
 * **Access policy**: authenticated
 */
export const webhookList = <ThrowOnError extends boolean = true>(
  options?: Options<WebhookListData, ThrowOnError>
): RequestResult<WebhookListResponses, WebhookListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    WebhookListResponses,
    WebhookListErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zWebhookListQuery.optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zWebhookListResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/webhooks',
    ...options,
  });

/**
 * Create a webhook
 *
 * **Access policy**: authenticated
 */
export const webhookCreate = <ThrowOnError extends boolean = true>(
  options: Options<WebhookCreateData, ThrowOnError>
): RequestResult<WebhookCreateResponses, WebhookCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    WebhookCreateResponses,
    WebhookCreateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zWebhookCreateBody,
          path: z.never().optional(),
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zWebhookCreateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/webhooks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a webhook
 *
 * **Access policy**: authenticated
 */
export const webhookDelete = <ThrowOnError extends boolean = true>(
  options: Options<WebhookDeleteData, ThrowOnError>
): RequestResult<WebhookDeleteResponses, WebhookDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    WebhookDeleteResponses,
    WebhookDeleteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zWebhookDeletePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/webhooks/{id}',
    ...options,
  });

/**
 * Execute a webhook
 *
 * Acts on a passed in token UUID to restart the docker service
 * **Access policy**: public
 */
export const webhookExecute = <ThrowOnError extends boolean = true>(
  options: Options<WebhookExecuteData, ThrowOnError>
): RequestResult<WebhookExecuteResponses, WebhookExecuteErrors, ThrowOnError> =>
  (options.client ?? client).post<
    WebhookExecuteResponses,
    WebhookExecuteErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: zWebhookExecutePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    url: '/webhooks/{id}',
    ...options,
  });

/**
 * Update a webhook
 *
 * **Access policy**: authenticated
 */
export const webhookUpdate = <ThrowOnError extends boolean = true>(
  options: Options<WebhookUpdateData, ThrowOnError>
): RequestResult<WebhookUpdateResponses, WebhookUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    WebhookUpdateResponses,
    WebhookUpdateErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zWebhookUpdateBody,
          path: zWebhookUpdatePath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zWebhookUpdateResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/webhooks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reassign a webhook to another resource
 *
 * **Access policy**: authenticated
 */
export const webhookReassign = <ThrowOnError extends boolean = true>(
  options: Options<WebhookReassignData, ThrowOnError>
): RequestResult<
  WebhookReassignResponses,
  WebhookReassignErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    WebhookReassignResponses,
    WebhookReassignErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: zWebhookReassignBody,
          path: zWebhookReassignPath,
          query: z.never().optional(),
        })
        .parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) =>
      await zWebhookReassignResponse.parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/webhooks/{id}/reassign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Attach a websocket
 *
 * If the nodeName query parameter is present, the request will be proxied to the underlying agent environment(endpoint).
 * If the nodeName query parameter is not specified, the request will be upgraded to the websocket protocol and
 * an AttachStart operation HTTP request will be created and hijacked.
 * **Access policy**: authenticated
 */
export const websocketAttach = <ThrowOnError extends boolean = true>(
  options: Options<WebsocketAttachData, ThrowOnError>
): RequestResult<
  WebsocketAttachResponses,
  WebsocketAttachErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WebsocketAttachResponses,
    WebsocketAttachErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zWebsocketAttachQuery,
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/websocket/attach',
    ...options,
  });

/**
 * Execute a websocket
 *
 * If the nodeName query parameter is present, the request will be proxied to the underlying agent environment(endpoint).
 * If the nodeName query parameter is not specified, the request will be upgraded to the websocket protocol and
 * an ExecStart operation HTTP request will be created and hijacked.
 */
export const websocketExec = <ThrowOnError extends boolean = true>(
  options: Options<WebsocketExecData, ThrowOnError>
): RequestResult<WebsocketExecResponses, WebsocketExecErrors, ThrowOnError> =>
  (options.client ?? client).get<
    WebsocketExecResponses,
    WebsocketExecErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zWebsocketExecQuery,
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/websocket/exec',
    ...options,
  });

/**
 * Execute a websocket on kubectl shell pod
 *
 * The request will be upgraded to the websocket protocol. The request will proxy input from the client to the pod via long-lived websocket connection.
 * **Access policy**: authenticated
 */
export const websocketKubernetesShell = <ThrowOnError extends boolean = true>(
  options: Options<WebsocketKubernetesShellData, ThrowOnError>
): RequestResult<
  WebsocketKubernetesShellResponses,
  WebsocketKubernetesShellErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WebsocketKubernetesShellResponses,
    WebsocketKubernetesShellErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zWebsocketKubernetesShellQuery,
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/websocket/kubernetes-shell',
    ...options,
  });

/**
 * Execute a websocket on a node shell pod
 *
 * Creates a privileged pod pinned to the requested Kubernetes node that
 * uses nsenter to expose a shell with access to the node's host namespaces.
 * The HTTP request is upgraded to a websocket and proxies stdin/stdout to the pod.
 * **Access policy**: admin
 */
export const websocketNodeShellExec = <ThrowOnError extends boolean = true>(
  options: Options<WebsocketNodeShellExecData, ThrowOnError>
): RequestResult<
  WebsocketNodeShellExecResponses,
  WebsocketNodeShellExecErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WebsocketNodeShellExecResponses,
    WebsocketNodeShellExecErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zWebsocketNodeShellExecQuery,
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/websocket/node-shell',
    ...options,
  });

/**
 * Execute a websocket on pod
 *
 * The request will be upgraded to the websocket protocol.
 * **Access policy**: authenticated
 */
export const websocketPodExec = <ThrowOnError extends boolean = true>(
  options: Options<WebsocketPodExecData, ThrowOnError>
): RequestResult<
  WebsocketPodExecResponses,
  WebsocketPodExecErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WebsocketPodExecResponses,
    WebsocketPodExecErrors,
    ThrowOnError
  >({
    requestValidator: async (data) =>
      await z
        .object({
          body: z.never().optional(),
          path: z.never().optional(),
          query: zWebsocketPodExecQuery,
        })
        .parseAsync(data),
    security: [
      { name: 'X-API-KEY', type: 'apiKey' },
      { name: 'Authorization', type: 'apiKey' },
    ],
    url: '/websocket/pod',
    ...options,
  });
